import _regeneratorRuntime from "/data/maven/.jenkins/workspace/web/web/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { checkOCisBlock, queryAuditProcessList, imageUploads_fun, imageUploads_del, premiumCalculation_fun, autoMatchKindInfo_fun, getPath_biaodi, excleCargoDownload_biaodi, proposalInsertInit, saveOrSubmit, findInsuranceCompany, queryAll, codeTypeList, proposalQueryDto, proposalQueryByCopy, queryCountry, findInsuredByConditions, clausequeryAll, queryEditEngage, queryRemarkEngage, proposalCallWriteBack_fun, proposalCallBack_fun, policyfromcheck_fun, transport_money, shipInformation_chuan, markof_type, newShipInformation } from '@/api/policymanagement';
import { isEmpty, deepcopy, checkPhone, validateEmail, accMul, accAdd, cleanArray, checkCompensate, num3_type_fun, num4_type_fun, num5_type_fun, toThousands, num2_type, _type_fun, unique, integer_type_fun } from "../../libs/common";
import { // getDisabledData,
getChilComList, getProductList, getCompanyList, getKindInfoList, getClauseList, getClauseListByType //getProtocolItemList,
, queryliPeiData, getBaseDateList, getProvinceCityArea, getBaseCodeByCodeType } from '@/api/baseDate';
import { getCountryList, getCityList, getUnderCity, getCHNCity } from '@/utils/country';
import { saveNewClause } from '@/api/policymanagement';
import currencyInput from '@/components/v-currencyInput/CurrencyInput'; //	var $ = require("../../libs/jquery");

import $ from 'jquery';
import XLSX from 'xlsx';
import axios from 'axios';
import typescript from 'highlight.js/lib/languages/typescript';
import List_obj from "../protocol/list_obj";
export default {
  name: "insuranceentry",
  components: {
    currencyInput: currencyInput
  },
  data: function data() {
    var checkAge = function checkAge(rule, value, callback) {
      var regu = /^(\-\d+)?$/;
      var ragu = /^([1-9]\d*|0)(\.\d{1,2})?$/;

      if (regu.test(value) == true) {
        return callback(new Error('请输入正数'));
      } else if (ragu.test(value) == false) {
        //return callback(new Error('请输入两位小数'))
        return callback();
      } else {
        return callback();
      }
    };

    var checkBge = function checkBge(rule, value, callback) {
      var regu = /^(\-\d+)?$/;
      var ragu = /^([1-9]\d*|0)(\.\d{1,2})?$/;
      var resg = /^\d+$|^\d*\.\d+$/g;

      if (!value) {
        return callback(new Error('请输入数量'));
      } else if (regu.test(value) == true) {
        return callback(new Error('请输入正数'));
      } else if (ragu.test(value) == false) {
        //return callback(new Error('请输入两位小数'))
        return callback();
      } else {
        return callback();
      }
    };

    var checkCge = function checkCge(rule, value, callback) {
      var regu = /^(\-\d+)?$/;
      var ragu = /^([1-9]\d*|0)(\.\d{1,2})?$/;

      if (!value) {
        return callback(new Error('请输入总价'));
      } else if (regu.test(value) == true) {
        return callback(new Error('请输入正数'));
      } else if (ragu.test(value) == false) {
        //return callback(new Error('请输入两位小数'))
        return callback();
      } else {
        return callback();
      }
    };

    return {
      invoiceCollectedFlag: false,
      areaProps: {
        // 省市区三级联动
        label: 'codeCname',
        value: 'codeCode'
      },
      forbidFastClickFlag: false,
      insuranceCompanyCode: '',
      proposalNO: '',
      queryType: '',
      //查询类型：被保险人/货运险注册用户
      isRegisterFlag: true,
      //是否是货运险注册用户添加：被保险人/货运险注册用户
      inVoIcNo: '',
      inVoIcCurrency: '',
      proposalStatus: '',
      ladIngNo: '',
      inVoIcAmount: '',
      componentList: [],
      // 单位性质
      innerList: [],
      // 境内外标识
      areaListArr: [],
      //省市区
      //1.申请电子保单同步方法是否返回结果 0没有返回过 1 返回过
      doPolicy1: 0,
      //2.申请电子保单轮询方法是否返回结果 0没有返回过 1 返回过
      doPolicy2: 0,
      //3.计时---毫秒数
      doPolicyCount: 0,
      //4.定时器
      new_address_list: '',
      dataChange: '',
      payAgent: {
        selectedAgent: '',
        agentName: '',
        // 代理点名称
        email: '',
        // 邮箱
        telephoneNumber: '',
        // 电话
        facsimileNumber: '' // 传真

      },
      agencybankrule: {
        selectedAgent: [{
          type: 'array',
          required: true,
          message: '请选择理赔代理点',
          trigger: 'change'
        }],
        agentName: [{
          required: true,
          message: '请输入代理点姓名',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: '请输入邮箱',
          trigger: 'blur'
        }],
        telephoneNumber: [{
          required: true,
          message: '请输入电话',
          trigger: 'blur'
        }],
        facsimileNumber: [{
          required: true,
          message: '请输入传真',
          trigger: 'blur'
        }]
      },
      agencyPrintrule: {
        originalAmount: [{
          required: true,
          message: '请选择正本数量',
          trigger: 'change'
        }],
        copyAmount: [{
          required: true,
          message: '请选择副本数量',
          trigger: 'change'
        }]
      },
      agentShow: false,
      agentPrintShow: false,
      agentPrintTitle: '',
      agentPrint: {
        originalAmount: '3',
        copyAmount: '0'
      },
      quantitylList: [{
        label: '0',
        value: '0'
      }, {
        label: '1',
        value: '1'
      }, {
        label: '2',
        value: '2'
      }, {
        label: '3',
        value: '3'
      }, {
        label: '4',
        value: '4'
      }],
      loing_box: true,
      path: process.env.BASE_URL,
      decimalValue: 2,
      decimalValue2: 2,
      decimalValue3: 3,
      decimalValue6: 6,
      updatemb: false,
      box_hwqd: false,
      box_8: false,
      top_but: false,
      box_9: false,
      box_10: false,
      box_11: false,
      applicationNo: "",
      nuclearfailure: "",
      since: false,
      cigreen: true,
      //cigary: false,
      customtarget: false,
      customtarget2: false,
      box_8_cont: [],
      total_bel: 0,
      dialogFormVisible_obj: {
        insuredName: '',
        identifyNumber: ''
      },
      clauseCode_option: [{
        value: '1',
        label: '主险'
      }, {
        value: '2',
        label: '附加险'
      }],
      clauseTypeCode_option: [],
      dutyCode_option: [],
      proposalNo: '',
      whole_flag: false,
      whole_flag_but: true,
      whole_flag_but_view: true,
      whole_flag_bx: true,
      // 运输信息
      whole_flagys: false,
      whole_flagmy: false,
      whole_flagdate: false,
      whole_flagyf1: false,
      whole_flagyf2: false,
      otherTaxFeesFlag: false,
      // 货物信息
      whole_flagbz: false,
      whole_flaglc: false,
      whole_flagjz: false,
      whole_flagbg: false,
      whole_flagtd: false,
      whole_flagfp: false,
      whole_flagst: false,
      whole_flagfpbb: false,
      whole_flagbabb: false,
      whole_flagbfbb: false,
      //操作记录
      auditProcessList: [],
      isViewProcess: false,
      whole_carflag: false,
      whole_benflag: false,
      options_insuranceCompanyName: [],
      options_companyName: [],
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      fileList_exlc: [],
      value1: '',
      label_s1: '',
      label_s2: '',
      radio1: null,
      radio2: null,
      activeName: '6',
      is_goods: false,
      inForm: {
        input1: '',
        name: '',
        tions: ''
      },
      options: [{
        value: '01',
        label: '身份证'
      }],
      options_old: [{
        value: '1',
        label: '新'
      }, {
        value: '2',
        label: '旧'
      }],
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      tableData_transport: [{
        voyageNumber: '',
        startSiteCountryCode: "",
        startSiteCountryName: '',
        startSiteCityCode: '',
        startSiteCityName: '',
        endSiteCountryCode: '',
        endSiteCountryName: '',
        endSiteCityCode: '',
        endSiteCityName: '',
        blName: '',
        voyageNo: '',
        shipClassCode: '',
        shipClassName: '',
        shipTypesCode: '',
        shipTypes: '',
        vessel: ''
      }],
      tableData: [],
      tableData_hw: [],
      tableData_ship: [],
      tableData_matter: [],
      ProposalLimitDtoList: [],
      option_transport: [{
        value: '01',
        label: "船舶"
      }, {
        value: '02',
        label: "飞机"
      }, {
        value: '03',
        label: "火车"
      }, {
        value: '04',
        label: "汽车"
      }],
      option_deal: [],
      option_Meanstransport: [],
      option_Freightcurrency: [],
      option_packing: [],
      option_currency: [{
        value: '1',
        label: "RMB"
      }, {
        value: '2',
        label: "USD"
      }, {
        value: '3',
        label: "EUR"
      }],
      isAgrB: false,
      showFlag: false,
      shipFlag: false,
      ProposalMainDto: {
        agreementEndDate: "",
        agreementStartDate: "",
        companyCode: "",
        companyName: "",
        insuranceCompanyCode: "",
        insuranceCompanyName: "",
        proposalNo: "",
        protocolNo: "",
        policyNo: "",
        riskCode: "",
        riskName: "",
        sumAmount: "",
        sumPremium: "",
        coreBackSumPremium: "",
        limitMiniPremium: "",
        //限额最低保费
        isAgreementBalance: "",
        //是否协议结算
        shipInvokeFlag: '0' //页面是否调用船舶接口flag  默认为 0

      },
      ProposalApplicantDto: {
        applicantName: "",
        identifyNumber: "",
        identifyType: "",
        identifyTypeName: "",
        linkmanAddress: "",
        linkmanEmail: "",
        linkmanName: "",
        linkmanPhone: "",
        registeredAddress: "",
        unitNature: "",
        unitNatureName: "",
        nationalFlagName: "",
        nationalFlag: "",
        insuredProvince: '',
        provinceList: [],
        provinceCode: "",
        cityCode: "",
        areaCode: "",
        provinceName: "",
        cityName: "",
        areaName: ""
      },
      ProposalInsuredDto: {
        address: "",
        email: "",
        identifyNumber: "",
        identifyType: "",
        identifyTypeName: "",
        insuredEnName: "",
        insuredName: "",
        insuredCode: "",
        phone: "",
        serialNo: "1",
        unitNature: "",
        unitNatureName: "",
        nationalFlagName: "",
        nationalFlag: "",
        insuredProvince: '',
        provinceList: [],
        provinceCode: "",
        cityCode: "",
        areaCode: "",
        provinceName: "",
        cityName: "",
        areaName: ""
      },
      ProposalConveyanceDto: {
        voyage: '',
        classSocietyNameCn: '',
        classSociety: '',
        vesselSubTypeNameCn: '',
        vesselSubType: '',
        vesselAge: '',
        conveyanceWayCode: '',
        conveyanceWayName: '',
        clinchWayCode: '',
        clinchWayName: '',
        freight: '',
        freightCurrency: '',
        freightCurrencyName: '',
        startTime: '',
        proposalConveyanceListDtoList: []
      },
      ProposalItemDto: {
        customslistNo: "",
        invoicAmount: "0",
        invoicCurrency: "",
        invoicCurrencyCode: "",
        isContainer: "",
        isRefrigeRate: "",
        invoicNo: "",
        ladingNO: "",
        marks: "",
        isStorage: "0",
        storageStartTime: "",
        storageEndTime: "",
        storagePeriod: "",
        packingWay: "",
        packingWayCode: "",
        reportName: "",
        reportCode: "",
        proposalItemCargoDtoList: [],
        proposalItemCargoDtoTempList: [],
        remark: "1",
        nationType: '',
        countryEName: '',
        countryName: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        areaCode: '',
        areaName: '',
        roadName: '',
        houseNumber: '',
        otherInfo: '',
        detailAddress: ''
      },
      ProposalKindDto: {
        amountCurrency: "",
        amountCurrencyCode: "",
        remiumCurrency: "",
        remiumCurrencyCode: "",
        exchangeRate: "",
        plusRate: "",
        sumPremium: "",
        sunAmount: "",
        limitMiniPremium: "",
        //限额最低保费
        coreBackSumPremium: "",
        //核心返回总保费
        proposalItemKindDtoList: []
      },
      ProposalInvoiceDto: {
        invoiceEmail: "",
        isThirdPartyPayment: "1",
        // 是否第三方支付 是1/否0；默认为：是
        actualPayer: '',
        invoiceHeader: "",
        taxpayerIdentityType: ""
      },
      ProposalEngageDtoList: [],
      ProposalEngageDto_obj: {
        engageCode: '',
        engageName: '',
        engageContent: '',
        serialNo: 1,
        updateFlag: 0
      },
      ProposalEngageDto_obj_rules: {
        engageCode: [{
          required: true,
          message: '请填写特约代码',
          trigger: 'change'
        }],
        engageName: [{
          required: true,
          message: '请填写特约名称',
          trigger: 'change'
        }],
        engageContent: [{
          required: true,
          message: '请填写特约内容',
          trigger: 'change'
        }]
      },
      ProposalItemKindDto_obj: {
        amount: "",
        clauseType: "",
        clauseTypeCode: "",
        itemKindNo: "",
        kindCode: "",
        kindName: "",
        premium: "",
        remark: "",
        riskCode: "",
        riskName: ""
      },
      proposalItemCargoDto_obj: {
        itemType: '',
        itemTypeName: '',
        cargoName: '',
        cargoEnName: '',
        quantity: '',
        isNewOrOld: '',
        unit: '',
        unitName: '',
        unitAmount: '0.00',
        totalAmount: '0.00',
        cargoCode: '',
        cargoCodeName: '',
        vehicleModel: '',
        chassisNumber: '',
        engineNumber: '',
        vehiclePrice: ''
      },
      proposalItemCargoDto_obj_rules: {
        itemType: [{
          required: true,
          message: '请选择标的类型',
          trigger: 'change'
        }],
        quantity: [{
          required: true,
          trigger: 'blur',
          validator: checkBge
        }],
        isNewOrOld: [{
          required: true,
          message: '请选择货物新旧标识',
          trigger: 'change'
        }],
        unit: [{
          required: true,
          message: '请选择单位',
          trigger: 'change'
        }],
        unitAmount: [{
          required: false,
          trigger: 'blur',
          validator: checkAge
        }],
        totalAmount: [{
          required: true,
          // message: '请输入总价',
          trigger: 'blur',
          //当失去焦点就进行一次验证
          validator: checkCge //当失去焦点，会使validator验证,会调用一次checkAge函数。并且会给checkAge默认传参数，checkAge(rules,value,callback){}，value是input框中的内容，callback是回调函数。这3个参数是关键，必须要传给vuex store中的验证函数。

        }],
        vehicleModel: [{
          required: true,
          message: '请输入车辆型号',
          trigger: 'change'
        }],
        chassisNumber: [{
          required: true,
          message: '请输入底盘号',
          trigger: 'change'
        }],
        engineNumber: [{
          required: true,
          message: '请输入发动机号',
          trigger: 'change'
        }],
        vehiclePrice: [{
          required: true,
          message: '请输入车辆价格',
          trigger: 'change',
          validator: checkBge
        }]
      },
      disabled_6: true,
      box_6: false,
      index_6: '',
      box_6edit: false,
      box_7: false,
      box_7_flag: "",
      index_7: '',
      box_7_img: true,
      isView: false,
      itemDisabled: false,
      isDisabled: false,
      imguploaderbtn: true,
      text1: {
        proposalNo: '',
        protocolNo: '',
        dates: '',
        insuranceCompanyName: '',
        companyName: ''
      },
      text2: {
        applicantName: '',
        registeredAddress: '',
        linkmanName: '',
        identifyType: '',
        identifyTypeName: '',
        identifyNumber: '',
        linkmanPhone: '',
        linkmanAddress: '',
        linkmanEmail: '',
        unitNature: "",
        unitNatureName: "",
        nationalFlagName: "",
        nationalFlag: "",
        insuredProvince: '',
        provinceList: [],
        provinceCode: "",
        cityCode: "",
        areaCode: "",
        provinceName: "",
        cityName: "",
        areaName: ""
      },
      text3: {
        insuredName: '',
        insuredEnName: '',
        identifyType: '',
        identifyNumber: '',
        address: '',
        email: '',
        phone: '',
        unitNature: "",
        unitNatureName: "",
        nationalFlagName: "",
        nationalFlag: "",
        insuredProvince: '',
        provinceList: [],
        provinceCode: "",
        cityCode: "",
        areaCode: "",
        provinceName: "",
        cityName: "",
        areaName: ""
      },
      text4: {
        conveyanceWayCode: '',
        clinchWayCode: '',
        conveyanceCode: '',
        freightCurrency: '',
        blName: '',
        voyageNo: '',
        startTime: '',
        startSiteCountryCode: '',
        viaSiteCountryCode: '',
        endSiteCountryCode: '',
        checkAgentCode: '',
        vessel: '',
        shipClassCode: '',
        shipTypesCode: '',
        freight: ''
      },
      text5: {
        packingWayCode: '',
        containerType: '',
        isRefrigeRate: '',
        isContainer: '',
        isNewOrOld: '',
        ladingNO: '',
        invoicNo: '',
        marks: '',
        invoicAmount: '',
        invoicCurrencyCode: '',
        customslistNo: '',
        reportName: ''
      },
      text6: {
        amountCurrencyCode: '',
        remiumCurrencyCode: '',
        exchangeRate: '',
        plusRate: ''
      },
      text7: {
        invoiceEmail: '',
        isThirdPartyPayment: '',
        actualPayer: '',
        invoiceHeader: '',
        taxpayerIdentityType: ''
      },
      pageNo: 1,
      pageSize: 1,
      fromdata: false,
      matter_flag: '',
      matter_index: '',
      box_7_disabled: false,
      box_8_disabled: false,
      storageFlag: false,
      select_radio_s_obj: {},
      conveyance_option: [],
      tradeTerms_option: [],
      currency_option: [],
      reportName_option: [],
      storage_option: [{
        value: "1",
        label: "是"
      }, {
        value: "0",
        label: "否"
      }],
      becurrency_option: [],
      shipClass_option: [],
      shipTypes_option: [],
      vesselType_option: [],
      taxpayerIdentity_option: [{
        value: "1",
        label: "增值税一般纳税人"
      }, {
        value: "2",
        label: "增值税小额纳税人"
      }],
      thirdParty_option: [{
        value: "1",
        label: "是"
      }, {
        value: "0",
        label: "否"
      }],
      checkLadingNO: '',
      checkInvoicNo: '',
      checkInvoicCurrencyCode: '',
      checkInvoicAmount: '',
      isCheckLadingNO: false,
      isCheckInvoicNo: false,
      isCheckInvoicCurrencyCode: false,
      isCheckInvoicAmount: false,
      country_option: [{
        value: "01",
        label: "中国"
      }],
      city_option: [{
        value: "03",
        label: "上海"
      }],
      packType_option: [],
      packTypes_option: [{
        value: "",
        label: "请选择"
      }, {
        value: "0",
        label: "否"
      }, {
        value: "1",
        label: "是"
      }],
      cargoCode_option: [{
        value: "0",
        label: "HScode1"
      }],
      idCard_option: [],
      content: {},
      ship_index: '',

      /*ty_engageName: '',
      ty_engageCode: '',*/
      ty_engageCode_option: [],
      measuringUnit_option: [],
      isneworold_option: [],
      itemType_option: [],
      itemType_option2: [],
      conveyanceWayCode_3_proposalConveyanceListDtoList: "",
      insured_pageNo: 1,
      insured_pageSize: 10,
      whole_flag_s: true,
      //被保险人基础信息
      whole_flag_subAssuredOInfo: true,
      //被保险人其他信息
      isRepetition_s: false,
      isSubmit_s: false,
      // ture  -- 可计算     false -- 不可计算
      isSubmit_cont: false,
      // ture  -- 可提交     false -- 不可提交，
      Temporary_but_flg: true,
      cont_proposalNo: '',
      countryAll: [],
      //起运地全部国家
      countryIndex: 1,
      //起运地国家下拉框当前页
      countryCount: 0,
      //起运地国家下拉总条数
      operateType: '',
      carShowFlag: false,
      buttonShowFlag: true,
      viewShowFlag: false,
      nation: List_obj.nationalType,
      codeFlag: true,
      nationFlag: false,
      countryList: [],
      countryAllList: [],
      provinceList: [],
      chinaList: [],
      cityList: [],
      areaList: [],
      allAddressData: [],
      addressFlag: false,
      text8: {
        nationPrompt: '',
        countryPrompt: '',
        provincePrompt: '',
        cityPrompt: '',
        areaPrompt: '',
        roadNamePrompt: '',
        detailAddressPrompt: ''
      },
      showAddressFlag: false,
      riskCode: '',
      insuredNameCheck: []
    };
  },
  watch: {
    ProposalConveyanceDto: {
      //运输信息
      handler: function handler(newValue, oldValue) {
        this.isSubmit_s = false;
        this.isSubmit_cont = false;
      },
      deep: true
    },
    ProposalItemDto: {
      handler: function handler(newValue, oldValue) {
        //标的信息
        this.isSubmit_s = false;
        this.isSubmit_cont = false;
      },
      deep: true
    },
    'ProposalKindDto.amountCurrencyCode': {
      //保额
      handler: function handler(newValue, oldValue) {
        this.isSubmit_s = false;
        this.isSubmit_cont = false;
      },
      deep: true
    },
    'ProposalKindDto.remiumCurrencyCode': {
      handler: function handler(newValue, oldValue) {
        //保费
        this.isSubmit_s = false;
        this.isSubmit_cont = false;
      },
      deep: true
    } // 'ProposalKindDto.plusRate': {
    // 	handler: function(newValue, oldValue) { //加成比例
    // 		this.isSubmit_s = true
    // 		this.isSubmit_cont = false
    // 	},
    // 	deep: true
    // }

  },
  created: function created() {
    var _this = this;

    this.getInsuredNameCheck();
    console.log("页面insurance-entry.vue");
    var data = this.$route.params; //  view -- 查看             modify -- 修改

    this.riskCode = data.riskCode;
    this.queryType = data.queryType;
    this.createBy = data.createBy;

    if (data.type == "view") {
      this.whole_flag = true;
      this.whole_flagtrue();
      this.whole_flag_s = true;
      this.whole_flag_subAssuredOInfo = true;
      this.whole_flag_but = false;
      this.whole_flag_bx = false;
      this.isView = true;
      this.imguploaderbtn = false;
      this.whole_benflag = false;
      this.Init_get2(data.proposalNo, "view"); //this.bonusproportion()

      this.moneytransport(); //投保人 联系人电话脱敏

      if (this.ProposalApplicantDto.linkmanPhone != null && this.ProposalApplicantDto.linkmanPhone != '') {
        this.ProposalApplicantDto.linkmanPhone = this.setPhone(this.ProposalApplicantDto.linkmanPhone);
      }

      if (this.ProposalInsuredDto.phone != null && this.ProposalInsuredDto.phone != '') {
        //被保险人 联系人电话脱敏
        this.ProposalInsuredDto.phone = this.setListPhone(this.ProposalInsuredDto.phone);
      }

      if (this.ProposalApplicantDto.email != null && this.ProposalApplicantDto.email != '') {
        //投保人 邮箱地址脱敏
        this.ProposalApplicantDto.email = this.setApplicationEmailTou(this.ProposalApplicantDto.email);
      }

      if (this.ProposalInsuredDto.email != null && this.ProposalInsuredDto.email != '') {
        //被保人 邮箱地址脱敏
        this.ProposalInsuredDto.email = this.setApplicationEmailTou(this.ProposalInsuredDto.email);
      }
    } else if (data.type == "modify" || data.type == "collection") {
      this.whole_flag = false;
      this.whole_flagfalse();
      this.whole_flag_but = true;
      this.whole_flag_bx = true; //this.bonusproportion()//YCKK-946 手工报关单投保，加成比例有值不显示//YCKK-1080

      this.Init_get2(data.proposalNo, "modify");
      this.moneytransport();
    } else if (data.type == "add") {
      this.whole_flag = false;
      this.whole_flagfalse();
      this.whole_flag_but = true;
      this.whole_flag_bx = true; //				console.log(data)

      this.Init_get(data.protocolNo, data.riskCode, data.riskName); //this.bonusproportion()

      this.moneytransport();
      this.add_transport();
    } else if (data.type == "opcopy") {
      this.whole_flag = false;
      this.whole_flagfalse();
      this.whole_flag_but = true;
      this.whole_flag_bx = true;
      this.whole_flag_bx = true;
      this.Init_get3(data.proposalNo); //this.bonusproportion()

      this.moneytransport();
      /*}else if(data.type == "collection"){
      	this.whole_flag_s = true
      	this.whole_flag = false
      	this.whole_flag_but = true
      	this.whole_flag_bx = false
      	this.Init_get4(data.proposalNo)
      	this.bonusproportion()
      	this.moneytransport()*/
    } //			this.clausequeryAll_fun(data.insurancecompanyCode, data.riskCode) //主副险责任 --- 条款名称 、条款类型
    //
    //			this.getKindInfoList_fun(data.insurancecompanyCode, data.riskCode) //主副险责任 --- 责任名称


    this.getEngageList_fun(data.insurancecompanyCode, data.protocolNo, data.riskCode); //特约信息查询

    this.getAreaList();
    var Info = {
      codeLever: '1',
      codeType: ["unitNature", "nationalFlag"]
    };
    getBaseDateList(Info).then(function (res) {
      res.forEach(function (item) {
        if (item.codeType === 'unitNature') {
          _this.componentList = item.dictionary; // 单位性质

          console.log('单位性质', _this.componentList);
        } else if (item.codeType === 'nationalFlag') {
          _this.innerList = item.dictionary; // 境内外标识

          console.log('境内外标识', _this.innerList);
        }
      });
    });
  },
  mounted: function mounted() {
    this.proposalNo = this.$router.history.current.params.proposalNo;
    console.log('params==', this.proposalNo);
    var companyCode = this.$store.state.user.userinfo.insuranceCompanyCode || "";
    var data = this.$route.params;
    this.operateType = data.type;
    this.select_data(companyCode); // this.getList()

    this.getProvinceCityData1();
  },
  methods: {
    formatDateRange: function formatDateRange() {
      // 协议生效日期省去时分秒
      var formatter = new Intl.DateTimeFormat('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });

      if (this.ProposalMainDto.agreementStartDate != undefined && this.ProposalMainDto.agreementStartDate != null) {
        this.ProposalMainDto.agreementStartDate = formatter.format(new Date(this.ProposalMainDto.agreementStartDate)).replace(/\//g, '-');
      }

      if (this.ProposalMainDto.agreementEndDate != undefined && this.ProposalMainDto.agreementEndDate != null) {
        this.ProposalMainDto.agreementEndDate = formatter.format(new Date(this.ProposalMainDto.agreementEndDate)).replace(/\//g, '-');
      }
    },
    getInsuredNameCheck: function getInsuredNameCheck() {
      var _this2 = this;

      var params = {
        'codeType': 'insuredName'
      };
      getBaseCodeByCodeType(params).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.label = res[i].codeCode;
          obj.value = res[i].codeCname;

          _this2.insuredNameCheck.push(obj);
        }
      });
    },
    setPhone: function setPhone(tel) {
      if (tel.indexOf("-") != -1) {
        tel = " " + tel;
        var str = " ";
        str = tel.substring(0, 3) + "****" + tel.substring(9);
        return str;
      } else {
        var phone = this.ProposalApplicantDto.linkmanPhone; //获取到投保人的电话信息

        phone = "" + phone;
        var reg = /(\d{3})\d{4}(\d{4})/; //正则表达式

        var phone = phone.replace(reg, "$1****$2");
        this.ProposalApplicantDto.linkmanPhone = phone;
        return phone;
      }
    },
    setListPhone: function setListPhone(tel) {
      if (tel.indexOf("-") != -1) {
        tel = " " + tel;
        var str = " ";
        str = tel.substring(0, 3) + "****" + tel.substring(9);
        return str;
      } else {
        var phone = this.ProposalInsuredDto.phone; //获取到被保人的电话信息

        phone = "" + phone;
        var reg = /(\d{3})\d{4}(\d{4})/; //正则表达式

        var phone = phone.replace(reg, "$1****$2");
        this.ProposalInsuredDto.phone = phone;
        return phone;
      }
    },
    setApplicationEmailTou: function setApplicationEmailTou(email) {
      //投保人 邮箱
      //2022-01-11 判断如果邮箱是多个的话需要特殊处理
      var emailArr = [];

      if (email.search(",") != -1) {
        emailArr = email.split(",");
        var new_email = '';

        for (var j = 0; j < emailArr.length; j++) {
          if (String(emailArr[j]).indexOf('@') > 0) {
            var str = emailArr[j].split('@');
            var _s = '';

            if (str[0].length > 3) {
              //@前面多于3位
              for (var i = 3; i < str[0].length; i++) {
                _s += '*';
              }

              if (new_email != '') {
                new_email = new_email + ',' + str[0].substr(0, 3) + _s + '@' + str[1];
              } else {
                new_email = str[0].substr(0, 3) + _s + '@' + str[1];
              }
            } else {
              //@前面小于等于于3位
              for (var _i = 1; _i < str[0].length; _i++) {
                _s += '*';
              }

              if (new_email != '') {
                new_email = new_email + ',' + str[0].substr(0, 1) + _s + '@' + str[1];
              } else {
                new_email = str[0].substr(0, 1) + _s + '@' + str[1];
              }
            }
          }
        }

        return new_email;
      } else {
        var _new_email = email;

        if (String(email).indexOf('@') > 0) {
          var _str = email.split('@');

          var _s2 = '';

          if (_str[0].length > 3) {
            //@前面多于3位
            for (var _i2 = 3; _i2 < _str[0].length; _i2++) {
              _s2 += '*';
            }

            _new_email = _str[0].substr(0, 3) + _s2 + '@' + _str[1];
          } else {
            //@前面小于等于于3位
            for (var _i3 = 1; _i3 < _str[0].length; _i3++) {
              _s2 += '*';
            }

            _new_email = _str[0].substr(0, 1) + _s2 + '@' + _str[1];
          }
        }

        return _new_email;
      }
    },
    // 选择省市区
    handleChange: function handleChange(value) {
      var _this3 = this;

      this.ProposalApplicantDto.provinceCode = value[0];
      this.ProposalApplicantDto.cityCode = value[1];
      this.ProposalApplicantDto.areaCode = value[2];
      this.areaListArr.forEach(function (item) {
        if (item.codeCode === value[0]) {
          _this3.ProposalApplicantDto.provinceName = item.codeCname;
          item.children.forEach(function (semp) {
            if (semp.codeCode === value[1]) {
              _this3.ProposalApplicantDto.cityName = semp.codeCname;
            }

            semp.children.forEach(function (temp) {
              if (temp.codeCode === value[2]) {
                _this3.ProposalApplicantDto.areaName = temp.codeCname;
              }
            });
          });
        }
      });
    },
    handleChangeInsured: function handleChangeInsured(value) {
      var _this4 = this;

      this.ProposalInsuredDto.provinceCode = value[0];
      this.ProposalInsuredDto.cityCode = value[1];
      this.ProposalInsuredDto.areaCode = value[2];
      this.areaListArr.forEach(function (item) {
        if (item.codeCode === value[0]) {
          _this4.ProposalInsuredDto.provinceName = item.codeCname;
          item.children.forEach(function (semp) {
            if (semp.codeCode === value[1]) {
              _this4.ProposalInsuredDto.cityName = semp.codeCname;
            }

            semp.children.forEach(function (temp) {
              if (temp.codeCode === value[2]) {
                _this4.ProposalInsuredDto.areaName = temp.codeCname;
              }
            });
          });
        }
      });
    },
    // 获取省市区
    getAreaList: function getAreaList() {
      var _this5 = this;

      getProvinceCityArea({}).then(function (res) {
        _this5.areaListArr = res;
      });
    },
    selectUnit: function selectUnit(value) {
      var _this6 = this;

      // 单位性质
      this.componentList.forEach(function (item) {
        if (item.codeCode === value) {
          _this6.ProposalApplicantDto.unitNatureName = item.codeCname;
        }
      });
    },
    selectUnits: function selectUnits(value) {
      var _this7 = this;

      this.componentList.forEach(function (item) {
        if (item.codeCode === value) {
          _this7.ProposalInsuredDto.unitNatureName = item.codeCname;
        }
      });
    },
    selectInner: function selectInner(value) {
      var _this8 = this;

      //境内外标识
      this.innerList.forEach(function (item) {
        if (item.codeCode === value) {
          _this8.ProposalApplicantDto.nationalFlagName = item.codeCname;
        }
      });
      this.identifyNumber_ch1_1();
    },
    selectInners: function selectInners(value) {
      var _this9 = this;

      this.innerList.forEach(function (item) {
        if (item.codeCode === value) {
          _this9.ProposalInsuredDto.nationalFlagName = item.codeCname;
        }
      }); // 清空身份类型和id的校验info，并且判断三者之间的关系

      this.insuredEnName_ch(this.ProposalInsuredDto.insuredEnName);
      this.identifyType_ch2(this.ProposalInsuredDto.identifyType);
      this.identifyNumber_ch2(this.ProposalInsuredDto.identifyNumber); // this.identifyNumber_ch2_2()
    },
    // 判断是否是--报关单 若是部分数据不可修改 并置灰
    // getList(){
    //   let proposalNo = {
    //     proposalNo:this.proposalNo
    //   }
    //   getDisabledData(proposalNo).then(res=>{
    //     console.log('res==',res)
    //   })
    // },
    goDetail: function goDetail(e) {
      this.getLeafKeys(e);
    },
    getLeafKeys: function getLeafKeys(e) {
      var _this10 = this;

      this.agentOptions.forEach(function (item) {
        item.children.forEach(function (itm) {
          itm.children.forEach(function (it) {
            if (it.children == [] || it.children == null) {
              if (it.address == e[2]) {
                _this10.newList = it;
              }
            } else {
              it.children.forEach(function (i) {
                if (i.address == e[3]) {
                  _this10.newList = i;
                }
              });
            }
          });
        });
      });
      this.payAgent.agentName = this.newList.agentName;
      this.payAgent.email = this.newList.email;
      this.payAgent.telephoneNumber = this.newList.telephoneNumber;
      this.payAgent.facsimileNumber = this.newList.facsimileNumber; //this.payAgent.selectedAgent = this.newList.address
    },
    getAddressData: function getAddressData(insurancecompanyCode) {
      var _this11 = this;

      var params = {
        'insuranceCompanyCode': insurancecompanyCode
      };
      queryliPeiData(params).then(function (res) {
        // console.log(res, '==res')
        _this11.agentOptions = res;
      });
    },
    cancelAgent: function cancelAgent(formName) {
      var _this12 = this;

      this.agentShow = false;
      this.$nextTick(function () {
        _this12.$refs[formName].clearValidate();
      }); // this.selectedAgent = ''
    },
    saveAgent: function saveAgent(formName) {
      var _this13 = this;

      this.agentShow = true;
      this.$refs[formName].validate(function (valid) {
        console.log(valid);

        if (valid) {
          _this13.agentShow = false;
          var len = _this13.payAgent.selectedAgent.length - 1;
          var agent = _this13.payAgent.selectedAgent[len];
          var reg = new RegExp(',', 'g'); //g代表全部

          _this13.payAgent.email = _this13.payAgent.email.replace(reg, '');
          _this13.new_address_list = JSON.parse(JSON.stringify(_this13.payAgent.agentName + '<br/>' + agent + '<br/>' + 'TEL:' + _this13.payAgent.telephoneNumber + '<br/>' + 'FAX:' + _this13.payAgent.facsimileNumber + '<br/>' + 'EMAIL:' + _this13.payAgent.email));

          if (_this13.new_address_list != null && _this13.new_address_list != '' && _this13.new_address_list != undefined) {
            _this13.get_data(2);
          }

          console.log(_this13.new_address_list, 'this.new_address_list');
        }
      });
    },
    // 可用输入框禁与否
    whole_flagtrue: function whole_flagtrue() {
      // 运输信息
      this.whole_flagys = true;
      this.whole_flagmy = true;
      this.whole_flagdate = true;
      this.whole_flagyf1 = true;
      this.whole_flagyf2 = true; // 货物信息

      this.whole_flagbz = true;
      this.whole_flaglc = true;
      this.whole_flagjz = true;
      this.whole_flagbg = true;
      this.whole_flagtd = true;
      this.whole_flagfp = true;
      this.whole_flagst = true;
      this.whole_flagfpbb = true;
      this.whole_flagbabb = true;
      this.whole_flagbfbb = true;
    },
    whole_flagfalse: function whole_flagfalse() {
      // 运输信息
      this.whole_flagys = false;
      this.whole_flagmy = false;
      this.whole_flagdate = false;
      this.whole_flagyf1 = false;
      this.whole_flagyf2 = false; // 货物信息

      this.whole_flagbz = false;
      this.whole_flaglc = false;
      this.whole_flagjz = false;
      this.whole_flagbg = false;
      this.whole_flagtd = false;
      this.whole_flagfp = false;
      this.whole_flagst = false;
      this.whole_flagfpbb = false;
      this.whole_flagbabb = false;
      this.whole_flagbfbb = false;
    },
    //新增-----初始化
    Init_get: function Init_get(protocolNo, riskCode, riskName) {
      var _this14 = this;

      this.box_7_img = false;
      var para = {
        protocolNo: protocolNo,
        riskCode: riskCode,
        riskName: riskName,
        type: '2',
        queryType: this.queryType
      };
      proposalInsertInit(para).then(function (res) {
        console.log('-------------新增---初始化-------------');
        console.log(res);
        _this14.insuranceCompanyCode = res.proposalMainDto.insuranceCompanyCode;
        _this14.itemType_option = res.protocolItemResDto.itemList;
        _this14.itemType_option2 = res.protocolItemResDto.customItemList;
        _this14.queryType = res.queryType; //当是被保险人登录时，只能看到自己一个被保险人，默认关闭---保险人登录时，只会走add流程

        if (_this14.queryType === "subAssured") {
          _this14.isRegisterFlag = false;
        } // 申报基准


        for (var i = 0; i < res.pageSelect.reportCodeList.length; i++) {
          var obj = {};
          obj.value = res.pageSelect.reportCodeList[i].codeCode;
          obj.label = res.pageSelect.reportCodeList[i].codeCname;

          _this14.reportName_option.push(obj);
        } // 加成比例


        if (res.pageSelect.insureUpperLimit == null || res.pageSelect.insureUpperLimit == "") {
          _this14.ProposalKindDto.plusRate = res.pageSelect.insureDefault;
          $(".carriagetwo").addClass("putash");
          _this14.whole_carflag = true;
        } // 是否收集发票信息


        if (res.pageSelect.isInvoiceCollected == '1') {
          _this14.invoiceCollectedFlag = true;
        } else {
          _this14.invoiceCollectedFlag = false;
        } // 是否默认投保仓储/展览


        if (res.pageSelect.isDefaultStorage === '1') {
          _this14.ProposalItemDto.isStorage = '1';
          _this14.storageFlag = true;
        } else {
          _this14.ProposalItemDto.isStorage = '0';
          _this14.storageFlag = false;
        } // -- 基本


        if (res.proposalMainDto != null) {
          _this14.ProposalMainDto = res.proposalMainDto;

          _this14.getAddressData(res.proposalMainDto.insuranceCompanyCode);

          _this14.formatDateRange();

          _this14.ProposalMainDto.dates = [_this14.ProposalMainDto.agreementStartDate, _this14.ProposalMainDto.agreementEndDate];

          if (res.proposalMainDto.isAgreementBalance == '1' && res.proposalMainDto.insuranceCompanyCode == 'IC0009') {
            _this14.isAgrB = true;
          }
        } // -- 投保人


        if (res.proposalApplicantDto != null) {
          _this14.ProposalApplicantDto = res.proposalApplicantDto;
          var newArrArea = [];
          newArrArea.push(res.proposalApplicantDto.provinceCode);
          newArrArea.push(res.proposalApplicantDto.cityCode);
          newArrArea.push(res.proposalApplicantDto.areaCode);
          _this14.ProposalApplicantDto.provinceList = newArrArea;
          console.log('this.ProposalApplicantDto.provinceList投保人省事', _this14.ProposalApplicantDto.provinceList);
        } // --被保险人


        if (res.proposalInsuredDto != null) {
          _this14.ProposalInsuredDto = res.proposalInsuredDto;
          var newArrAreaInsured = [];
          newArrAreaInsured.push(res.proposalInsuredDto.provinceCode);
          newArrAreaInsured.push(res.proposalInsuredDto.cityCode);
          newArrAreaInsured.push(res.proposalInsuredDto.areaCode);
          _this14.ProposalInsuredDto.provinceList = newArrAreaInsured; // ADD + 可修改 + 投保人进入 ：全放开
          // ADD + 可修改 + 被保人险进入 ：按照新需求放开
          // ADD + 不可修改 ：全禁用
          // 20240823
          // ADD + 可修改 + 投保人进入 ：全放开
          // ADD + 可修改 + 被保险人进入 ：名称+证件类型+证件号禁用+其余放开
          // ADD + 不可修改 + 投保人进入 ：全禁用
          // ADD + 不可修改 + 被保险人进入 ：名称+证件类型+证件号禁用+其余放开

          if (_this14.ProposalInsuredDto.isUpdateInsuredName === '1') {
            if (_this14.queryType === 'register') {
              _this14.whole_flag_s = false;
              _this14.whole_flag_subAssuredOInfo = false;
            } else {
              _this14.whole_flag_s = true;
              _this14.whole_flag_subAssuredOInfo = false;
            }
          } else {
            if (_this14.queryType === 'register') {
              _this14.whole_flag_s = true;
              _this14.whole_flag_subAssuredOInfo = true;
            } else {
              _this14.whole_flag_s = true;
              _this14.whole_flag_subAssuredOInfo = false;
            }
          }
        } // -- 特约


        if (res.proposalEngageDtoList != null) {
          _this14.ProposalEngageDtoList = res.proposalEngageDtoList;
        } // -- 限额免赔


        if (res.proposalLimitDtoList != null) {
          _this14.ProposalLimitDtoList = res.proposalLimitDtoList;

          for (var n = 0; n < _this14.ProposalLimitDtoList.length; n++) {
            if (null != _this14.ProposalLimitDtoList[n].viewType && undefined != _this14.ProposalLimitDtoList[n].viewType) {
              _this14.ProposalLimitDtoList[n].viewType = _this14.ProposalLimitDtoList[n].limitCondit + _this14.ProposalLimitDtoList[n].viewType;
            } else {
              _this14.ProposalLimitDtoList[n].viewType = _this14.ProposalLimitDtoList[n].limitCondit;
            }
          }
        }

        _this14.loing_box = false; //this.customizationtype()
      });
    },
    //修改--浏览------- 初始化
    Init_get2: function Init_get2(code, type) {
      var _this15 = this;

      console.log('----------------修改/浏览----初始化-------------', type + "+++++" + code);
      var para = {
        proposalNo: code,
        queryType: this.queryType
      };
      var auditRecordNo = code;
      var audit = {
        auditRecordNo: code
      }; //当是被保险人登录时，只能看到自己一个被保险人,不可修改，默认关闭---保险人登录时，只会走add流程

      if (this.queryType === "subAssured") {
        // 被保险人不展示选择协议被保险人按钮
        this.isRegisterFlag = false; // 被保险人不能修改投保人信息

        this.whole_flagbg = true;
      } // 投保人修改投保单时，不可以修改别人创建的投保单的协议被保险人


      if (this.queryType === "register" && this.createBy !== this.$store.state.user.userinfo.userId) {
        this.isRegisterFlag = false;
      }

      proposalQueryDto(para).then(function (res) {
        //					var list = getCityList()
        //					this.city_option = []
        //					for(var k = 0; k < list.length; k++) {
        //						var obj = {}
        //						obj.value = list[k].codeCode
        //						obj.label = list[k].codeCname
        //						this.city_option.push(obj)
        //					}
        console.log('----------------修改/浏览----初始化-------------');
        console.log(res);
        _this15.itemType_option = res.protocolItemResDto.itemList;
        _this15.itemType_option2 = res.protocolItemResDto.customItemList; // 申报基准

        for (var i = 0; i < res.pageSelect.reportCodeList.length; i++) {
          var obj = {};
          obj.value = res.pageSelect.reportCodeList[i].codeCode;
          obj.label = res.pageSelect.reportCodeList[i].codeCname;

          _this15.reportName_option.push(obj);
        }

        if (type != "view") {
          _this15.isViewProcess = false; // 加成比例

          if (res.pageSelect.insureUpperLimit == null || res.pageSelect.insureUpperLimit == "") {
            _this15.ProposalKindDto.plusRate = res.pageSelect.insureDefault;
            $(".carriagetwo").addClass("putash");
            _this15.whole_carflag = true;
          }
        } // 是否收集发票信息


        if (res.pageSelect.isInvoiceCollected == '1') {
          _this15.invoiceCollectedFlag = true;
        } else {
          _this15.invoiceCollectedFlag = false;
        }

        if (type === 'view') {
          _this15.isViewProcess = true;
          queryAuditProcessList(audit).then(function (res) {
            console.log('***********----------', res);
            _this15.auditProcessList = res || [];
          });
        } // -- 基本


        if (res.proposalMainDto != null) {
          _this15.ProposalMainDto = res.proposalMainDto;

          _this15.getAddressData(res.proposalMainDto.insuranceCompanyCode);

          _this15.formatDateRange();

          _this15.ProposalMainDto.dates = [_this15.ProposalMainDto.agreementStartDate, _this15.ProposalMainDto.agreementEndDate];

          if (res.proposalMainDto.isAgreementBalance == '1' && res.proposalMainDto.insuranceCompanyCode == 'IC0009') {
            _this15.isAgrB = true;
          }
        } // -- 投保人


        console.log('投保人返参', res.proposalApplicantDto);

        if (res.proposalApplicantDto != null) {
          _this15.ProposalApplicantDto = res.proposalApplicantDto;
          var newArrArea = [];
          newArrArea.push(res.proposalApplicantDto.provinceCode);
          newArrArea.push(res.proposalApplicantDto.cityCode);
          newArrArea.push(res.proposalApplicantDto.areaCode);
          _this15.ProposalApplicantDto.provinceList = newArrArea;
          console.log('this.ProposalApplicantDto.provinceList投保人省事', _this15.ProposalApplicantDto.provinceList);

          if (type === 'view') {
            //投保人联系电话 脱敏
            if (_this15.ProposalApplicantDto.linkmanPhone != null && _this15.ProposalApplicantDto.linkmanPhone != '') {
              _this15.ProposalApplicantDto.linkmanPhone = _this15.setPhone(_this15.ProposalApplicantDto.linkmanPhone);
            } //投保人邮箱地址 脱敏


            if (_this15.ProposalApplicantDto.email != null && _this15.ProposalApplicantDto.email != '') {
              _this15.ProposalApplicantDto.email = _this15.setApplicationEmailTou(_this15.ProposalApplicantDto.email);
            }
          }
        } // --被保险人


        if (res.proposalInsuredDtoList != null) {
          _this15.ProposalInsuredDto = res.proposalInsuredDtoList[0] || [];
          var newArrAreaInsured = [];
          newArrAreaInsured.push(res.proposalInsuredDtoList[0].provinceCode);
          newArrAreaInsured.push(res.proposalInsuredDtoList[0].cityCode);
          newArrAreaInsured.push(res.proposalInsuredDtoList[0].areaCode);
          _this15.ProposalInsuredDto.provinceList = newArrAreaInsured;

          if (type === 'view') {
            if (_this15.ProposalInsuredDto.phone != null && _this15.ProposalInsuredDto.phone != '') {
              //被保人联系电话 脱敏
              _this15.ProposalInsuredDto.phone = _this15.setListPhone(_this15.ProposalInsuredDto.phone);
            }

            if (_this15.ProposalInsuredDto.email != null && _this15.ProposalInsuredDto.email != '') {
              //被保人邮箱地址 脱敏
              _this15.ProposalInsuredDto.email = _this15.setApplicationEmailTou(_this15.ProposalInsuredDto.email);
            }
          } // MODIFY+可修改+投保人进入+投保人创建：全放开
          // MODIFY+可修改+投保人进入+被保险人创建：全禁用
          // MODIFY+可修改+被保险人进入：按照新需求放开
          // MODIFY+不可修改：全禁用
          // 20240823
          // MODIFY+可修改+投保人进入+投保人创建：全放开
          // MODIFY+可修改+投保人进入+被保险人创建：全禁用
          // MODIFY+可修改+被保险人进入：按照新需求放开
          // MODIFY+不可修改+投保人进入：全禁用
          // MODIFY+不可修改+被保险人进入：按照新需求放开
          // 1--可修改    0----不可修改


          if (_this15.ProposalInsuredDto.isUpdateInsuredName === '1') {
            if (_this15.queryType === 'register') {
              if (_this15.createBy === _this15.$store.state.user.userinfo.userId) {
                _this15.whole_flag_s = false;
                _this15.whole_flag_subAssuredOInfo = false;
              } else {
                _this15.whole_flag_s = true;
                _this15.whole_flag_subAssuredOInfo = true;
              }
            } else {
              _this15.whole_flag_s = true;
              _this15.whole_flag_subAssuredOInfo = false;
            }
          } else {
            if (_this15.queryType === 'register') {
              _this15.whole_flag_s = true;
              _this15.whole_flag_subAssuredOInfo = true;
            } else {
              _this15.whole_flag_s = true;
              _this15.whole_flag_subAssuredOInfo = false;
            }
          }
        } // -- 特约都展示


        if (res.proposalEngageDtoList != null) {
          _this15.ProposalEngageDtoList = res.proposalEngageDtoList;
        }
        /*if (type == "view") {
          // -- 特约都展示
          if(res.proposalEngageDtoList != null) {
            this.ProposalEngageDtoList = res.proposalEngageDtoList
          }
        }else{
          // -- 特约只展示可编辑的
          var viewList = [];
          var oldList = res.proposalEngageDtoList;
          if(oldList != null) {
            for(var i = 0; i < oldList.length; i++) {
              if(oldList[i].updateFlag == '1'){
                viewList.push(oldList[i])
              }
            }
          }
          this.ProposalEngageDtoList = viewList
        }*/
        // -- 限额免赔


        if (res.proposalLimitDtoList != null) {
          _this15.ProposalLimitDtoList = res.proposalLimitDtoList;

          for (var n = 0; n < _this15.ProposalLimitDtoList.length; n++) {
            if (null != _this15.ProposalLimitDtoList[n].viewType && undefined != _this15.ProposalLimitDtoList[n].viewType) {
              _this15.ProposalLimitDtoList[n].viewType = _this15.ProposalLimitDtoList[n].limitCondit + _this15.ProposalLimitDtoList[n].viewType;
            } else {
              _this15.ProposalLimitDtoList[n].viewType = _this15.ProposalLimitDtoList[n].limitCondit;
            }
          }
        } //--- 运输


        if (res.proposalConveyanceDto != null) {
          for (var j = 0; j < res.proposalConveyanceDto.proposalConveyanceListDtoList.length; j++) {
            if (res.proposalConveyanceDto.proposalConveyanceListDtoList[j].voyageNumber == 999999999) {
              res.proposalConveyanceDto.proposalConveyanceListDtoList.splice(j, 1);
            } else {
              continue;
            }
          }

          _this15.ProposalConveyanceDto = res.proposalConveyanceDto;
          _this15.ProposalConveyanceDto.proposalConveyanceListDtoList = res.proposalConveyanceDto.proposalConveyanceListDtoList;
          var list = getCountryList();

          if (_this15.ProposalConveyanceDto.proposalConveyanceListDtoList != null) {
            for (var i = 0; i < _this15.ProposalConveyanceDto.proposalConveyanceListDtoList.length; i++) {
              // 查看状态下，船级社、船级类型、启运地、中转地/目的地 老数据展示  仅限于查看模式下维护老数据的展示
              if (type == "view") {
                // 船级社-不存在就新增，存在就更新label，保证页面上是旧的label
                var obj1 = {};
                obj1.value = _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassCode;
                obj1.label = _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassName;

                var existingOption1 = _this15.shipClass_option.find(function (option) {
                  return option.value === obj1.value;
                });

                if (!existingOption1) {
                  // 如果不存在具有相同value的对象，则添加新对象
                  _this15.shipClass_option.push(obj1);
                } else {
                  // 如果存在，你可以选择更新label
                  existingOption1.label = obj1.label;
                } // 船舶类型-不存在就新增，存在就更新label，保证页面上是旧的label


                var obj2 = {};
                obj2.value = _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypesCode;
                obj2.label = _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypes;

                var existingOption2 = _this15.shipTypes_option.find(function (option) {
                  return option.value === obj2.value;
                });

                if (!existingOption2) {
                  // 如果不存在具有相同value的对象，则添加新对象
                  _this15.shipTypes_option.push(obj2);
                } else {
                  // 如果存在，你可以选择更新label
                  existingOption2.label = obj2.label;
                } //启运地-


                var obj3 = {};
                obj3.value = _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode;
                obj3.label = _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryName;

                var existingOption3 = _this15.country_option.find(function (option) {
                  return option.value === obj3.value;
                });

                if (!existingOption3) {
                  // 如果不存在具有相同value的对象，则添加新对象
                  _this15.country_option.push(obj3);
                } else {
                  // 如果存在，你可以选择更新label
                  existingOption3.label = obj3.label;
                } //中转地/目的地


                var obj4 = {};
                obj4.value = _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryCode;
                obj4.label = _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryName;

                var existingOption4 = _this15.country_option.find(function (option) {
                  return option.value === obj4.value;
                });

                if (!existingOption4) {
                  // 如果不存在具有相同value的对象，则添加新对象
                  _this15.country_option.push(obj4);
                } else {
                  // 如果存在，你可以选择更新label
                  existingOption4.label = obj4.label;
                }
              } // 修改、复制状态下，船级社、船级类型过期数据清除


              if (type == "modify") {
                //船级社-code不存在则清空，code存在，value不同
                var obj1 = {};
                obj1.value = _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassCode;
                obj1.label = _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassName;

                var _existingOption = _this15.shipClass_option.find(function (option) {
                  return option.value === obj1.value;
                });

                if (!_existingOption) {
                  // 如果不存在具有相同value的对象,清空
                  _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassCode = null;
                  _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassName = null;
                } else {
                  // value存在但是label不同也清空
                  if (obj1.label !== _existingOption.label) {
                    _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassCode = null;
                    _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassName = null;
                  }
                }

                var obj2 = {};
                obj2.value = _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypesCode;
                obj2.label = _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypes;

                var _existingOption2 = _this15.shipTypes_option.find(function (option) {
                  return option.value === obj2.value;
                });

                if (!_existingOption2) {
                  // 如果不存在具有相同value的对象,清空
                  _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypesCode = null;
                  _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypes = null;
                } else {
                  // value存在但是label不同也清空
                  if (obj2.label !== _existingOption2.label) {
                    _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypesCode = null;
                    _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypes = null;
                  }
                }
              }

              if (_this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode == 'CHN') {
                var list1 = getCHNCity();
                var arr1 = [];

                for (var k = 0; k < list1.length; k++) {
                  var obj = {};
                  obj.value = list1[k].codeCode;
                  obj.label = list1[k].codeCname + " - " + list1[k].codeEname;
                  arr1.push(obj);
                }

                _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option1 = arr1;
              } else {
                var list1 = getUnderCity(_this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode);
                var arr1 = [];

                for (var k = 0; k < list1.length; k++) {
                  var obj = {};
                  obj.value = list1[k].codeCode;
                  obj.label = list1[k].codeCname + " - " + list1[k].codeEname;
                  arr1.push(obj);
                }

                _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option1 = arr1;
              }

              if (_this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryCode == 'CHN') {
                var list2 = getCHNCity();
                var arr2 = [];

                for (var k = 0; k < list2.length; k++) {
                  var obj = {};
                  obj.value = list2[k].codeCode;
                  obj.label = list2[k].codeCname + " - " + list2[k].codeEname;
                  arr2.push(obj);
                }

                _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option2 = arr2;
              } else {
                var list2 = getUnderCity(_this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryCode);
                var arr2 = [];

                for (var k = 0; k < list2.length; k++) {
                  var obj = {};
                  obj.value = list2[k].codeCode;
                  obj.label = list2[k].codeCname + " - " + list2[k].codeEname;
                  arr2.push(obj);
                }

                _this15.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option2 = arr2;
              } // var list1 = getUnderCity(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode)
              // var list2 = getUnderCity(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryCode)
              // var arr1 = []
              // for(var k = 0; k < list1.length; k++) {
              // 	var obj = {}
              // 	obj.value = list1[k].codeCode
              // 	obj.label = list1[k].codeCname
              // 	arr1.push(obj)
              // }
              // var arr2 = []
              // for(var k = 0; k < list2.length; k++) {
              // 	var obj = {}
              // 	obj.value = list2[k].codeCode
              // 	obj.label = list2[k].codeCname
              // 	arr2.push(obj)
              // }
              // this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option1 = arr1
              // this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option2 = arr2

            } // console.log(this.ProposalConveyanceDto.proposalConveyanceListDtoList)

          }
        } //--- 标的


        if (res.proposalItemDto != null) {
          console.log(res.proposalItemDto.proposalItemCargoDtoList);

          for (var j = 0; j < res.proposalItemDto.proposalItemCargoDtoList.length; j++) {
            if (res.proposalItemDto.proposalItemCargoDtoList[j].serialNo == 999999999) {
              res.proposalItemDto.proposalItemCargoDtoList.splice(j, 1);
            } else {
              continue;
            }
          }

          _this15.ProposalItemDto = res.proposalItemDto; // 特定贸易条件下、运费改为其他税费

          if (_this15.ProposalItemDto.reportName === '销售合同金额（不含增值税）+ 进口增值税' || _this15.ProposalItemDto.reportName === '采购金额 + 进口关税 + 进口增值税 + 运费' || _this15.ProposalItemDto.reportName === '发票金额 + 运费') {
            _this15.otherTaxFeesFlag = true;
          } else {
            _this15.otherTaxFeesFlag = false;
          }

          _this15.isStorage_ch(_this15.ProposalItemDto.isStorage);

          _this15.ProposalItemDto.proposalItemCargoDtoList = res.proposalItemDto.proposalItemCargoDtoList; // console.log(this.ProposalItemDto.proposalItemCargoDtoList,'**********')
          // if (this.ProposalItemDto.invoicCurrencyCode == 'JPY') {
          // 	this.decimalValue = 0
          // } else {
          // 	this.decimalValue = 2
          // }
          // 日本元或非日本元时 千分位展示
          // 发票金额

          if (_this15.ProposalItemDto.invoicAmount == null) {
            _this15.invoicAmountsum_fun();
          }

          if (typeof _this15.ProposalItemDto.invoicAmount == "string") {
            _this15.ProposalItemDto.invoicAmount = parseFloat(_this15.ProposalItemDto.invoicAmount.replace(/,/g, ""));
          }

          if (_this15.ProposalItemDto.invoicCurrencyCode == "JPY") {
            _this15.ProposalItemDto.invoicAmount = toThousands(Math.round(_this15.ProposalItemDto.invoicAmount));
            console.log(_this15.ProposalItemDto.invoicAmount, 'jpy***');
          } else {
            _this15.ProposalItemDto.invoicAmount = num3_type_fun(_this15.ProposalItemDto.invoicAmount);
            console.log(_this15.ProposalItemDto.invoicAmount, 'fj***');
          }

          console.log('初始化---------------1');

          for (var i = 0; i < _this15.ProposalItemDto.proposalItemCargoDtoList.length; i++) {
            // 总价
            console.log(_this15.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount);

            if (_this15.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount != null) {
              if (_this15.ProposalItemDto.invoicCurrencyCode == "JPY") {
                _this15.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = toThousands(Math.round(_this15.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount)); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount)
              } else {
                _this15.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = num5_type_fun(_this15.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount);
              }
            } // 单价


            if (_this15.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount != null) {
              if (_this15.ProposalItemDto.invoicCurrencyCode == "JPY") {
                _this15.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = toThousands(Math.round(_this15.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)
              } else {
                _this15.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = num4_type_fun(_this15.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount);
              }
            }
          }

          if (res.proposalItemDto.storagePeriod != null && res.proposalItemDto.storagePeriod != undefined) {
            if (res.proposalItemDto.nationType != '' && res.proposalItemDto.nationType != null) {
              if (type === 'view') {
                _this15.addressFlag = true;
                _this15.viewShowFlag = true;
                _this15.nationFlag = true;
              } else if (type === 'modify') {
                _this15.addressFlag = true;
                _this15.viewShowFlag = false;
                _this15.nationFlag = false;
                _this15.showAddressFlag = true;
              } //国内


              if (res.proposalItemDto.nationType == '1') {
                _this15.showAddressFlag = true;
                _this15.nationFlag = true;
              } else if (res.proposalItemDto.nationType == '2') {
                _this15.showAddressFlag = false;
                _this15.nationFlag = false;
              }
            } // 更新地址信息
            // if (type === 'modify' || type === 'opcopy') {
            //   this.getProvinceCityData().then(res1=>{
            //     if (res.proposalItemDto.provinceCode !== null && res.proposalItemDto.provinceCode !== '') {
            //       for (var i = 0;i < this.allAddressData.length; i++) {
            //         if (this.allAddressData[i].codeCode === res.proposalItemDto.provinceCode) {
            //           for (var j = 0; j < this.allAddressData[i].children.length; j++) {
            //             var obj = {}
            //             obj.codeCode = this.allAddressData[i].children[j].codeCode
            //             obj.codeCname = this.allAddressData[i].children[j].codeCname
            //             this.cityList.push(obj)
            //           }
            //         }
            //       }
            //     }
            //     if (res.proposalItemDto.cityCode !== null && res.proposalItemDto.cityCode !== '') {
            //       for (var i = 0; i < this.allAddressData.length; i++) {
            //         if (this.allAddressData[i].codeCode === res.proposalItemDto.provinceCode) {
            //           for (var j = 0; j < this.allAddressData[i].children.length; j++) {
            //             if (this.allAddressData[i].children[j].codeCode === res.proposalItemDto.cityCode) {
            //               for (var k = 0; k < this.allAddressData[i].children[j].children.length; k++ ) {
            //                 var obj = {}
            //                 obj.codeCode = this.allAddressData[i].children[j].children[k].codeCode
            //                 obj.codeCname = this.allAddressData[i].children[j].children[k].codeCname
            //                 this.areaList.push(obj)
            //               }
            //             }
            //           }
            //         }
            //       }
            //     }
            //   })
            // }

          }
        }

        if (_this15.ProposalItemDto.proposalItemCargoDtoList != null) {//						for(var i = 0; i < this.ProposalItemDto.proposalItemCargoDtoList.length; i++) {
          //
          //							for(var k = 0; k < this.measuringUnit_option.length; k++) {
          //								if(this.ProposalItemDto.proposalItemCargoDtoList[i].unit == this.measuringUnit_option[k].value) {
          //									this.ProposalItemDto.proposalItemCargoDtoList[i].unitName = this.measuringUnit_option[k].label
          //								}
          //							}
          //
          //						}
        } //---主附险


        if (res.proposalKindDto != null) {
          if (res.proposalKindDto.plusRate == null) {
            res.proposalKindDto.plusRate = _this15.ProposalKindDto.plusRate;
          }

          for (var j = 0; j < res.proposalKindDto.proposalItemKindDtoList.length; j++) {
            if (res.proposalKindDto.proposalItemKindDtoList[j].kindCode == 999999999) {
              res.proposalKindDto.proposalItemKindDtoList.splice(j, 1);
            } else {
              continue;
            }
          }

          _this15.ProposalKindDto = res.proposalKindDto;

          if (res.proposalKindDto.premium != null) {
            if (res.proposalKindDto.limitMiniPremium != null) {
              if (Number(res.proposalKindDto.limitMiniPremium) > Number(res.proposalKindDto.premium)) {
                if (res.proposalMainDto.coreBackSumPremium != null) {
                  _this15.ProposalKindDto.limitMiniPremium = res.proposalMainDto.coreBackSumPremium;
                  _this15.ProposalKindDto.coreBackSumPremium = res.proposalMainDto.coreBackSumPremium;
                }
              } else {
                _this15.ProposalKindDto.limitMiniPremium = null;
              }
            }
          }

          if (type != "view") {
            // 加成比例
            if (res.pageSelect.insureUpperLimit == null || res.pageSelect.insureUpperLimit == "") {
              _this15.ProposalKindDto.plusRate = res.pageSelect.insureDefault;
              $(".carriagetwo").addClass("putash");
              _this15.whole_carflag = true;
            }
          }

          if (res.proposalKindDto.amount != null) {
            // 根据保额/保费币别判断总保额总保费显示
            // this.ProposalKindDto.sunAmount = res.proposalKindDto.amount
            if (_this15.ProposalKindDto.amountCurrencyCode == "JPY") {
              _this15.ProposalKindDto.sunAmount = toThousands(Math.round(res.proposalKindDto.amount));
            } else {
              _this15.ProposalKindDto.sunAmount = num3_type_fun(res.proposalKindDto.amount);
            }
          }

          if (res.proposalKindDto.premium != null) {
            // this.ProposalKindDto.sumPremium = res.proposalKindDto.premium
            if (_this15.ProposalKindDto.remiumCurrencyCode == "JPY") {
              _this15.ProposalKindDto.sumPremium = toThousands(Math.round(res.proposalKindDto.premium));
            } else {
              _this15.ProposalKindDto.sumPremium = num3_type_fun(res.proposalKindDto.premium);
            }
          }

          _this15.ProposalKindDto.remiumCurrency = res.proposalKindDto.premiumCurrency;
          _this15.ProposalKindDto.remiumCurrencyCode = res.proposalKindDto.premiumCurrencyCode;

          if (res.proposalKindDto.proposalItemKindDtoList != null) {
            console.log(res.proposalKindDto.proposalItemKindDtoList); // 条款信息列表根据保额/保费币别判断总保额总保费显示

            for (var i = 0; i < res.proposalKindDto.proposalItemKindDtoList.length; i++) {
              if (res.proposalKindDto.proposalItemKindDtoList[i].clauseType == '附加险') {
                // 仓储附加险-做成基础配置
                if (res.proposalKindDto.proposalItemKindDtoList[i].editFlag) {
                  _this15.ProposalKindDto.proposalItemKindDtoList[i].amount = num3_type_fun(res.proposalKindDto.proposalItemKindDtoList[i].amount);
                } else {
                  _this15.ProposalKindDto.proposalItemKindDtoList[i].amount = '-';
                }
              } else {
                console.log(_this15.ProposalKindDto.amountCurrencyCode);

                if (_this15.ProposalKindDto.amountCurrencyCode == "JPY") {
                  _this15.ProposalKindDto.proposalItemKindDtoList[i].amount = toThousands(Math.round(res.proposalKindDto.proposalItemKindDtoList[i].unitAmount));
                } else {
                  _this15.ProposalKindDto.proposalItemKindDtoList[i].amount = num3_type_fun(res.proposalKindDto.proposalItemKindDtoList[i].unitAmount);
                }
              }

              console.log(_this15.ProposalKindDto.remiumCurrencyCode);

              if (_this15.ProposalKindDto.remiumCurrencyCode == "JPY") {
                _this15.ProposalKindDto.proposalItemKindDtoList[i].premium = toThousands(Math.round(res.proposalKindDto.proposalItemKindDtoList[i].unitPremium));
              } else {
                _this15.ProposalKindDto.proposalItemKindDtoList[i].premium = num3_type_fun(res.proposalKindDto.proposalItemKindDtoList[i].unitPremium);
              }
            }
          }
        } //图片信息


        if (res.proposalImagList != null) {
          for (var i = 0; i < res.proposalImagList.length; i++) {
            // console.log(res.proposalImagList,'---------')
            var obj = {};
            var formData = new FormData();
            var base64 = 'data:image/png;base64,' + res.proposalImagList[i].base64Src;
            var imagCode = res.proposalImagList[i].imagCode;
            var proposalNo = res.proposalImagList[i].proposalNo;
            var fileSrc = res.proposalImagList[i].fileSrc;
            var fileName = res.proposalImagList[i].fileName; //转换base64到file

            var toFile = require('data-uri-to-file');

            toFile(base64).then(function (filed) {
              console.log(filed.mimeType, filed.data, filed.extension);
              formData.append("imageName", filed);
              obj.raw = filed;
            }); //var file = this.base64ToFile(base64);
            // console.log(file)
            //formData.append("imageName", file);

            obj.name = fileName; //obj.raw = file;

            obj["type"] = "old";
            obj["url"] = base64;
            obj["fileSrc"] = fileSrc;
            obj.imagCode = imagCode;
            obj.proposalNo = proposalNo;

            _this15.fileList.push(obj);
          }

          console.log(obj);
        } // 发票信息


        if (res.proposalInvoiceDto != null) {
          _this15.ProposalInvoiceDto = res.proposalInvoiceDto;
        }

        if (type == "view") {
          _this15.whole_carflag = true;
          _this15.whole_flag_s = true;
          _this15.whole_flag_subAssuredOInfo = true;

          if (_this15.whole_flag) {
            $(".carriage").addClass("putash");
            $(".carriagetwo").addClass("putash");
            _this15.whole_carflag = true;
            _this15.whole_benflag = true;
          } else {
            $(".carriage").removeClass("putash");
            $(".carriagetwo").removeClass("putash");
            _this15.whole_carflag = true;
            _this15.whole_benflag = true;
          }

          _this15.loing_box = false;
        }

        _this15.loing_box = false; //this.customizationtype()
      });
    },
    //复制投保单申请号内容------- 初始化
    Init_get3: function Init_get3(code) {
      var _this16 = this;

      var type = 'opcopy';
      this.box_7_img = false;
      var para = {
        proposalNo: code,
        queryType: this.queryType
      }; //当是被保险人登录时，只能看到自己一个被保险人，默认关闭---保险人登录时，只会走add流程

      if (this.queryType === "subAssured") {
        this.isRegisterFlag = false;
      }

      proposalQueryByCopy(para).then(function (res) {
        console.log('----------------复制----初始化-------------');
        console.log(res);
        _this16.itemType_option = res.protocolItemResDto.itemList;
        _this16.itemType_option2 = res.protocolItemResDto.customItemList; // 申报基准

        for (var i = 0; i < res.pageSelect.reportCodeList.length; i++) {
          var obj = {};
          obj.value = res.pageSelect.reportCodeList[i].codeCode;
          obj.label = res.pageSelect.reportCodeList[i].codeCname;

          _this16.reportName_option.push(obj);
        } // 加成比例


        if (res.pageSelect.insureUpperLimit == null || res.pageSelect.insureUpperLimit == "") {
          _this16.ProposalKindDto.plusRate = res.pageSelect.insureDefault;
          $(".carriagetwo").addClass("putash");
          _this16.whole_carflag = true;
        } // 是否收集发票信息


        if (res.pageSelect.isInvoiceCollected == '1') {
          _this16.invoiceCollectedFlag = true;
        } else {
          _this16.invoiceCollectedFlag = false;
        } // -- 基本


        if (res.proposalMainDto != null) {
          _this16.ProposalMainDto = res.proposalMainDto;

          _this16.getAddressData(res.proposalMainDto.insuranceCompanyCode);

          _this16.formatDateRange();

          _this16.ProposalMainDto.dates = [_this16.ProposalMainDto.agreementStartDate, _this16.ProposalMainDto.agreementEndDate];
          _this16.ProposalMainDto.proposalNo = "";

          if (res.proposalMainDto.isAgreementBalance == '1' && res.proposalMainDto.insuranceCompanyCode == 'IC0009') {
            _this16.isAgrB = true;
          }
        } // -- 投保人


        if (res.proposalApplicantDto != null) {
          _this16.ProposalApplicantDto = res.proposalApplicantDto;
          var newArrArea = [];
          newArrArea.push(res.proposalApplicantDto.provinceCode);
          newArrArea.push(res.proposalApplicantDto.cityCode);
          newArrArea.push(res.proposalApplicantDto.areaCode);
          _this16.ProposalApplicantDto.provinceList = newArrArea;
        } // --被保险人


        if (res.proposalInsuredDtoList != null) {
          _this16.ProposalInsuredDto = res.proposalInsuredDtoList[0] || [];
          var newArrAreaInsured = [];
          newArrAreaInsured.push(res.proposalInsuredDtoList[0].provinceCode);
          newArrAreaInsured.push(res.proposalInsuredDtoList[0].cityCode);
          newArrAreaInsured.push(res.proposalInsuredDtoList[0].areaCode);
          _this16.ProposalInsuredDto.provinceList = newArrAreaInsured; // 复制 数据可修改 被保险人登录 -> 部分禁用
          // 复制 数据可修改 投保人登录 -> 不禁用
          // 复制 数据不可修改 all 全部禁用
          // 20240823
          // 复制 数据可修改 被保险人登录 -> 部分禁用
          // 复制 数据可修改 投保人登录 -> 不禁用
          // 复制 数据不可修改 投保人登录 -> 全部禁用
          // 复制 数据不可修改 被保险人登录 -> 部分禁用

          if (_this16.ProposalInsuredDto.isUpdateInsuredName == "1") {
            //1--可修改    0----不可修改
            if (_this16.queryType === "register") {
              _this16.whole_flag_s = false;
              _this16.whole_flag_subAssuredOInfo = false;
            } else {
              _this16.whole_flag_s = true;
              _this16.whole_flag_subAssuredOInfo = false;
            }
          } else {
            if (_this16.queryType === "register") {
              _this16.whole_flag_s = true;
              _this16.whole_flag_subAssuredOInfo = true;
            } else {
              _this16.whole_flag_s = true;
              _this16.whole_flag_subAssuredOInfo = false;
            }
          } // 20240820 被保险人回刷 投保人复制时+如果协议不可修改+子账号创建（投保单被保险人不存在在协议被保险人中（确认违法不可修改原则）/在其中（如果恰好子账号也在被保险人中，而且不是默认的第一位,没有违法不可修改原则）），刷回第一个被保险人(转后端处理)

        } // -- 特约


        if (res.proposalEngageDtoList != null) {
          _this16.ProposalEngageDtoList = res.proposalEngageDtoList;
          /*// -- 特约只展示可编辑的
          var viewList = [];
          var oldList = res.proposalEngageDtoList;
          if(oldList != null) {
            for(var i = 0; i < oldList.length; i++) {
              if(oldList[i].updateFlag == '1'){
                viewList.push(oldList[i])
              }
            }
          }
          this.ProposalEngageDtoList = viewList*/
        } // -- 限额免赔


        if (res.proposalLimitDtoList != null) {
          _this16.ProposalLimitDtoList = res.proposalLimitDtoList;

          for (var n = 0; n < _this16.ProposalLimitDtoList.length; n++) {
            if (null != _this16.ProposalLimitDtoList[n].viewType && undefined != _this16.ProposalLimitDtoList[n].viewType) {
              _this16.ProposalLimitDtoList[n].viewType = _this16.ProposalLimitDtoList[n].limitCondit + _this16.ProposalLimitDtoList[n].viewType;
            } else {
              _this16.ProposalLimitDtoList[n].viewType = _this16.ProposalLimitDtoList[n].limitCondit;
            }
          }
        } //--- 运输


        if (res.proposalConveyanceDto != null) {
          for (var j = 0; j < res.proposalConveyanceDto.proposalConveyanceListDtoList.length; j++) {
            if (res.proposalConveyanceDto.proposalConveyanceListDtoList[j].voyageNumber == 999999999) {
              res.proposalConveyanceDto.proposalConveyanceListDtoList.splice(j, 1);
            } else {
              continue;
            }
          }

          _this16.ProposalConveyanceDto = res.proposalConveyanceDto;
          _this16.ProposalConveyanceDto.proposalConveyanceListDtoList = res.proposalConveyanceDto.proposalConveyanceListDtoList;
          _this16.ProposalConveyanceDto.startTime = null;
          var list = getCountryList();

          if (_this16.ProposalConveyanceDto.proposalConveyanceListDtoList != null) {
            for (var i = 0; i < _this16.ProposalConveyanceDto.proposalConveyanceListDtoList.length; i++) {
              // 修改、复制状态下，船级社、船级类型过期数据清除(根据code获取值，code不存在，清空，code存在，获取最新值)
              if (type == "opcopy") {
                // var obj1 = {}
                // obj1.value = this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassCode
                // obj1.label = this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassName
                // const existingOption1 = this.shipClass_option.find(option => option.value === obj1.value)
                // if (!existingOption1) {
                //   // 如果不存在具有相同value的对象,清空
                //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassCode = null
                //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassName = null
                // } else {
                //   // value存在但是label不同也清空
                //   if(obj1.label !== existingOption1.label){
                //     this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassCode = null
                //     this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassName = null
                //   }
                // }
                // var obj2 = {}
                // obj2.value = this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypesCode
                // obj2.label = this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypes
                // const existingOption2 = this.shipTypes_option.find(option => option.value === obj2.value)
                // if (!existingOption2) {
                //   // 如果不存在具有相同value的对象,清空
                //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypesCode = null
                //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypes = null
                // } else {
                //   // value存在但是label不同也清空
                //   if(obj2.label !== existingOption2.label){
                //     this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypesCode = null
                //     this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypes = null
                //   }
                // }
                // 20241024 因船级社和船舶类型有时为空，所以统一将 船级社\船舶类型\船龄 置空
                _this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassCode = null;
                _this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassName = null;
                _this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypesCode = null;
                _this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypes = null;
                _this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].vessel = null;
              }

              if (_this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode == 'CHN') {
                var list1 = getCHNCity();
                var arr1 = [];

                for (var k = 0; k < list1.length; k++) {
                  var obj = {};
                  obj.value = list1[k].codeCode;
                  obj.label = list1[k].codeCname + " - " + list1[k].codeEname;
                  arr1.push(obj);
                }

                _this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option1 = arr1;
              } else {
                var list1 = getUnderCity(_this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode);
                var arr1 = [];

                for (var k = 0; k < list1.length; k++) {
                  var obj = {};
                  obj.value = list1[k].codeCode;
                  obj.label = list1[k].codeCname + " - " + list1[k].codeEname;
                  arr1.push(obj);
                }

                _this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option1 = arr1;
              }

              if (_this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryCode == 'CHN') {
                var list2 = getCHNCity();
                var arr2 = [];

                for (var k = 0; k < list2.length; k++) {
                  var obj = {};
                  obj.value = list2[k].codeCode;
                  obj.label = list2[k].codeCname + " - " + list2[k].codeEname;
                  arr2.push(obj);
                }

                _this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option2 = arr2;
              } else {
                var list2 = getUnderCity(_this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryCode);
                var arr2 = [];

                for (var k = 0; k < list2.length; k++) {
                  var obj = {};
                  obj.value = list2[k].codeCode;
                  obj.label = list2[k].codeCname + " - " + list2[k].codeEname;
                  arr2.push(obj);
                }

                _this16.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option2 = arr2;
              } // var list1 = getUnderCity(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode)
              // var list2 = getUnderCity(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryCode)
              // var arr1 = []
              // for(var k = 0; k < list1.length; k++) {
              // 	var obj = {}
              // 	obj.value = list1[k].codeCode
              // 	obj.label = list1[k].codeCname
              // 	arr1.push(obj)
              // }
              // var arr2 = []
              // for(var k = 0; k < list2.length; k++) {
              // 	var obj = {}
              // 	obj.value = list2[k].codeCode
              // 	obj.label = list2[k].codeCname
              // 	arr2.push(obj)
              // }
              // this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option1 = arr1
              // this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option2 = arr2

            } // console.log(this.ProposalConveyanceDto.proposalConveyanceListDtoList)

          }
        } //--- 标的


        if (res.proposalItemDto != null) {
          for (var j = 0; j < res.proposalItemDto.proposalItemCargoDtoList.length; j++) {
            if (res.proposalItemDto.proposalItemCargoDtoList[j].serialNo == 999999999) {
              res.proposalItemDto.proposalItemCargoDtoList.splice(j, 1);
            } else {
              continue;
            }
          }

          _this16.ProposalItemDto = res.proposalItemDto;
          _this16.ProposalItemDto.storageStartTime = null;
          _this16.ProposalItemDto.storageEndTime = null;
          _this16.ProposalItemDto.storagePeriod = null; // 特定贸易条件下、运费改为其他税费

          if (_this16.ProposalItemDto.reportName === '销售合同金额（不含增值税）+ 进口增值税' || _this16.ProposalItemDto.reportName === '采购金额 + 进口关税 + 进口增值税 + 运费' || _this16.ProposalItemDto.reportName === '发票金额 + 运费') {
            _this16.otherTaxFeesFlag = true;
          } else {
            _this16.otherTaxFeesFlag = false;
          }

          _this16.ProposalItemDto.proposalItemCargoDtoList = res.proposalItemDto.proposalItemCargoDtoList; // if (this.ProposalItemDto.invoicCurrencyCode == 'JPY') {
          // 	this.decimalValue = 0
          // } else {
          // 	this.decimalValue = 2
          // }
          // 日本元或非日本元时 千分位展示
          // 发票金额

          if (_this16.ProposalItemDto.invoicAmount == null) {
            _this16.invoicAmountsum_fun();
          }

          if (typeof _this16.ProposalItemDto.invoicAmount == "string") {
            _this16.ProposalItemDto.invoicAmount = parseFloat(_this16.ProposalItemDto.invoicAmount.replace(/,/g, ""));
          }

          if (_this16.ProposalItemDto.invoicCurrencyCode == "JPY") {
            _this16.ProposalItemDto.invoicAmount = toThousands(Math.round(_this16.ProposalItemDto.invoicAmount));
            console.log(_this16.ProposalItemDto.invoicAmount, 'jpy***');
          } else {
            _this16.ProposalItemDto.invoicAmount = num3_type_fun(_this16.ProposalItemDto.invoicAmount);
            console.log(_this16.ProposalItemDto.invoicAmount, 'fj***');
          }

          console.log('初始化---------------2');

          for (var i = 0; i < _this16.ProposalItemDto.proposalItemCargoDtoList.length; i++) {
            // 总价
            if (_this16.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount != null) {
              if (_this16.ProposalItemDto.invoicCurrencyCode == "JPY") {
                _this16.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = toThousands(Math.round(_this16.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount)); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount)
              } else {
                _this16.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = num5_type_fun(_this16.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount);
              }
            } // 单价


            if (_this16.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount != null) {
              if (_this16.ProposalItemDto.invoicCurrencyCode == "JPY") {
                _this16.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = toThousands(Math.round(_this16.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)
              } else {
                _this16.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = num4_type_fun(_this16.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount);
              }
            }
          }

          if (res.proposalItemDto.isStorage !== null && res.proposalItemDto.isStorage === '1') {
            _this16.storageFlag = true;
          }

          if (res.proposalItemDto.storagePeriod != null && res.proposalItemDto.storagePeriod != undefined) {
            if (res.proposalItemDto.nationType != '' && res.proposalItemDto.nationType != null) {
              _this16.addressFlag = true;
              _this16.viewShowFlag = false;
              _this16.nationFlag = false; //国内

              if (res.proposalItemDto.nationType == '1') {
                _this16.showAddressFlag = true;
                _this16.nationFlag = true;
              } else if (res.proposalItemDto.nationType == '2') {
                _this16.showAddressFlag = false;
                _this16.nationFlag = false;
              } else {
                _this16.showAddressFlag = true;
                _this16.nationFlag = false;
              }
            } else {
              _this16.addressFlag = true; //国内

              if (res.proposalItemDto.nationType == '1') {
                _this16.showAddressFlag = true;
              } else if (res.proposalItemDto.nationType == '2') {
                _this16.showAddressFlag = false;
              } else {
                _this16.showAddressFlag = true;
              }

              _this16.nationFlag = true;
              _this16.ProposalItemDto.countryEName = 'CHN';
              _this16.ProposalItemDto.countryName = '中国';
              _this16.ProposalItemDto.nationType = '1';
            } // 更新地址信息
            // if (type === 'modify' || type === 'opcopy') {
            //   this.getProvinceCityData().then(res1=>{
            //     if (res.proposalItemDto.provinceCode !== null && res.proposalItemDto.provinceCode !== '') {
            //       for (var i = 0;i < this.allAddressData.length; i++) {
            //         if (this.allAddressData[i].codeCode === res.proposalItemDto.provinceCode) {
            //           for (var j = 0; j < this.allAddressData[i].children.length; j++) {
            //             var obj = {}
            //             obj.codeCode = this.allAddressData[i].children[j].codeCode
            //             obj.codeCname = this.allAddressData[i].children[j].codeCname
            //             this.cityList.push(obj)
            //           }
            //         }
            //       }
            //     }
            //     if (res.proposalItemDto.cityCode !== null && res.proposalItemDto.cityCode !== '') {
            //       for (var i = 0; i < this.allAddressData.length; i++) {
            //         if (this.allAddressData[i].codeCode === res.proposalItemDto.provinceCode) {
            //           for (var j = 0; j < this.allAddressData[i].children.length; j++) {
            //             if (this.allAddressData[i].children[j].codeCode === res.proposalItemDto.cityCode) {
            //               for (var k = 0; k < this.allAddressData[i].children[j].children.length; k++ ) {
            //                 var obj = {}
            //                 obj.codeCode = this.allAddressData[i].children[j].children[k].codeCode
            //                 obj.codeCname = this.allAddressData[i].children[j].children[k].codeCname
            //                 this.areaList.push(obj)
            //               }
            //             }
            //           }
            //         }
            //       }
            //     }
            //   })
            // }

          }
        }

        if (_this16.ProposalItemDto.proposalItemCargoDtoList != null) {//						for(var i = 0; i < this.ProposalItemDto.proposalItemCargoDtoList.length; i++) {
          //
          //							for(var k = 0; k < this.measuringUnit_option.length; k++) {
          //								if(this.ProposalItemDto.proposalItemCargoDtoList[i].unit == this.measuringUnit_option[k].value) {
          //									this.ProposalItemDto.proposalItemCargoDtoList[i].unitName = this.measuringUnit_option[k].label
          //								}
          //							}
          //
          //						}
        } //---主附险


        if (res.proposalKindDto != null) {
          for (var j = 0; j < res.proposalKindDto.proposalItemKindDtoList.length; j++) {
            if (res.proposalKindDto.proposalItemKindDtoList[j].kindCode == 999999999) {
              res.proposalKindDto.proposalItemKindDtoList.splice(j, 1);
            } else {
              continue;
            }
          }

          _this16.ProposalKindDto = res.proposalKindDto; // 加成比例

          if (res.pageSelect.insureUpperLimit == null || res.pageSelect.insureUpperLimit == "") {
            _this16.ProposalKindDto.plusRate = res.pageSelect.insureDefault;
            $(".carriagetwo").addClass("putash");
            _this16.whole_carflag = true;
          }

          if (res.proposalKindDto.amount != null) {
            // 根据保额/保费币别判断总保额总保费显示
            // this.ProposalKindDto.sunAmount = res.proposalKindDto.amount
            if (_this16.ProposalKindDto.amountCurrencyCode == "JPY") {
              _this16.ProposalKindDto.sunAmount = toThousands(Math.round(res.proposalKindDto.amount));
            } else {
              _this16.ProposalKindDto.sunAmount = num3_type_fun(res.proposalKindDto.amount);
            }
          }

          if (res.proposalKindDto.premium != null) {
            // this.ProposalKindDto.sumPremium = res.proposalKindDto.premium
            if (_this16.ProposalKindDto.remiumCurrencyCode == "JPY") {
              _this16.ProposalKindDto.sumPremium = toThousands(Math.round(res.proposalKindDto.premium));
            } else {
              _this16.ProposalKindDto.sumPremium = num3_type_fun(res.proposalKindDto.premium);
            }
          }

          _this16.ProposalKindDto.remiumCurrency = res.proposalKindDto.premiumCurrency;
          _this16.ProposalKindDto.remiumCurrencyCode = res.proposalKindDto.premiumCurrencyCode;

          if (res.proposalKindDto.proposalItemKindDtoList != null) {
            // 条款信息列表根据保额/保费币别判断总保额总保费显示
            for (var i = 0; i < res.proposalKindDto.proposalItemKindDtoList.length; i++) {
              if (res.proposalKindDto.proposalItemKindDtoList[i].clauseType == '附加险') {
                // 仓储附加险-做成基础配置
                if (res.proposalKindDto.proposalItemKindDtoList[i].editFlag) {
                  _this16.ProposalKindDto.proposalItemKindDtoList[i].amount = num3_type_fun(res.proposalKindDto.proposalItemKindDtoList[i].amount);
                } else {
                  _this16.ProposalKindDto.proposalItemKindDtoList[i].amount = '-';
                }
              } else {
                console.log(_this16.ProposalKindDto.amountCurrencyCode);

                if (_this16.ProposalKindDto.amountCurrencyCode == "JPY") {
                  _this16.ProposalKindDto.proposalItemKindDtoList[i].amount = toThousands(Math.round(res.proposalKindDto.proposalItemKindDtoList[i].unitAmount));
                } else {
                  _this16.ProposalKindDto.proposalItemKindDtoList[i].amount = num3_type_fun(res.proposalKindDto.proposalItemKindDtoList[i].unitAmount);
                }
              }

              console.log(_this16.ProposalKindDto.remiumCurrencyCode);

              if (_this16.ProposalKindDto.remiumCurrencyCode == "JPY") {
                _this16.ProposalKindDto.proposalItemKindDtoList[i].premium = toThousands(Math.round(res.proposalKindDto.proposalItemKindDtoList[i].unitPremium));
              } else {
                _this16.ProposalKindDto.proposalItemKindDtoList[i].premium = num3_type_fun(res.proposalKindDto.proposalItemKindDtoList[i].unitPremium);
              }
            }
          }
        } // 发票信息


        if (res.proposalInvoiceDto != null) {
          _this16.ProposalInvoiceDto = res.proposalInvoiceDto;
        }

        _this16.loing_box = false; //this.customizationtype()
      });
    },
    //待补录内容------- 初始化
    Init_get4: function Init_get4(code) {
      var _this17 = this;

      var para = {
        proposalNo: code
      };
      proposalQueryDto(para).then(function (res) {
        console.log('----------------复制----初始化-------------');
        console.log(res);
        _this17.itemType_option = res.protocolItemResDto.itemList;
        _this17.itemType_option2 = res.protocolItemResDto.customItemList; // 申报基准

        for (var i = 0; i < res.pageSelect.reportCodeList.length; i++) {
          var obj = {};
          obj.value = res.pageSelect.reportCodeList[i].codeCode;
          obj.label = res.pageSelect.reportCodeList[i].codeCname;

          _this17.reportName_option.push(obj);
        } // 加成比例


        if (res.pageSelect.insureUpperLimit == null || res.pageSelect.insureUpperLimit == "") {
          _this17.ProposalKindDto.plusRate = res.pageSelect.insureDefault;
          $(".carriagetwo").addClass("putash");
          _this17.whole_carflag = true;
        } // -- 基本


        if (res.proposalMainDto != null) {
          _this17.ProposalMainDto = res.proposalMainDto;

          _this17.getAddressData(res.proposalMainDto.insuranceCompanyCode);

          _this17.formatDateRange();

          _this17.ProposalMainDto.dates = [_this17.ProposalMainDto.agreementStartDate, _this17.ProposalMainDto.agreementEndDate];
        } // -- 投保人


        if (res.proposalApplicantDto != null) {
          _this17.ProposalApplicantDto = res.proposalApplicantDto;
          var newArrArea = [];
          newArrArea.push(res.proposalApplicantDto.provinceCode);
          newArrArea.push(res.proposalApplicantDto.cityCode);
          newArrArea.push(res.proposalApplicantDto.areaCode);
          _this17.ProposalApplicantDto.provinceList = newArrArea;
        } // --被保险人


        if (res.proposalInsuredDtoList != null) {
          _this17.ProposalInsuredDto = res.proposalInsuredDtoList[0] || [];
          var newArrAreaInsured = [];
          newArrAreaInsured.push(res.proposalInsuredDtoList[0].provinceCode);
          newArrAreaInsured.push(res.proposalInsuredDtoList[0].cityCode);
          newArrAreaInsured.push(res.proposalInsuredDtoList[0].areaCode);
          _this17.ProposalInsuredDto.provinceList = newArrAreaInsured;

          if (_this17.ProposalInsuredDto.isUpdateInsuredName == "1") {
            //1--可修改    0----不可修改
            _this17.whole_flag_s = false;
            _this17.whole_flag_subAssuredOInfo = false;
          } else {
            _this17.whole_flag_s = true;
            _this17.whole_flag_subAssuredOInfo = true;
          }
        } // -- 特约


        if (res.proposalEngageDtoList != null) {
          _this17.ProposalEngageDtoList = res.proposalEngageDtoList;
        } // -- 限额免赔


        if (res.proposalLimitDtoList != null) {
          _this17.ProposalLimitDtoList = res.proposalLimitDtoList;

          for (var n = 0; n < _this17.ProposalLimitDtoList.length; n++) {
            if (null != _this17.ProposalLimitDtoList[n].viewType && undefined != _this17.ProposalLimitDtoList[n].viewType) {
              _this17.ProposalLimitDtoList[n].viewType = _this17.ProposalLimitDtoList[n].limitCondit + _this17.ProposalLimitDtoList[n].viewType;
            } else {
              _this17.ProposalLimitDtoList[n].viewType = _this17.ProposalLimitDtoList[n].limitCondit;
            }
          }
        } //--- 运输


        if (res.proposalConveyanceDto != null) {
          for (var j = 0; j < res.proposalConveyanceDto.proposalConveyanceListDtoList.length; j++) {
            if (res.proposalConveyanceDto.proposalConveyanceListDtoList[j].voyageNumber == 999999999) {
              res.proposalConveyanceDto.proposalConveyanceListDtoList.splice(j, 1);
            } else {
              continue;
            }
          }

          _this17.ProposalConveyanceDto = res.proposalConveyanceDto; // this.ProposalConveyanceDto.proposalConveyanceListDtoList = res.proposalConveyanceDto.proposalConveyanceListDtoList

          var list = getCountryList();

          if (_this17.ProposalConveyanceDto.proposalConveyanceListDtoList != null) {
            for (var i = 0; i < _this17.ProposalConveyanceDto.proposalConveyanceListDtoList.length; i++) {
              if (_this17.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode == 'CHN') {
                var list1 = getCHNCity();
                var arr1 = [];

                for (var k = 0; k < list1.length; k++) {
                  var obj = {};
                  obj.value = list1[k].codeCode;
                  obj.label = list1[k].codeCname + " - " + list1[k].codeEname;
                  arr1.push(obj);
                }

                _this17.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option1 = arr1;
              } else {
                var list1 = getUnderCity(_this17.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode);
                var arr1 = [];

                for (var k = 0; k < list1.length; k++) {
                  var obj = {};
                  obj.value = list1[k].codeCode;
                  obj.label = list1[k].codeCname + " - " + list1[k].codeEname;
                  arr1.push(obj);
                }

                _this17.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option1 = arr1;
              }

              if (_this17.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryCode == 'CHN') {
                var list2 = getCHNCity();
                var arr2 = [];

                for (var k = 0; k < list2.length; k++) {
                  var obj = {};
                  obj.value = list2[k].codeCode;
                  obj.label = list2[k].codeCname + " - " + list2[k].codeEname;
                  arr2.push(obj);
                }

                _this17.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option2 = arr2;
              } else {
                var list2 = getUnderCity(_this17.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryCode);
                var arr2 = [];

                for (var k = 0; k < list2.length; k++) {
                  var obj = {};
                  obj.value = list2[k].codeCode;
                  obj.label = list2[k].codeCname + " - " + list2[k].codeEname;
                  arr2.push(obj);
                }

                _this17.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option2 = arr2;
              } // var list1 = getUnderCity(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode)
              // var list2 = getUnderCity(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryCode)
              // var arr1 = []
              // for(var k = 0; k < list1.length; k++) {
              // 	var obj = {}
              // 	obj.value = list1[k].codeCode
              // 	obj.label = list1[k].codeCname
              // 	arr1.push(obj)
              // }
              // var arr2 = []
              // for(var k = 0; k < list2.length; k++) {
              // 	var obj = {}
              // 	obj.value = list2[k].codeCode
              // 	obj.label = list2[k].codeCname
              // 	arr2.push(obj)
              // }
              // this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option1 = arr1
              // this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].city_option2 = arr2

            } // console.log(this.ProposalConveyanceDto.proposalConveyanceListDtoList)

          }
        } //--- 标的


        if (res.proposalItemDto != null) {
          for (var j = 0; j < res.proposalItemDto.proposalItemCargoDtoList.length; j++) {
            if (res.proposalItemDto.proposalItemCargoDtoList[j].serialNo == 999999999) {
              res.proposalItemDto.proposalItemCargoDtoList.splice(j, 1);
            } else {
              continue;
            }
          }

          _this17.ProposalItemDto = res.proposalItemDto;
          _this17.ProposalItemDto.proposalItemCargoDtoList = res.proposalItemDto.proposalItemCargoDtoList; // if (this.ProposalItemDto.invoicCurrencyCode == 'JPY') {
          // 	this.decimalValue = 0
          // } else {
          // 	this.decimalValue = 2
          // }
          // 日本元或非日本元时 千分位展示
          // 发票金额

          if (_this17.ProposalItemDto.invoicAmount == null) {
            _this17.invoicAmountsum_fun();
          }

          if (typeof _this17.ProposalItemDto.invoicAmount == "string") {
            _this17.ProposalItemDto.invoicAmount = parseFloat(_this17.ProposalItemDto.invoicAmount.replace(/,/g, ""));
          }

          if (_this17.ProposalItemDto.invoicCurrencyCode == "JPY") {
            _this17.ProposalItemDto.invoicAmount = toThousands(Math.round(_this17.ProposalItemDto.invoicAmount));
            console.log(_this17.ProposalItemDto.invoicAmount, 'jpy***');
          } else {
            _this17.ProposalItemDto.invoicAmount = num3_type_fun(_this17.ProposalItemDto.invoicAmount);
            console.log(_this17.ProposalItemDto.invoicAmount, 'fj***');
          }

          console.log('初始化---------------3');

          for (var i = 0; i < _this17.ProposalItemDto.proposalItemCargoDtoList.length; i++) {
            // 总价
            console.log(_this17.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount);

            if (_this17.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount != null) {
              if (_this17.ProposalItemDto.invoicCurrencyCode == "JPY") {
                _this17.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = toThousands(Math.round(_this17.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount)); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount)
              } else {
                _this17.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = num5_type_fun(_this17.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount);
              }
            } // 单价


            if (_this17.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount != null) {
              if (_this17.ProposalItemDto.invoicCurrencyCode == "JPY") {
                _this17.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = toThousands(Math.round(_this17.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)
              } else {
                _this17.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = num4_type_fun(_this17.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount);
              }
            }
          }
        }

        if (_this17.ProposalItemDto.proposalItemCargoDtoList != null) {} //---主附险


        if (res.proposalKindDto != null) {
          for (var j = 0; j < res.proposalKindDto.proposalItemKindDtoList.length; j++) {
            if (res.proposalKindDto.proposalItemKindDtoList[j].kindCode == 999999999) {
              res.proposalKindDto.proposalItemKindDtoList.splice(j, 1);
            } else {
              continue;
            }
          }

          _this17.ProposalKindDto = res.proposalKindDto; // 加成比例

          if (res.pageSelect.insureUpperLimit == null || res.pageSelect.insureUpperLimit == "") {
            _this17.ProposalKindDto.plusRate = res.pageSelect.insureDefault;
            $(".carriagetwo").addClass("putash");
            _this17.whole_carflag = true;
          }

          if (res.proposalKindDto.amount != null) {
            // 根据保额/保费币别判断总保额总保费显示
            // this.ProposalKindDto.sunAmount = res.proposalKindDto.amount
            if (_this17.ProposalKindDto.amountCurrencyCode == "JPY") {
              _this17.ProposalKindDto.sunAmount = toThousands(Math.round(res.proposalKindDto.amount));
            } else {
              _this17.ProposalKindDto.sunAmount = num3_type_fun(res.proposalKindDto.amount);
            }
          }

          if (res.proposalKindDto.premium != null) {
            // this.ProposalKindDto.sumPremium = res.proposalKindDto.premium
            if (_this17.ProposalKindDto.remiumCurrencyCode == "JPY") {
              _this17.ProposalKindDto.sumPremium = toThousands(Math.round(res.proposalKindDto.premium));
            } else {
              _this17.ProposalKindDto.sumPremium = num3_type_fun(res.proposalKindDto.premium);
            }
          }

          _this17.ProposalKindDto.remiumCurrency = res.proposalKindDto.premiumCurrency;
          _this17.ProposalKindDto.remiumCurrencyCode = res.proposalKindDto.premiumCurrencyCode;

          if (res.proposalKindDto.proposalItemKindDtoList != null) {
            // 条款信息列表根据保额/保费币别判断总保额总保费显示
            for (var i = 0; i < res.proposalKindDto.proposalItemKindDtoList.length; i++) {
              if (res.proposalKindDto.proposalItemKindDtoList[i].clauseType == '附加险') {
                _this17.ProposalKindDto.proposalItemKindDtoList[i].amount = '-';
              } else {
                console.log(_this17.ProposalKindDto.amountCurrencyCode);

                if (_this17.ProposalKindDto.amountCurrencyCode == "JPY") {
                  _this17.ProposalKindDto.proposalItemKindDtoList[i].amount = toThousands(Math.round(res.proposalKindDto.proposalItemKindDtoList[i].unitAmount));
                } else {
                  _this17.ProposalKindDto.proposalItemKindDtoList[i].amount = num3_type_fun(res.proposalKindDto.proposalItemKindDtoList[i].unitAmount);
                }
              }

              console.log(_this17.ProposalKindDto.remiumCurrencyCode);

              if (_this17.ProposalKindDto.remiumCurrencyCode == "JPY") {
                _this17.ProposalKindDto.proposalItemKindDtoList[i].premium = toThousands(Math.round(res.proposalKindDto.proposalItemKindDtoList[i].unitPremium));
              } else {
                _this17.ProposalKindDto.proposalItemKindDtoList[i].premium = num3_type_fun(res.proposalKindDto.proposalItemKindDtoList[i].unitPremium);
              }
            }
          }
        } //图片信息


        if (res.proposalImagList != null) {
          for (var i = 0; i < res.proposalImagList.length; i++) {
            var obj = {};
            var formData = new FormData();
            var base64 = 'data:image/png;base64,' + res.proposalImagList[i].base64Src;
            var imagCode = res.proposalImagList[i].imagCode;
            var proposalNo = res.proposalImagList[i].proposalNo;
            var fileSrc = res.proposalImagList[i].fileSrc;
            var fileName = res.proposalImagList[i].fileName; //转换base64到file

            var file = _this17.base64ToFile(base64); // console.log(file)


            formData.append("imageName", file);
            obj.name = fileName;
            obj.raw = file;
            obj["type"] = "old";
            obj["url"] = base64;
            obj["fileSrc"] = fileSrc;
            obj.imagCode = imagCode;
            obj.proposalNo = proposalNo;

            _this17.fileList.push(obj);
          } // console.log(obj)

        }

        _this17.forcollection(); //  待补录判断 是否已有数据


        _this17.loing_box = false; //this.customizationtype() // 获取自定义标的类型
      });
    },
    //  待补录判断 是否已有数据
    forcollection: function forcollection() {
      // 运输信息
      if (this.ProposalConveyanceDto.conveyanceWayCode == null || this.ProposalConveyanceDto.conveyanceWayCode == "") {
        // 运输方式
        this.whole_flagys = false;
      } else {
        this.whole_flagys = true;
      }

      if (this.ProposalConveyanceDto.clinchWayCode == null || this.ProposalConveyanceDto.clinchWayCode == "") {
        //贸易
        this.whole_flagmy = false;
      } else {
        this.whole_flagmy = true;
      }

      if (this.ProposalConveyanceDto.startTime == null || this.ProposalConveyanceDto.startTime == "") {
        //运输时间
        this.whole_flagdate = false;
      } else {
        this.whole_flagdate = true;
      }

      if (this.ProposalConveyanceDto.freight == "" || this.ProposalConveyanceDto.freight == null) {
        // 运费
        this.whole_flagyf1 = false;
      } else {
        this.whole_flagyf1 = true;
      }

      if (this.ProposalConveyanceDto.freightCurrency == "" || this.ProposalConveyanceDto.freightCurrency == null) {
        // 运费
        this.whole_flagyf2 = false;
      } else {
        this.whole_flagyf2 = true;
      } // 标的货物信息


      if (this.ProposalItemDto.packingWayCode == null || this.ProposalItemDto.packingWayCode == "") {
        // 包装
        this.whole_flagbz = false;
      } else {
        this.whole_flagbz = true;
      }

      if (this.ProposalItemDto.isRefrigeRate == null || this.ProposalItemDto.isRefrigeRate == "") {
        // 冷藏
        this.whole_flaglc = false;
      } else {
        this.whole_flaglc = true;
      }

      if (this.ProposalItemDto.isContainer == null || this.ProposalItemDto.isContainer == "") {
        // 集装箱
        this.whole_flagjz = false;
      } else {
        this.whole_flagjz = true;
      }

      if (this.ProposalItemDto.customslistNo == null || this.ProposalItemDto.customslistNo == "") {
        // 报关单号
        this.whole_flagbg = false;
      } else {
        this.whole_flagbg = true;
      }

      if (this.ProposalItemDto.ladingNO == null || this.ProposalItemDto.ladingNO == "") {
        // 提单号
        this.whole_flagtd = false;
      } else {
        this.whole_flagtd = true;
      }

      if (this.ProposalItemDto.invoicNo == null || this.ProposalItemDto.invoicNo == "") {
        // 发票号
        this.whole_flagfp = false;
      } else {
        this.whole_flagfp = true;
      }

      if (this.ProposalItemDto.marks == null || this.ProposalItemDto.marks == "") {
        // 唛头信息
        this.whole_flagst = false;
      } else {
        this.whole_flagst = true;
      }

      if (this.ProposalItemDto.storagePeriod == null || this.ProposalItemDto.storagePeriod == "") {
        // 唛头信息
        this.whole_flagst = false;
      } else {
        this.whole_flagst = true;
      }

      if (this.ProposalItemDto.invoicCurrencyCode == null || this.ProposalItemDto.invoicCurrencyCode == "") {
        // 发票币别
        this.whole_flagfpbb = false;
      } else {
        this.whole_flagfpbb = true;
      } // if(this.ProposalItemDto.reportCode == null || this.ProposalItemDto.reportCode == "") {
      // 	this.text5.reportName = "请输入申报基准"
      // }
      //--  主附险


      if (this.ProposalKindDto.amountCurrencyCode == null || this.ProposalKindDto.amountCurrencyCode == "") {
        // 保额币别
        this.whole_flagbabb = false;
      } else {
        this.whole_flagbabb = true;
      }

      if (this.ProposalKindDto.remiumCurrencyCode == null || this.ProposalKindDto.remiumCurrencyCode == "") {
        // 保费币别
        this.whole_flagbfbb = false;
      } else {
        this.whole_flagbfbb = true;
      }
    },
    base64ToFile: function base64ToFile(data, flie) {
      // 将base64 的图片转换成file对象上传 atob将ascii码解析成binary数据
      var binary = atob(data.split(',')[1]);
      var mime = data.split(',')[0].match(/:(.*?);/)[1];
      var array = [];

      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }

      var fileData = new Blob([new Uint8Array(array)], {
        type: mime
      }); // console.log(fileData)

      var file = new File([fileData], "".concat(new Date().getTime(), ".png"), {
        type: mime
      });
      return file;
    },
    // 自动上传接口，组件逻辑文件是单独处理，单独判断，单独上传
    autoUpload: function autoUpload(file) {
      var _this18 = this;

      this.loing_box = true;
      var formData = new FormData();
      formData.append('proposalNo', this.ProposalMainDto.proposalNo);
      formData.append('protocolNo', this.ProposalMainDto.protocolNo);
      formData.append('insuranceCompanyCode', this.ProposalMainDto.insuranceCompanyCode);
      formData.append('insuranceCompanyName', this.ProposalMainDto.insuranceCompanyName);
      formData.append('files', file.file);
      imageUploads_fun(formData).then(function (res) {
        if (res.rtnCode == "0000") {
          _this18.fileList.forEach(function (item) {
            if (file.file.uid === item.uid) {
              item.fileSrc = res.detailDtoList[0].fileSrc;
              item.imagCode = res.detailDtoList[0].imagCode;
              item.proposalNo = res.detailDtoList[0].proposalNo;
            }
          });

          _this18.$message({
            duration: 3000,
            message: res.data,
            type: 'success'
          });

          $(".el-upload-list__item-status-label").css("display", "block");
          _this18.loing_box = false;
        } else if (res.rtnCode == "8977") {
          _this18.$message({
            duration: 3000,
            message: res.rtnMsg,
            type: 'info'
          });

          _this18.loing_box = false;
        } else {
          _this18.$message({
            duration: 3000,
            message: '没有待上传的影像',
            type: 'error'
          });

          _this18.loing_box = false;
        }
      }, function (res) {
        _this18.loing_box = false;
      });
    },
    //提交图片信息
    submitUpload: function submitUpload() {
      var _thisd = this;

      _thisd.loing_box = true;
      var formData = new FormData();
      var j = 0;
      var newarray = [];
      var isNewlyUploadedFlag = false;
      formData.append('proposalNo', _thisd.ProposalMainDto.proposalNo);
      formData.append('protocolNo', _thisd.ProposalMainDto.protocolNo);
      formData.append('insuranceCompanyCode', _thisd.ProposalMainDto.insuranceCompanyCode);
      formData.append('insuranceCompanyName', _thisd.ProposalMainDto.insuranceCompanyName);

      for (var i = 0; i < this.fileList.length; i++) {
        if (_thisd.fileList[i].raw && _thisd.fileList[i].type != "old") {
          if (j < 10) {
            formData.append('files', this.fileList[i].raw);
            _thisd.fileList[i]['type'] = 'old';
            isNewlyUploadedFlag = true;
          }

          j++;
        }
      }

      console.log(_thisd.fileList); // 有新上传的文件才调用上传接口

      if (isNewlyUploadedFlag) {
        imageUploads_fun(formData).then(function (res) {
          if (res.rtnCode == "0000") {
            var k = 0;

            for (var i = 0; i < _thisd.fileList.length; i++) {
              // console.log(this.fileList)
              if (!_thisd.fileList[i].imagCode && k < 10) {
                _thisd.fileList[i].fileSrc = res.detailDtoList[k].fileSrc;
                _thisd.fileList[i].imagCode = res.detailDtoList[k].imagCode;
                _thisd.fileList[i].proposalNo = res.detailDtoList[k].proposalNo;
                newarray.push(_thisd.fileList[i]);
                k++;
              }
            } // location.reload();


            console.log(newarray.length);

            if (newarray.length > 9) {
              // console.log("00000",this.fileList.length)
              _thisd.submitUpload2();
            } else {
              _thisd.$message({
                duration: 3000,
                message: res.data,
                type: 'success'
              });

              $(".el-upload-list__item-status-label").css("display", "block");
              _thisd.loing_box = false;
            }
          } else {
            _thisd.$message({
              duration: 3000,
              message: '没有待上传的影像',
              type: 'error'
            });

            _thisd.loing_box = false;
          }
        }, function (res) {
          _thisd.loing_box = false;
        });
      }
    },
    submitUpload2: function submitUpload2() {
      var _thist = this;

      _thist.loing_box = true;
      var formData = new FormData();
      formData.append('proposalNo', _thist.ProposalMainDto.proposalNo);
      formData.append('protocolNo', _thist.ProposalMainDto.protocolNo);
      formData.append('insuranceCompanyCode', _thist.ProposalMainDto.insuranceCompanyCode);
      formData.append('insuranceCompanyName', _thist.ProposalMainDto.insuranceCompanyName);

      for (var i = 0; i < _thist.fileList.length; i++) {
        if (_thist.fileList[i].raw && _thist.fileList[i].type != "old") {
          formData.append('files', _thist.fileList[i].raw);
          _thist.fileList[i]['type'] = 'old';
        }
      }

      imageUploads_fun(formData).then(function (res) {
        if (res.rtnCode == "0000") {
          _thist.$message({
            duration: 3000,
            message: res.data,
            type: 'success'
          });

          $(".el-upload-list__item-status-label").css("display", "block");
          var k = 0;

          for (var i = 0; i < _thist.fileList.length; i++) {
            if (!_thist.fileList[i].imagCode) {
              _thist.fileList[i].fileSrc = res.detailDtoList[k].fileSrc;
              _thist.fileList[i].imagCode = res.detailDtoList[k].imagCode;
              _thist.fileList[i].proposalNo = res.detailDtoList[k].proposalNo;
              k++;
            }
          }
        } else {
          _thist.$message({
            duration: 3000,
            message: '没有待上传的影像',
            type: 'error'
          });
        }

        _thist.loing_box = false;
      }, function (res) {
        _thist.loing_box = false;
      });
    },
    httpRequest: function httpRequest(data) {
      this.submitUpload(); //				console.log(data)
      //
      //				let file = data.file
      //
      //
      //				var obj = {
      //					url:"https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
      //					raw: file
      //				}
      //
      //				console.log(obj)
      //
      //				this.fileList.push(obj)
      //				console.log(this.fileList)
      //				let _this = this
      //				let rd = new FileReader() // 创建文件读取对象
      //				let file = data.file
      //				rd.readAsDataURL(file) // 文件读取装换为base64类型
      //				rd.onloadend = function(e) {
      //					_this.data.imageUrl = this.result // this指向当前方法onloadend的作用域
      //				}
    },
    //图片上传成功后
    success_img: function success_img(response, file, fileList) {
      console.log(file);
      this.fileList = fileList;
    },
    //图片删除时
    handleRemove: function handleRemove(file, fileList) {
      var _this19 = this;

      var formData = new FormData();
      var objimg = {
        detailDtoList: [{
          imagCode: file.imagCode,
          proposalNo: file.proposalNo
        }]
      };
      imageUploads_del(objimg).then(function (res) {
        _this19.fileList = fileList;
      });
    },
    // 下载文件
    look_img: function look_img(file) {
      // console.log(file,"***********************")
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
      if (file.fileSrc) {
        var data = {
          fileSrc: file.fileSrc
        };
        excleCargoDownload_biaodi(data).then(function (res) {
          var blob = new Blob([res], {
            type: ""
          });
          var url = window.URL.createObjectURL(blob);
          console.log(url);
          var link = document.createElement("a"); // 创建a标签

          link.href = url;
          link.download = file.name; // 重命名文件

          link.click();
          URL.revokeObjectURL(url); // 释放内存
        });
      }
    },
    //图片上传时
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      // console.log(file)
      this.fileList.push(file); //				var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      //
      //				const extension =
      //					testmsg === "jpg" ||
      //					testmsg === "JPG" ||
      //					testmsg === "png" ||
      //					testmsg === "PNG" ||
      //					testmsg === "bpm" ||
      //					testmsg === "BPM";
      //				const isLtM = file.size / 1024 / 1024 < 1;
      //
      //				if(!extension) {
      //					this.$message({
      //						message: "上传图片只能是jpg / png / bpm格式!",
      //						type: "error"
      //					});
      //					return false; //必须加上return false; 才能阻止
      //				}
      //
      //				if(!isLtM) {
      //					this.$message({
      //						message: "上传文件大小不能超过 1MB!",
      //						type: "error"
      //					});
      //					return false;
      //				}
      //				return extension || isLtM;
    },
    handleClick: function handleClick(tab, event) {// console.log(tab, event);
    },
    //关闭
    close_insurance: function close_insurance() {},
    // 判断上传影像文件类型
    beforeUploadimg: function beforeUploadimg(file) {
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isDuplicate = false; // 判断文件名是否重复

      this.fileList.forEach(function (item) {
        if (file.name === item.name && file.uid !== item.uid) {
          isDuplicate = true;
        }
      });

      if (isDuplicate) {
        this.fileList = this.fileList.filter(function (item) {
          return !(file.uid === item.uid);
        });
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
        return false;
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
        return false;
      }

      if (this.fileList.length > 20) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
        return false;
      }

      return true;
    },
    // 获取加成比例与申报基准
    // bonusproportion() {
    // 	var data = {
    // 		protocolNo: this.$route.params.protocolNo,
    // 		riskCode: this.$route.params.riskCode
    // 	};
    //
    // 	proportion_bonus(data).then(res => {
    //
    // 		// var plk = {
    // 		// 	label: "请选择",
    // 		// 	value: ""
    // 		// }
    // 		// this.reportName_option = [plk]
    //
    // 		// 申报基准
    // 		for(var i = 0; i < res.reportCodeList.length; i++){
    // 			var obj = {};
    // 			obj.value = res.reportCodeList[i].codeCode
    // 			obj.label = res.reportCodeList[i].codeCname
    //
    // 			this.reportName_option.push(obj)
    // 		}
    //
    // 		// 加成比例
    // 		if(res.insureUpperLimit == null || res.insureUpperLimit == ""){
    // 			this.ProposalKindDto.plusRate = res.insureDefault
    //
    // 			$(".carriagetwo").addClass("putash")
    // 			this.whole_carflag = true
    // 		}else{
    // 			// this.ProposalKindDto.plusRate = res.insureDefault
    //
    // 			// $(".carriagetwo").removeClass("putash")
    // 			// this.whole_carflag = false
    // 		}
    //
    //
    // 		// this.loing_box = false
    // 	})
    // },
    // 根据协议号查询币种等信息
    moneytransport: function moneytransport() {
      var _this20 = this;

      var data = {
        protocolNo: this.$route.params.protocolNo,
        riskCode: this.$route.params.riskCode
      };
      transport_money(data).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          // 保额
          if (res[i].type == "amountCurrency") {
            // console.log('111',res)
            var plk = {
              label: "请选择",
              value: ""
            };
            _this20.becurrency_option = [plk];

            for (var k = 0; k < res[i].codeList.length; k++) {
              var obj = {};
              obj.value = res[i].codeList[k].code;
              obj.label = res[i].codeList[k].codeName + ' - ' + obj.value;

              _this20.becurrency_option.push(obj);
            }
          } // 判断是否为自定义标的类型


          if (res[i].type == "isOpen") {
            if (res[i].isOpen == null || res[i].isOpen == "0" || res[i].isOpen == "") {
              console.log("非自定义标的类型");
              _this20.customtarget = true;
              _this20.customtarget2 = false;
              _this20.updatemb = true;
            } else {
              _this20.customtarget = false;
              _this20.customtarget2 = true;
              _this20.updatemb = false;
            }
          }
        }
      });
    },
    //选择协议被保险人---开启
    open_insured: function open_insured() {
      this.dialogFormVisible = true;
      this.findInsuredByConditions_fun();
    },
    //被保险人弹框集合
    findInsuredByConditions_fun: function findInsuredByConditions_fun() {
      var _this21 = this;

      var data = {
        "idEntifyTypeCode": "",
        "identifyNumber": this.dialogFormVisible_obj.identifyNumber,
        "idEntifyTypeName": "",
        "insuredName": this.dialogFormVisible_obj.insuredName,
        "insuredType": "2",
        "pageNo": this.insured_pageNo,
        "pageSize": this.insured_pageSize,
        "protocolNo": this.ProposalMainDto.protocolNo
      };
      findInsuredByConditions(data).then(function (res) {
        // console.log(res,'*******')
        for (var i = 0; i < res.content.length; i++) {
          if (res.content[i].idEntifyTypeCode == "1") {
            res.content[i].idEntifyTypeName = "组织机构代码证";
          } else if (res.content[i].idEntifyTypeCode == "2") {
            res.content[i].idEntifyTypeName = "税务登记证";
          } else if (res.content[i].idEntifyTypeCode == "3") {
            res.content[i].idEntifyTypeName = "营业执照";
          } else if (res.content[i].idEntifyTypeCode == "8") {
            res.content[i].idEntifyTypeName = "工商注册号码";
          } else if (res.content[i].idEntifyTypeCode == "9") {
            res.content[i].idEntifyTypeName = "其他证件";
          } else if (res.content[i].idEntifyTypeCode == "10") {
            res.content[i].idEntifyTypeName = "统一社会信用代码";
          }
        } // console.log(res,'2************')


        _this21.tableData = res.content;
        _this21.total_bel = res.totalCount;
      });
    },
    //协议被保险人集合
    findInsuredByConditions_fun1: function findInsuredByConditions_fun1() {
      var _this22 = this;

      var data = {
        "idEntifyTypeCode": "",
        "identifyNumber": this.dialogFormVisible_obj.identifyNumber,
        "idEntifyTypeName": "",
        "insuredName": this.dialogFormVisible_obj.insuredName,
        "insuredType": "2",
        "pageNo": this.insured_pageNo,
        "pageSize": this.insured_pageSize,
        "protocolNo": this.ProposalMainDto.protocolNo
      };
      return new Promise(function (resolve, reject) {
        findInsuredByConditions(data).then(function (res) {
          for (var i = 0; i < res.content.length; i++) {
            if (res.content[i].idEntifyTypeCode == "1") {
              res.content[i].idEntifyTypeName = "组织机构代码证";
            } else if (res.content[i].idEntifyTypeCode == "2") {
              res.content[i].idEntifyTypeName = "税务登记证";
            } else if (res.content[i].idEntifyTypeCode == "3") {
              res.content[i].idEntifyTypeName = "营业执照";
            } else if (res.content[i].idEntifyTypeCode == "8") {
              res.content[i].idEntifyTypeName = "工商注册号码";
            } else if (res.content[i].idEntifyTypeCode == "9") {
              res.content[i].idEntifyTypeName = "其他证件";
            } else if (res.content[i].idEntifyTypeCode == "10") {
              res.content[i].idEntifyTypeName = "统一社会信用代码";
            }
          }

          _this22.tableData = res.content;
          resolve(_this22.tableData);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      this.insured_pageSize = val;
      this.findInsuredByConditions_fun();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
      this.insured_pageNo = val;
      this.findInsuredByConditions_fun();
    },
    search_but: function search_but() {
      this.findInsuredByConditions_fun();
    },
    //选择协议被保险人---关闭
    handleClose: function handleClose() {
      this.dialogFormVisible = false;
      this.radio1 = null;
      this.content = {};
      this.carShowFlag = false;
      this.buttonShowFlag = false;
    },
    //选择协议被保险人-- 选择
    select_radio: function select_radio(val, row) {
      console.log(row);
      this.content = row.row;
    },
    handleClose_cont: function handleClose_cont() {
      if (this.radio1 == null) {
        this.$message({
          message: '请选择一条信息',
          type: 'warning'
        });
        return;
      }

      this.ProposalInsuredDto.insuredName = this.content.insuredName;
      this.ProposalInsuredDto.insuredEnName = this.content.insuredEnName;
      this.ProposalInsuredDto.identifyType = this.content.idEntifyTypeCode;
      this.ProposalInsuredDto.identifyTypeName = this.content.idEntifyTypeName;
      this.ProposalInsuredDto.insuredCode = this.content.insuredCode;
      this.ProposalInsuredDto.identifyNumber = this.content.identifyNumber;
      this.ProposalInsuredDto.address = this.content.address;
      this.ProposalInsuredDto.email = this.content.email;
      this.ProposalInsuredDto.phone = this.content.phone;
      this.ProposalInsuredDto.nationalFlag = this.content.nationalFlag;
      this.dialogFormVisible = false;
    },
    //选择船舶信息-- 选择
    select_radio_s: function select_radio_s(val, row) {
      console.log(row);
      this.select_radio_s_obj = row;
    },
    //选择船舶信息-- 确定
    dialogFormVisible2_submit: function dialogFormVisible2_submit() {
      var _this23 = this;

      if (this.radio2 == null) {
        this.$message({
          message: '请选择一条信息',
          type: 'warning'
        });
        return;
      } // console.log('this.select_radio_s_obj',this.select_radio_s_obj)


      var index = this.ship_index;
      var qystartTime = this.ProposalConveyanceDto.startTime.substring(0, 4); // 起运日期

      this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].blName = this.select_radio_s_obj.row.nameEn;

      if (this.select_radio_s_obj.row.classSocietyNameCn !== null && this.select_radio_s_obj.row.classSociety !== null) {
        this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassCode = this.select_radio_s_obj.row.classSociety;
        this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassName = this.select_radio_s_obj.row.classSocietyNameCn;
        this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].nShipClassCode = this.select_radio_s_obj.row.nClassSociety;
      } else {
        this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassCode = '';
        this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassName = '';
      }

      if (this.select_radio_s_obj.row.vesselSubTypeNameCn !== null && this.select_radio_s_obj.row.vesselSubType !== null) {
        this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypesCode = this.select_radio_s_obj.row.vesselSubType;
        this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypes = this.select_radio_s_obj.row.vesselSubTypeNameCn; // 如果code没有映射成功，清空

        var existingOption = this.shipTypes_option.find(function (option) {
          return option.value === _this23.select_radio_s_obj.row.vesselSubType;
        });

        if (!existingOption) {
          this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypesCode = '';
          this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypes = '';
        }
      } else {
        this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypesCode = '';
        this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypes = '';
      }

      if (this.select_radio_s_obj.row.vesselAge !== null) {
        this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = this.select_radio_s_obj.row.vesselAge;
      } else {
        this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = '';
      } // YCKK-1376 船舶接口调用之后航次字段前端不赋值优化
      // if(this.select_radio_s_obj.row.voyage !== null ){
      //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].voyageNo = this.select_radio_s_obj.row.voyage
      // }else {
      //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].voyageNo = ''
      // }
      // if(this.select_radio_s_obj.row.classSocietyName !== null && this.select_radio_s_obj.row.classSociety !== null){
      //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassName = this.select_radio_s_obj.row.classSocietyName
      //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassCode = this.select_radio_s_obj.row.classSociety
      // }else {
      //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassName = ''
      //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassCode = ''
      // }
      //
      // this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypes = this.select_radio_s_obj.row.vesselSubTypeNameCn
      // this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypesCode = this.select_radio_s_obj.row.vesselSubType
      // if(qystartTime == this.select_radio_s_obj.row.buildYear){
      // 	this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = '1'
      // }else{
      //   if(undefined == this.select_radio_s_obj.row.buildYear
      //       || null == this.select_radio_s_obj.row.buildYear
      //       || this.select_radio_s_obj.row.buildYear.length === 0){
      //     this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = ''
      //   }else {
      //     this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = '' + (qystartTime - this.select_radio_s_obj.row.buildYear)
      //   }
      // }


      this.dialogFormVisible2 = false;
      $('.shipClassCode').eq(index).find('input').css({
        'border': '1px solid #e4e7ed'
      });
      $('.shipTypesCode').eq(index).find('input').css({
        'border': '1px solid #e4e7ed'
      });
      $('.vessel').eq(index).find('input').css({
        'border': '1px solid #e4e7ed'
      });
    },
    //船舶信息
    ship_box: function ship_box(scope) {
      this.ship_index = scope.$index;
      this.radio2 = null;
      this.select_radio_s_obj = {}; // console.log(scope)
      // console.log(this.ProposalConveyanceDto.conveyanceWayCode)

      if (this.ProposalConveyanceDto.conveyanceWayCode == '3' || this.ProposalConveyanceDto.conveyanceWayCode == "8" || this.ProposalConveyanceDto.conveyanceWayCode == "10") {
        if (this.ProposalConveyanceDto.proposalConveyanceListDtoList != "") {
          console.log(this.ProposalConveyanceDto.proposalConveyanceListDtoList, '000');

          if (this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].blName == null || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].blName == "") {
            this.$message({
              message: '请输入船名 / 航班号 / 车牌号 / 其他运输工具',
              type: 'warning'
            });
            return;
          }

          var transportname = this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].blName;
          console.log('transportname111==', this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index]);
          console.log('transportname==', transportname);
          this.port_ship(transportname);
        } else {
          this.tableData_ship = [];
          this.dialogFormVisible2 = true;
        }
      } else {
        this.tableData_ship = [];
        this.dialogFormVisible2 = true;
      }
    },
    //运输信息添加
    add_transport: function add_transport() {
      var length = this.ProposalConveyanceDto.proposalConveyanceListDtoList.length;
      var obj = {
        voyageNumber: length + 1,
        startSiteCountryCode: "",
        startSiteCountryName: '',
        startSiteCityCode: '',
        startSiteCityName: '',
        city_option1: '',
        endSiteCountryCode: '',
        endSiteCountryName: '',
        endSiteCityCode: '',
        endSiteCityName: '',
        blName: '',
        voyageNo: '',
        shipClassCode: '',
        shipClassName: '',
        shipTypesCode: '',
        shipTypes: '',
        vessel: ''
      };

      if (length > 0) {
        obj.startSiteCountryCode = this.ProposalConveyanceDto.proposalConveyanceListDtoList[length - 1].endSiteCountryCode;
        obj.startSiteCountryName = this.ProposalConveyanceDto.proposalConveyanceListDtoList[length - 1].endSiteCountryName;
        obj.startSiteCityCode = this.ProposalConveyanceDto.proposalConveyanceListDtoList[length - 1].endSiteCityCode;
        obj.startSiteCityName = this.ProposalConveyanceDto.proposalConveyanceListDtoList[length - 1].endSiteCityName;

        if (this.ProposalConveyanceDto.proposalConveyanceListDtoList[length - 1].endSiteCountryCode == 'CHN') {
          var list1 = getCHNCity();
          var arr1 = [];

          for (var k = 0; k < list1.length; k++) {
            var obj1 = {};
            obj1.value = list1[k].codeCode;
            obj1.label = list1[k].codeCname;
            arr1.push(obj1);
          }

          obj.city_option1 = arr1;
        } else {
          var list1 = getUnderCity(this.ProposalConveyanceDto.proposalConveyanceListDtoList[length - 1].endSiteCountryCode);
          var arr1 = [];

          for (var k = 0; k < list1.length; k++) {
            var obj1 = {};
            obj1.value = list1[k].codeCode;
            obj1.label = list1[k].codeCname;
            arr1.push(obj1);
          }

          obj.city_option1 = arr1;
        }
      }

      this.ProposalConveyanceDto.proposalConveyanceListDtoList.push(obj);
      console.log(this.ProposalConveyanceDto.proposalConveyanceListDtoList);
    },
    //运输信息添加
    del_transport: function del_transport(index) {
      this.ProposalConveyanceDto.proposalConveyanceListDtoList.splice(index, 1);
      var length = this.ProposalConveyanceDto.proposalConveyanceListDtoList.length;

      for (var k = 0; k < length; k++) {
        this.ProposalConveyanceDto.proposalConveyanceListDtoList[k].voyageNumber = k + 1;
      }
    },
    //下载模板
    download_tem: function download_tem() {
      var data_s = {
        "fileDownloadType": "1"
      };
      getPath_biaodi(data_s).then(function (res_s) {
        var data = {
          fileSrc: res_s.fileSrc //						                        fileSrc: 'D://货运清单.xlsx'

        };
        excleCargoDownload_biaodi(data).then(function (res) {
          //							window.location.href ='http://localhost:9528/api/commondictionary/file/download?fileSrc=' + data.fileSrc
          //						const blob = new Blob([res], {
          //							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
          //						});
          //
          //						const fileName = '货运清单.xlsx';
          //						if('download' in document.createElement('a')) { // 非IE下载
          //
          //							const elink = document.createElement('a');
          //							elink.download = fileName;
          //							elink.style.display = 'none';
          //
          //							elink.href = URL.createObjectURL(blob);
          //							console.log(elink)
          //							document.body.appendChild(elink);
          //							elink.click();
          //							URL.revokeObjectURL(elink.href); // 释放URL 对象
          //							document.body.removeChild(elink);
          //						} else { // IE10+下载
          //							navigator.msSaveBlob(blob, fileName);
          //						}
          var blob = new Blob([res], {
            type: "application/vnd.ms-excel"
          });
          console.log(blob);
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement("a"); // 创建a标签

          link.href = url;
          link.download = "货运清单.xlsx"; // 重命名文件

          link.click();
          URL.revokeObjectURL(url); // 释放内存
        });
      });
    },
    //上传清单
    upload_tem: function upload_tem() {
      this.dialogFormVisible1 = true;

      if (this.ProposalItemDto.proposalItemCargoDtoList == '') {
        this.fileList_exlc = [];
      }
    },
    //手动添加清单
    add_tem: function add_tem(row) {
      this.matter_flag = row;
      this.dialogFormVisible3 = true;
      this.buttonShowFlag = true;
      this.itemDisabled = false;
      this.proposalItemCargoDto_obj = {}; //				var length = this.ProposalItemDto.proposalItemCargoDtoList.length
      //				this.proposalItemCargoDto_obj = {
      //					itemType: '',
      //					cargoCode: '',
      //					cargoName: '',
      //					cargoEnName: '',
      //					quantity: '',
      //					isNewOrOld: '',
      //					unit: '',
      //					unitAmount: '',
      //					totalAmount: '',
      //					serialNo: length + 1
      //				}
      //
    },
    //删除标的信息
    delect_matter: function delect_matter(index) {
      this.ProposalItemDto.proposalItemCargoDtoList.splice(index, 1); //YCKK-1399 投保申请页面-多条标的删除后新增序号异常问题修复

      this.ProposalItemDto.proposalItemCargoDtoList.forEach(function (ele, key) {
        ele.serialNo = key + 1;
      });
      this.invoicAmountsum_fun();
    },
    //查看标的信息
    view_matter: function view_matter(row) {
      this.itemDisabled = true;
      this.isDisabled = true;
      this.matter_flag = row;
      this.buttonShowFlag = false;
      this.dialogFormVisible3 = true;
      this.matter_index = row.$index;
      this.proposalItemCargoDto_obj = deepcopy(row.row);

      if (typeof this.proposalItemCargoDto_obj.unitAmount == "string") {
        this.proposalItemCargoDto_obj.unitAmount = parseFloat(this.proposalItemCargoDto_obj.unitAmount.replace(/,/g, ""));
        console.log(this.proposalItemCargoDto_obj.unitAmount, "dj");
      } else {
        this.proposalItemCargoDto_obj.unitAmount = this.proposalItemCargoDto_obj.unitAmount;
      }

      if (typeof this.proposalItemCargoDto_obj.totalAmount == "string") {
        this.proposalItemCargoDto_obj.totalAmount = parseFloat(this.proposalItemCargoDto_obj.totalAmount.replace(/,/g, ""));
        console.log(this.proposalItemCargoDto_obj.totalAmount, "zj");
      } else {
        this.proposalItemCargoDto_obj.totalAmount = this.proposalItemCargoDto_obj.totalAmount;
      }

      if (this.proposalItemCargoDto_obj.itemType == 'J01') {
        this.carShowFlag = true;
      } else {
        this.carShowFlag = false;
        this.proposalItemCargoDto_obj.vehicleModel = '';
        this.proposalItemCargoDto_obj.chassisNumber = '';
        this.proposalItemCargoDto_obj.engineNumber = '';
        this.proposalItemCargoDto_obj.vehiclePrice = '';
      }

      this.$refs['proposalItemCargoDto_obj'].resetFields();
    },
    //标的信息修改
    edit_matter: function edit_matter(row) {
      this.buttonShowFlag = true;
      this.itemDisabled = false;
      this.matter_flag = row;
      this.isDisabled = false;
      this.dialogFormVisible3 = true;
      this.matter_index = row.$index;
      this.proposalItemCargoDto_obj = deepcopy(row.row);

      if (typeof this.proposalItemCargoDto_obj.unitAmount == "string") {
        this.proposalItemCargoDto_obj.unitAmount = parseFloat(this.proposalItemCargoDto_obj.unitAmount.replace(/,/g, ""));
        console.log(this.proposalItemCargoDto_obj.unitAmount, "dj");
      } else {
        this.proposalItemCargoDto_obj.unitAmount = this.proposalItemCargoDto_obj.unitAmount;
      }

      if (typeof this.proposalItemCargoDto_obj.totalAmount == "string") {
        this.proposalItemCargoDto_obj.totalAmount = parseFloat(this.proposalItemCargoDto_obj.totalAmount.replace(/,/g, ""));
        console.log(this.proposalItemCargoDto_obj.totalAmount, "zj");
      } else {
        this.proposalItemCargoDto_obj.totalAmount = this.proposalItemCargoDto_obj.totalAmount;
      }

      if (this.proposalItemCargoDto_obj.itemType == 'J01') {
        this.carShowFlag = true;
      } else {
        this.carShowFlag = false;
        this.proposalItemCargoDto_obj.vehicleModel = '';
        this.proposalItemCargoDto_obj.chassisNumber = '';
        this.proposalItemCargoDto_obj.engineNumber = '';
        this.proposalItemCargoDto_obj.vehiclePrice = '';
      }

      this.$refs['proposalItemCargoDto_obj'].resetFields();
    },
    //标的hscode 或 商品名称中带有旧”、“废”、“回收”、“二手”
    hscode_cargoName: function hscode_cargoName() {
      if (this.proposalItemCargoDto_obj.cargoCode != "") {
        if (this.proposalItemCargoDto_obj.cargoCode.indexOf('旧') != -1 || this.proposalItemCargoDto_obj.cargoCode.indexOf('废') != -1 || this.proposalItemCargoDto_obj.cargoCode.indexOf('回收') != -1) {
          this.proposalItemCargoDto_obj.isNewOrOld = "02";
        }
      }

      if (this.proposalItemCargoDto_obj.cargoName != "") {
        if (this.proposalItemCargoDto_obj.cargoName.indexOf('旧') != -1 || this.proposalItemCargoDto_obj.cargoName.indexOf('废') != -1 || this.proposalItemCargoDto_obj.cargoName.indexOf('回收') != -1 || this.proposalItemCargoDto_obj.cargoName.indexOf('二手') != -1) {
          this.proposalItemCargoDto_obj.isNewOrOld = "02";
        }
      }
    },
    //标的信息 ---确定
    dialogFormVisible3_submit: function dialogFormVisible3_submit(formName) {
      var _this24 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          debugger; // this.hscode_cargoName()
          // 涉及 计算0.57或0.58时精度问题

          if (_this24.proposalItemCargoDto_obj.unitAmount == 0.57) {
            _this24.proposalItemCargoDto_obj.unitAmount = parseFloat(_this24.proposalItemCargoDto_obj.unitAmount) + 0.000001;
          } else if (_this24.proposalItemCargoDto_obj.unitAmount == 0.58) {
            _this24.proposalItemCargoDto_obj.unitAmount = parseFloat(_this24.proposalItemCargoDto_obj.unitAmount) + 0.000001;
          } else {
            _this24.proposalItemCargoDto_obj.unitAmount = _this24.proposalItemCargoDto_obj.unitAmount;
          }

          if (_this24.proposalItemCargoDto_obj.totalAmount == 0.57) {
            _this24.proposalItemCargoDto_obj.totalAmount = parseFloat(_this24.proposalItemCargoDto_obj.totalAmount) + 0.000001;
          } else if (_this24.proposalItemCargoDto_obj.totalAmount == 0.58) {
            _this24.proposalItemCargoDto_obj.totalAmount = parseFloat(_this24.proposalItemCargoDto_obj.totalAmount) + 0.000001;
          } else {
            _this24.proposalItemCargoDto_obj.totalAmount = _this24.proposalItemCargoDto_obj.totalAmount;
          }

          console.log('确定---------------1');
          console.log(_this24.proposalItemCargoDto_obj.cargoEnName);
          console.log(_this24.proposalItemCargoDto_obj.cargoName);

          if (_this24.proposalItemCargoDto_obj.cargoEnName == '' && _this24.proposalItemCargoDto_obj.cargoName == '') {
            _this24.cofirmBox('商品中文名称和商品英文名称必录其一');

            return false;
          }

          _this24.dialogFormVisible3 = false;

          if (_this24.matter_flag != "") {
            console.log('matter_flag1=' + _this24.matter_flag);
            console.log(_this24.proposalItemCargoDto_obj);
            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].cargoEnName = _this24.proposalItemCargoDto_obj.cargoEnName;
            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].cargoName = _this24.proposalItemCargoDto_obj.cargoName;
            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].isNewOrOld = _this24.proposalItemCargoDto_obj.isNewOrOld;
            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].quantity = _this24.proposalItemCargoDto_obj.quantity; // 当录入时单价总价自动转换为千分位

            if (_this24.ProposalItemDto.invoicCurrencyCode == "JPY") {
              _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].totalAmount = toThousands(Math.round(_this24.proposalItemCargoDto_obj.totalAmount));
              _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].unitAmount = toThousands(Math.round(_this24.proposalItemCargoDto_obj.unitAmount));
            } else {
              _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].totalAmount = num5_type_fun(_this24.proposalItemCargoDto_obj.totalAmount);
              _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].unitAmount = num4_type_fun(_this24.proposalItemCargoDto_obj.unitAmount);
            }

            if (_this24.proposalItemCargoDto_obj.itemType != 'J01') {
              _this24.proposalItemCargoDto_obj.vehicleModel = '';
              _this24.proposalItemCargoDto_obj.chassisNumber = '';
              _this24.proposalItemCargoDto_obj.engineNumber = '';
              _this24.proposalItemCargoDto_obj.vehiclePrice = '';
            }

            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].unit = _this24.proposalItemCargoDto_obj.unit;
            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].unitName = _this24.proposalItemCargoDto_obj.unitName;
            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].itemType = _this24.proposalItemCargoDto_obj.itemType;
            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].itemTypeName = _this24.proposalItemCargoDto_obj.itemTypeName; //标的类型显示名称，不往后端传递

            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].cargoCode = _this24.proposalItemCargoDto_obj.cargoCode;
            console.log('-----------------------------------');
            console.log(_this24.proposalItemCargoDto_obj.vehicleModel);
            console.log(_this24.proposalItemCargoDto_obj.chassisNumber);
            console.log(_this24.proposalItemCargoDto_obj.engineNumber);
            console.log(_this24.proposalItemCargoDto_obj.vehiclePrice);
            console.log('-----------------------------------');
            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].vehicleModel = _this24.proposalItemCargoDto_obj.vehicleModel;
            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].chassisNumber = _this24.proposalItemCargoDto_obj.chassisNumber;
            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].engineNumber = _this24.proposalItemCargoDto_obj.engineNumber;
            _this24.ProposalItemDto.proposalItemCargoDtoList[_this24.matter_index].vehiclePrice = _this24.proposalItemCargoDto_obj.vehiclePrice;
            console.log(_this24.ProposalItemDto.proposalItemCargoDtoList);
          } else {
            var length = _this24.ProposalItemDto.proposalItemCargoDtoList.length;
            _this24.proposalItemCargoDto_obj.serialNo = length + 1;
            _this24.proposalItemCargoDto_obj.totalAmount = num5_type_fun(_this24.proposalItemCargoDto_obj.totalAmount);
            _this24.proposalItemCargoDto_obj.unitAmount = num4_type_fun(_this24.proposalItemCargoDto_obj.unitAmount);
            _this24.proposalItemCargoDto_obj.quantity = num4_type_fun(_this24.proposalItemCargoDto_obj.quantity);

            _this24.ProposalItemDto.proposalItemCargoDtoList.push(_this24.proposalItemCargoDto_obj);
          }

          _this24.proposalItemCargoDto_obj = {
            itemType: '',
            itemTypeName: '',
            cargoCode: '',
            cargoCodeName: '',
            cargoName: '',
            cargoEnName: '',
            quantity: '',
            isNewOrOld: '',
            unit: '',
            unitAmount: '0.00',
            totalAmount: '0.00'
          };

          _this24.$nextTick(function () {
            _this24.$refs['proposalItemCargoDto_obj'].clearValidate();
          });

          _this24.invoicAmountsum_fun();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 标的取消
    subjectcancel: function subjectcancel() {
      var _this25 = this;

      this.dialogFormVisible3 = false;
      this.proposalItemCargoDto_obj = {
        itemType: '',
        itemTypeName: '',
        cargoCode: '',
        cargoCodeName: '',
        cargoName: '',
        cargoEnName: '',
        quantity: '',
        isNewOrOld: '',
        unit: '',
        unitAmount: '0.00',
        totalAmount: '0.00'
      };
      this.$nextTick(function () {
        _this25.$refs['proposalItemCargoDto_obj'].clearValidate();
      });
      this.carShowFlag = false;
    },
    //展开/显示
    but_toggle: function but_toggle() {
      //				console.log()
      this.is_goods = !this.is_goods;
    },
    //保存----保障责任信息
    preservation_but: function preservation_but() {
      if (this.index_6 != null) {
        this.ProposalKindDto.proposalItemKindDtoList[this.index_6].amount = num3_type_fun(this.ProposalItemKindDto_obj.amount); // this.ProposalKindDto.proposalItemKindDtoList[this.index_6].clauseType = this.ProposalItemKindDto_obj.clauseType
        // this.ProposalKindDto.proposalItemKindDtoList[this.index_6].kindcode = this.ProposalItemKindDto_obj.kindcode
        // this.ProposalKindDto.proposalItemKindDtoList[this.index_6].premium = this.ProposalItemKindDto_obj.premium
        // this.ProposalKindDto.proposalItemKindDtoList[this.index_6].remark = this.ProposalItemKindDto_obj.remark
        // this.ProposalKindDto.proposalItemKindDtoList[this.index_6].riskcode = this.ProposalItemKindDto_obj.riskcode

        this.box_6 = false;
      }

      this.box_6edit = false;
    },
    //取消----保障责任信息
    cancel_but: function cancel_but() {
      this.box_6 = false;
      this.box_6edit = false;
    },
    //---修改/浏览----保障责任信息      modify -- 修改       view  浏览  syn -- 同步
    modify_view_6: function modify_view_6(row, type) {
      // console.log(row)
      if (type === 'view') {
        this.index_6 = row.$index;
        this.ProposalItemKindDto_obj = deepcopy(row.row);
        this.tableData_hw = deepcopy(row.row.policyItemCargoDtoList);
        this.disabled_6 = true;
        this.box_6edit = false;
      } else if (type === 'syn') {
        this.ProposalItemKindDto_obj = deepcopy(this.ProposalKindDto.proposalItemKindDtoList[row]);
        this.tableData_hw = deepcopy(this.ProposalKindDto.proposalItemKindDtoList[row].policyItemCargoDtoList);
        this.disabled_6 = true;
      } else if (type === 'modify') {
        this.index_6 = row.$index;
        this.ProposalItemKindDto_obj = deepcopy(row.row);
        this.tableData_hw = deepcopy(row.row.policyItemCargoDtoList);
        this.disabled_6 = false;
        this.box_6edit = true;
      }

      this.box_6 = true;
      this.box_hwqd = true;
      this.is_goods = true;

      if (type === 'view' && row.row.policyItemCargoDtoList == undefined || type === 'syn' && this.ProposalKindDto.proposalItemKindDtoList[row].policyItemCargoDtoList == undefined) {
        this.tableData_hw = this.ProposalItemDto.proposalItemCargoDtoList;

        for (var i = 0; i < this.ProposalItemDto.proposalItemCargoDtoList.length; i++) {
          // console.log("11111111",this.ProposalItemDto.proposalItemCargoDtoList)
          // this.tableData_hw[i].amount = this.ProposalItemDto.proposalItemCargoDtoList[i].carGoAmount
          // this.tableData_hw[i].premium = this.ProposalItemDto.proposalItemCargoDtoList[i].carGoPremium
          if (this.ProposalItemKindDto_obj.clauseType == '附加险') {
            this.tableData_hw[i].amount = '-';
          } else {
            if (this.ProposalKindDto.amountCurrencyCode == "JPY") {
              this.tableData_hw[i].amount = toThousands(Math.round(this.ProposalItemDto.proposalItemCargoDtoList[i].carGoAmount));
            } else {
              this.tableData_hw[i].amount = num3_type_fun(this.ProposalItemDto.proposalItemCargoDtoList[i].carGoAmount);
            }
          }

          if (this.ProposalKindDto.remiumCurrencyCode == "JPY") {
            this.tableData_hw[i].premium = toThousands(Math.round(this.ProposalItemDto.proposalItemCargoDtoList[i].carGoPremium));
          } else {
            this.tableData_hw[i].premium = num3_type_fun(this.ProposalItemDto.proposalItemCargoDtoList[i].carGoPremium);
          }
        }
      } else {
        for (var i = 0; i < this.tableData_hw.length; i++) {
          if (this.ProposalItemKindDto_obj.clauseType == '附加险') {
            this.tableData_hw[i].amount = '-';
          } else {
            if (this.ProposalKindDto.amountCurrencyCode == "JPY") {
              this.tableData_hw[i].amount = toThousands(Math.round(this.tableData_hw[i].amount));
            } else {
              this.tableData_hw[i].amount = num3_type_fun(this.tableData_hw[i].amount);
            }
          }

          if (this.ProposalKindDto.remiumCurrencyCode == "JPY") {
            this.tableData_hw[i].premium = toThousands(Math.round(this.tableData_hw[i].premium));
          } else {
            this.tableData_hw[i].premium = num3_type_fun(this.tableData_hw[i].premium);
          } // 总价


          if (this.tableData_hw[i].totalAmount != null) {
            if (this.ProposalItemDto.invoicCurrencyCode == "JPY") {
              this.tableData_hw[i].totalAmount = toThousands(Math.round(this.tableData_hw[i].totalAmount));
            } else {
              this.tableData_hw[i].totalAmount = num5_type_fun(this.tableData_hw[i].totalAmount);
            }
          }
        }
      }

      if (this.ProposalItemKindDto_obj.clauseType == '附加险') {
        if (this.ProposalItemKindDto_obj.editFlag) {
          this.ProposalItemKindDto_obj.amount = parseFloat(this.ProposalItemKindDto_obj.amount.replace(/,/g, ''));
        } else {
          this.ProposalItemKindDto_obj.amount = '-';
        }
      } else {
        if (this.ProposalKindDto.amountCurrencyCode == "JPY") {
          // console.log(this.ProposalItemKindDto_obj.amount,'0000000000')
          this.ProposalItemKindDto_obj.amount = toThousands(Math.round(this.ProposalItemKindDto_obj.amount.replace(/,/g, "")));
        } else {
          this.ProposalItemKindDto_obj.amount = num3_type_fun(this.ProposalItemKindDto_obj.amount.replace(/,/g, ""));
        }
      }
    },
    //删除----保障责任信息
    del_6: function del_6(index) {
      this.tableData.splice(index, 1);
    },
    //保存----特别约定信息
    especially_but: function especially_but(formName) {
      var _this26 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this26.box_7_flag == "1") {
            for (var k = 0; k < _this26.ProposalEngageDtoList.length; k++) {
              if (_this26.ProposalEngageDto_obj.engageCode == _this26.ProposalEngageDtoList[k].engageCode) {
                // this.ty_engageName = ''
                // this.ty_engageCode = ''
                _this26.$message({
                  message: '新增的备注特约已经存在！',
                  type: 'warning'
                });

                return;
              }
            }
          }

          _this26.box_7 = false;
          _this26.ProposalEngageDto_obj.type = "1";
          console.log(_this26.box_7_flag);

          if (_this26.box_7_flag == "0") {
            //0----修改  浏览    1-----新增     2 --------
            _this26.ProposalEngageDtoList[_this26.index_7].engageCode = _this26.ProposalEngageDto_obj.engageCode;
            _this26.ProposalEngageDtoList[_this26.index_7].engageName = _this26.ProposalEngageDto_obj.engageName;
            _this26.ProposalEngageDtoList[_this26.index_7].engageContent = _this26.ProposalEngageDto_obj.engageContent;

            if (_this26.ProposalEngageDtoList[_this26.index_7].engageCode == 'CRM012') {
              _this26.ProposalEngageDtoList[_this26.index_7].updateFlag = 0;
            }

            console.log('看看 box_7_flag 为 0的话，updateFlag为 ', _this26.ProposalEngageDtoList[_this26.index_7].updateFlag);
          } else if (_this26.box_7_flag == "1") {
            var length = _this26.ProposalEngageDtoList.length;
            var obj = {
              engageCode: _this26.ProposalEngageDto_obj.engageCode,
              engageName: _this26.ProposalEngageDto_obj.engageName,
              engageContent: _this26.ProposalEngageDto_obj.engageContent,
              serialNo: length + 1,
              updateFlag: 1
            };

            if (obj.engageCode == 'CRM012') {
              obj.updateFlag = 0;
            }

            _this26.ProposalEngageDtoList.push(obj);

            console.log('新增特约', _this26.ProposalEngageDtoList);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //取消----特别约定信息
    especially_cancel_but: function especially_cancel_but() {
      this.box_7 = false;
    },
    //新增约定信息

    /*add_appointment() {
    		console.log(this.ProposalEngageDtoList)
    	if(this.ProposalEngageDtoList != null) {
    		for(var i = 0; i < this.ProposalEngageDtoList.length; i++) {
    			if(this.ProposalEngageDtoList[i].updateFlag == "1") {
    				this.$message({
    					message: '最多可添加一条特约信息',
    					type: 'warning'
    				});
    				return
    			}
    		}
    	}
                 console.log('新增约定信息-------------1')
                 console.log(this.ty_engageCode_option)
                 if(this.ty_engageCode_option.length>0) {
                     for(var i = 0; i < this.ty_engageCode_option.length; i++) {
                         this.ty_engageName = this.ty_engageCode_option[i].engageName
                         this.ty_engageCode = this.ty_engageCode_option[i].engageCode
                         for(var k=0;k<this.ProposalEngageDtoList.length; k++){
                             if(this.ty_engageCode==this.ProposalEngageDtoList[k].engageCode){
                                 this.ty_engageName = ''
                                 this.ty_engageCode = ''
                             }
                         }
                     }
                 }else{
                     this.$message({
                         message: '【基础数据管理】【特别约定导入】里面没有支持编辑的特约信息，不能新增',
                         type: 'warning'
                     });
                     return
                 }
                 console.log('新增约定信息-------------2')
                 console.log(this.ty_engageCode)
                 if(this.ty_engageCode == '' || this.ty_engageCode == null) {
                     this.$message({
                         message: '新增可支持编辑特约的特约代码已经存在',
                         type: 'warning'
                     });
                     return
                 }
    		this.box_7_disabled = false
    	this.box_7 = true
    	this.box_7_flag = "1"
    		this.ProposalEngageDto_obj.engageCode = this.ty_engageCode
    	this.ProposalEngageDto_obj.engageName = this.ty_engageName
    	this.ProposalEngageDto_obj.engageContent = ""
    	this.ProposalEngageDto_obj.updateFlag = "1"
    		var length = this.ProposalEngageDtoList.length;
    	this.ProposalEngageDto_obj.serialNo = length + 1
    		console.log(this.ProposalEngageDto_obj)
    	this.$refs['ProposalEngageDto_obj'].resetFields()
    	},*/
    add_appointment: function add_appointment() {
      console.log(this.ProposalEngageDtoList); //加载下拉框

      console.log('新增约定信息-------------1');
      console.log(this.ty_engageCode_option); //这里还是需要看下是否保费计算过，如果计算过，确定下是否协议等字段是多少

      if (this.isSubmit_s == true) {
        if (!this.showFlag) {
          for (var i = 0; i < this.ty_engageCode_option.length; i++) {
            if (this.ty_engageCode_option[i].engageCode == 'CRM012') {
              this.ty_engageCode_option.splice(i, 1);
            }
          }
        }
      }

      if (this.ty_engageCode_option.length > 0) {} else {
        this.$message({
          message: '保险公司未提供可添加的备注特约！',
          type: 'warning'
        });
        return;
      }

      this.box_7_disabled = false;
      this.box_8_disabled = false;
      this.box_7 = true;
      this.box_7_flag = "1";
      this.ProposalEngageDto_obj.engageCode = "";
      this.ProposalEngageDto_obj.engageName = "";
      this.ProposalEngageDto_obj.engageContent = "";
      this.ProposalEngageDto_obj.updateFlag = "1";
      var length = this.ProposalEngageDtoList.length;
      this.ProposalEngageDto_obj.serialNo = length + 1;
      console.log("1--------", this.ProposalEngageDto_obj);
      this.$refs['ProposalEngageDto_obj'].resetFields();
    },
    //修改下拉特别约定
    chUpdateEngageName: function chUpdateEngageName(val) {
      for (var i = 0; i < this.ty_engageCode_option.length; i++) {
        //获取选择的
        if (val == this.ty_engageCode_option[i].engageCode) {
          // this.ty_engageName = this.ty_engageCode_option[i].engageName
          // this.ty_engageCode = this.ty_engageCode_option[i].engageCode
          this.ProposalEngageDto_obj.engageName = this.ty_engageCode_option[i].engageName;
          this.ProposalEngageDto_obj.engageContent = this.ty_engageCode_option[i].engageContent;

          if (val == "CRM012") {
            this.box_8_disabled = true;

            if (this.isSubmit_s) {
              //说明保费计算成功了，那么先比较 是否协议结算和是否单独收费得标志  showflag
              //系统自动带出该单的保费和费率，特约内容不可修改
              if (this.riskCode == "CINL") {
                if (this.ProposalKindDto.limitMiniPremium == "" || this.ProposalKindDto.limitMiniPremium == null) {
                  this.ProposalEngageDto_obj.engageContent = "保费: " + this.ProposalKindDto.remiumCurrencyCode + " " + this.ProposalKindDto.sumPremium + '\r\n' + "费率: " + this.ProposalKindDto.proposalItemKindDtoList[0].rate + "%";
                } else {
                  this.ProposalEngageDto_obj.engageContent = "保费: " + this.ProposalKindDto.remiumCurrencyCode + " " + this.ProposalKindDto.limitMiniPremium + '\r\n' + "费率: " + this.ProposalKindDto.proposalItemKindDtoList[0].rate + "%";
                }
              } else if (this.riskCode == "CMAR" || this.riskCode == "CEXP") {
                if (this.ProposalKindDto.limitMiniPremium == "" || this.ProposalKindDto.limitMiniPremium == null) {
                  this.ProposalEngageDto_obj.engageContent = "Premium: " + this.ProposalKindDto.remiumCurrencyCode + " " + this.ProposalKindDto.sumPremium + '\r\n' + "Rate: " + this.ProposalKindDto.proposalItemKindDtoList[0].rate + "%";
                } else {
                  this.ProposalEngageDto_obj.engageContent = "Premium: " + this.ProposalKindDto.remiumCurrencyCode + " " + this.ProposalKindDto.limitMiniPremium + '\r\n' + "Rate: " + this.ProposalKindDto.proposalItemKindDtoList[0].rate + "%";
                }
              }
            }
          } else {
            this.box_8_disabled = false;
          }
        }
      }

      console.log('新增约定信息-------------2');
      /* console.log(this.ty_engageCode)
       if(this.ty_engageCode == '' || this.ty_engageCode == null) {
           // this.$message({
           //     message: '新增可支持编辑特约的特约代码已经存在',
           //     type: 'warning'
           // });
           return
       }*/
    },
    //浏览/修改-----------特约信息
    modify_content: function modify_content(row, type) {
      if (type == "look") {
        //查看
        this.box_7_disabled = true;
        this.box_8_disabled = true;
        this.box_7_flag = "0";
      } else {
        //编辑新增
        this.box_7_disabled = false;
        this.box_8_disabled = false;
        this.box_7_flag = "0";
      }

      this.box_7 = true;
      this.ProposalEngageDto_obj = deepcopy(row.row);
      this.index_7 = row.$index;
      this.$refs['ProposalEngageDto_obj'].resetFields();
    },
    //删除特约----内容
    delect_content: function delect_content(row) {
      this.ProposalEngageDtoList.splice(row.$index, 1);
    },
    //上传影像弹框
    img7_but: function img7_but() {
      if (this.ProposalMainDto.proposalNo == "" || this.ProposalMainDto.proposalNo == null) {
        this.$message({
          message: '请先进行暂存操作',
          type: 'warning'
        });
      } else {
        this.box_7_img = true;
      }
    },
    //必填校验
    rules_check: function rules_check() {
      //--------------------- 运输
      if (this.ProposalConveyanceDto.conveyanceWayCode == null || this.ProposalConveyanceDto.conveyanceWayCode == "") {
        this.text4.conveyanceWayCode = "请输入运输方式";
      } // if(this.ProposalConveyanceDto.clinchWayCode == null || this.ProposalConveyanceDto.clinchWayCode == "") {
      // 	this.text4.clinchWayCode = "请输入贸易条件"
      // }


      if (this.ProposalConveyanceDto.startTime == null || this.ProposalConveyanceDto.startTime == "") {
        // this.text4.startTime = "请输入船舶启航或飞机起飞日期"
        this.text4.startTime = "请输入起运日期";
      } // 根据申报基准选择内容--运费、运费币别/其他税费、其他税费币别


      if (this.otherTaxFeesFlag) {
        if (this.ProposalConveyanceDto.freight === "" || this.ProposalConveyanceDto.freight === null) {
          this.text4.freight = "请输入其他税费";
        }

        if (this.ProposalConveyanceDto.freightCurrency === "" || this.ProposalConveyanceDto.freightCurrency === null) {
          this.text4.freightCurrency = "请输入其他税费币别";
        }
      } else {
        if (this.ProposalConveyanceDto.freight != "" && this.ProposalConveyanceDto.freight != null) {
          if (this.ProposalConveyanceDto.freightCurrency == null || this.ProposalConveyanceDto.freightCurrency == "") {
            this.text4.freightCurrency = "请输入运费币别";
          }
        }
      }

      if (this.ProposalConveyanceDto.proposalConveyanceListDtoList.length <= 0) {
        this.box_8_cont = ['必须有一条航程信息'];
        this.box_8 = true;
        this.conveyanceWayCode_3_proposalConveyanceListDtoList = "必须有一条航程信息";
      } else if (this.ProposalConveyanceDto.proposalConveyanceListDtoList.length > 0) {
        this.conveyanceWayCode_3_proposalConveyanceListDtoList = "";

        for (var i = 0; i < this.ProposalConveyanceDto.proposalConveyanceListDtoList.length; i++) {
          if (this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode == null) {
            $('.startSiteCountryCode').eq(i).find('input').css({
              'border': '1px solid #f56c6c'
            });
            this.text4.startSiteCountryCode = "不为空";
          } else {
            $('.startSiteCountryCode').eq(i).find('input').css({
              'border': '1px solid #ccc'
            });
            this.text4.startSiteCountryCode = "";
          }

          if (this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCityCode == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCityCode == null) {
            $('.startSiteCityCode').eq(i).find('input').css({
              'border': '1px solid #f56c6c'
            });
            this.text4.startSiteCountryCode = "不为空";
          } else {
            $('.startSiteCityCode').eq(i).find('input').css({
              'border': '1px solid #ccc'
            });
            this.text4.startSiteCountryCode = "";
          }

          if (this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryCode == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCountryCode == null) {
            $('.endSiteCountryCode').eq(i).find('input').css({
              'border': '1px solid #f56c6c'
            });
            this.text4.endSiteCountryCode = "不为空";
          } else {
            $('.endSiteCountryCode').eq(i).find('input').css({
              'border': '1px solid #ccc'
            });
            this.text4.endSiteCountryCode = "";
          }

          if (this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCityCode == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].endSiteCityCode == null) {
            $('.endSiteCityCode').eq(i).find('input').css({
              'border': '1px solid #f56c6c'
            });
            this.text4.endSiteCountryCode = "不为空";
          } else {
            $('.endSiteCityCode').eq(i).find('input').css({
              'border': '1px solid #ccc'
            });
            this.text4.endSiteCountryCode = "";
          }
        } //如果只有一条运输信息，校验样式还适用，如果有多条，不校验必录


        if (this.ProposalConveyanceDto.proposalConveyanceListDtoList.length === 1) {
          for (var i = 0; i < this.ProposalConveyanceDto.proposalConveyanceListDtoList.length; i++) {
            if (this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].blName == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].blName == null) {
              $('.blName').eq(i).find('input').css({
                'border': '1px solid #f56c6c'
              });
              this.text4.blName = "不为空";
            } else {
              $('.blName').eq(i).find('input').css({
                'border': '1px solid #ccc'
              });
              this.text4.blName = "";
            }

            if (this.ProposalConveyanceDto.conveyanceWayCode == '3' || this.ProposalConveyanceDto.conveyanceWayCode == "8" || this.ProposalConveyanceDto.conveyanceWayCode == "10") {
              /*if(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].voyageNo == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].voyageNo == null) {
                $('.voyageNo').eq(i).find('input').css({
                  'border': '1px solid #f56c6c'
                })
                this.text4.voyageNo = "不为空"
              } else {
                $('.voyageNo').eq(i).find('input').css({
                  'border': '1px solid #ccc'
                })
                 this.text4.voyageNo = ""
              }*/
              $('.voyageNo').eq(i).find('input').css({
                'border': '1px solid #ccc'
              });

              if (this.riskCode == 'CINL' && this.ProposalConveyanceDto.conveyanceWayCode == '3') {} else {
                if (this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassCode == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassCode == null) {
                  $('.shipClassCode').eq(i).find('input').css({
                    'border': '1px solid #f56c6c'
                  });
                  this.text4.shipClassCode = "不为空";
                } else {
                  $('.shipClassCode').eq(i).find('input').css({
                    'border': '1px solid #ccc'
                  });
                  this.text4.shipClassCode = "";
                }

                if (this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypesCode == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypesCode == null) {
                  $('.shipTypesCode').eq(i).find('input').css({
                    'border': '1px solid #f56c6c'
                  });
                  this.text4.shipTypesCode = "不为空";
                } else {
                  $('.shipTypesCode').eq(i).find('input').css({
                    'border': '1px solid #ccc'
                  });
                  this.text4.shipTypesCode = "";
                }

                if (this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].vessel == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].vessel == null) {
                  $('.vessel').eq(i).find('input').css({
                    'border': '1px solid #f56c6c'
                  });
                  this.text4.vessel = "不为空";
                } else {
                  $('.vessel').eq(i).find('input').css({
                    'border': '1px solid #ccc'
                  });
                  this.text4.vessel = "";
                }
              }
            } else {
              $('.voyageNo').eq(i).find('input').css({
                'border': '1px solid #ccc'
              });
              this.text4.voyageNo = "";
              $('.shipClassCode').eq(i).find('input').css({
                'border': '1px solid #ccc'
              });
              this.text4.shipClassCode = "";
              $('.shipTypesCode').eq(i).find('input').css({
                'border': '1px solid #ccc'
              });
              this.text4.shipTypesCode = "";
              $('.vessel').eq(i).find('input').css({
                'border': '1px solid #ccc'
              });
              this.text4.vessel = "";
            }
          }
        }
      } //--------------标的


      if (this.ProposalItemDto.packingWayCode == null || this.ProposalItemDto.packingWayCode == "") {
        this.text5.packingWayCode = "请输入包装方式";
      }

      if (this.ProposalItemDto.isRefrigeRate == null || this.ProposalItemDto.isRefrigeRate == "") {
        this.text5.isRefrigeRate = "请输入是否冷藏";
      }

      if (this.ProposalItemDto.isContainer == null || this.ProposalItemDto.isContainer == "") {
        this.text5.isContainer = "请输入是否集装箱";
      }

      if ((this.ProposalItemDto.ladingNO == null || this.ProposalItemDto.ladingNO == "") && (this.ProposalItemDto.invoicNo == null || this.ProposalItemDto.invoicNo == "")) {
        if (this.riskCode != null && this.riskCode != 'CINL') {
          this.text5.ladingNO = "请输入发票号或提单号，两者必录其一";
          this.text5.invoicNo = "请输入发票号或提单号，两者必录其一";
        } else {
          this.text5.ladingNO = "";
          this.text5.invoicNo = "";
        }
      } else {
        this.text5.ladingNO = "";
        this.text5.invoicNo = "";
      } // if(this.ProposalItemDto.marks == null || this.ProposalItemDto.marks == "") {
      // 	this.text5.marks = "请输入唛头信息"
      // }


      console.log(this.ProposalItemDto.invoicAmount);

      if (this.ProposalItemDto.invoicAmount == null || this.ProposalItemDto.invoicAmount == "" || this.ProposalItemDto.invoicAmount == "0.00" || this.ProposalItemDto.invoicAmount == 0) {
        this.text5.invoicAmount = "请输入发票金额";
      } else {
        this.text5.invoicAmount = "";
      }

      if (this.ProposalItemDto.invoicCurrencyCode == null || this.ProposalItemDto.invoicCurrencyCode == "") {
        this.text5.invoicCurrencyCode = "请输入发票币别";
      } // if(this.ProposalItemDto.reportCode == null || this.ProposalItemDto.reportCode == "") {
      // 	this.text5.reportName = "请输入申报基准"
      // }
      //--  主附险


      if (this.ProposalKindDto.amountCurrencyCode == null || this.ProposalKindDto.amountCurrencyCode == "") {
        this.text6.amountCurrencyCode = "请输入保额币别";
      }

      if (this.ProposalKindDto.remiumCurrencyCode == null || this.ProposalKindDto.remiumCurrencyCode == "") {
        this.text6.remiumCurrencyCode = "请输入保费币别";
      } //				if(this.ProposalKindDto.exchangeRate == null || this.ProposalKindDto.exchangeRate == "") {
      //					this.text6.exchangeRate = "请输入保额兑换保费汇率"
      //				}


      if (this.ProposalKindDto.plusRate == null || this.ProposalKindDto.plusRate == "") {
        this.text6.plusRate = "请输入加成比例%";
      }

      if (this.ProposalConveyanceDto != null) {
        if (this.ProposalConveyanceDto.proposalConveyanceListDtoList.length >= 2) {
          var leng = this.ProposalConveyanceDto.proposalConveyanceListDtoList.length;

          for (var i = 0; i < this.ProposalConveyanceDto.proposalConveyanceListDtoList.length; i++) {
            if (i > 0) {
              if (this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCountryCode != this.ProposalConveyanceDto.proposalConveyanceListDtoList[i - 1].endSiteCountryCode) {
                $('.startSiteCountryCode').eq(i).find('input').css({
                  'border': '1px solid #f56c6c'
                });
                this.text4.startSiteCountryCode = "不为空";
              }

              if (this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].startSiteCityCode != this.ProposalConveyanceDto.proposalConveyanceListDtoList[i - 1].endSiteCityCode) {
                $('.startSiteCityCode').eq(i).find('input').css({
                  'border': '1px solid #f56c6c'
                });
                this.text4.startSiteCountryCode = "不为空";
              }

              if (this.text4.startSiteCountryCode != "") {
                this.box_8_cont = ['多条运输区间，中转地与下一条的起运地不一致，请进行修改'];
                this.box_8 = true;
              }
            }
          }
        }
      } //YCKK-1073 需求描述：船名/航班号 / 车牌号 / 其他运输工具，船舶航次，船级社，船舶类型，船龄这5个字段改成非必录的，但是提交的时候，至少有一条运输信息这5个字段是必录的，其他可录可不录。（非船舶运输方式至少有一条运输信息船名/航班号 / 车牌号 / 其他运输工具，船舶航次这2个字段是必录的，船信息不用录）
      //20241114 当投保产品为CINL，且运输方式为船舶时：在保费计算时，不校验需有一条完整的航程信息，即“船级社、船舶类型、船龄”允许为空；


      if (this.ProposalConveyanceDto.proposalConveyanceListDtoList.length >= 1) {
        var checknum = 0;

        for (var i = 0; i < this.ProposalConveyanceDto.proposalConveyanceListDtoList.length; i++) {
          if (this.riskCode == 'CINL') {
            if (this.ProposalConveyanceDto.conveyanceWayCode == "8" || this.ProposalConveyanceDto.conveyanceWayCode == "10") {
              if (!isEmpty(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].blName) && !isEmpty(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassCode) && !isEmpty(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypesCode) && !isEmpty(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].vessel)) {
                checknum = checknum + 1;
              }
            } else {
              if (!isEmpty(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].blName)) {
                checknum = checknum + 1;
              }
            }
          } else {
            if (this.ProposalConveyanceDto.conveyanceWayCode == '3' || this.ProposalConveyanceDto.conveyanceWayCode == "8" || this.ProposalConveyanceDto.conveyanceWayCode == "10") {
              if (!isEmpty(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].blName) && !isEmpty(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipClassCode) && !isEmpty(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].shipTypesCode) && !isEmpty(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].vessel)) {
                checknum = checknum + 1;
              }
            } else {
              if (!isEmpty(this.ProposalConveyanceDto.proposalConveyanceListDtoList[i].blName)) {
                checknum = checknum + 1;
              }
            }
          }
        }

        if (checknum >= 1) {} else {
          this.box_8_cont = ['必须有一条航程信息录入完整'];
          this.box_8 = true;
          this.text4.startSiteCountryCode = "必须有一条航程信息录入完整";
        }
      }

      if (this.ProposalItemDto.isStorage === null || this.ProposalItemDto.isStorage === '') {
        this.text5.isStorage = '请选择是否仓储/展览/加工/安装';
      } else {
        this.text5.isStorage = '';

        if (this.ProposalItemDto.isStorage === '1') {
          if (this.ProposalItemDto.storageStartTime === null || this.ProposalItemDto.storageStartTime === '') {
            this.text5.storageStartTime = '请选择仓储/展览/加工/安装起期';
          } else {
            this.text5.storageStartTime = '';
          }

          if (this.ProposalItemDto.storageEndTime === null || this.ProposalItemDto.storageEndTime === '') {
            this.text5.storageEndTime = '请选择仓储/展览/加工/安装止期';
          } else {
            this.text5.storageEndTime = '';
          }

          if (this.ProposalItemDto.storagePeriod === null || this.ProposalItemDto.storagePeriod === '') {
            this.text5.storagePeriod = '请选择仓储/展览/加工/安装起期与仓储/展览/加工/安装止期,来计算仓储/展览/加工/安装起期(天)';
          } else {
            this.text5.storagePeriod = '';
          }

          if (this.ProposalItemDto.storagePeriod != '' && this.ProposalItemDto.storagePeriod != undefined) {
            if (this.ProposalItemDto.nationType != '' && this.ProposalItemDto.nationType == '1') {
              console.log('!!!!!!!!!!!!!!!!!!!!');
              console.log(this.ProposalItemDto.countryName);
              console.log(this.ProposalItemDto.provinceName);
              console.log(this.ProposalItemDto.cityName);
              console.log(this.ProposalItemDto.areaName);
              console.log(this.ProposalItemDto.roadName);

              if (this.ProposalItemDto.countryName == '') {
                this.text8.countryPrompt = '请选择国家';
              } else {
                this.text8.countryPrompt = '';
              }

              if (this.ProposalItemDto.provinceName == '') {
                this.text8.provincePrompt = '请选择省';
              } else {
                this.text8.provincePrompt = '';
              }

              if (this.ProposalItemDto.cityName == '') {
                this.text8.cityPrompt = '请选择市';
              } else {
                this.text8.cityPrompt = '';
              }

              if (this.ProposalItemDto.areaName == '') {
                this.text8.areaPrompt = '请选择区';
              } else {
                this.text8.areaPrompt = '';
              }

              if (this.ProposalItemDto.roadName == '') {
                this.text8.roadNamePrompt = '请输入路名';
              } else {
                this.text8.roadNamePrompt = '';
              }

              if (this.ProposalItemDto.detailAddress == '') {
                this.text8.detailAddressPrompt = '请输入详细地址';
              } else {
                this.text8.detailAddressPrompt = '';
              }
            } else if (this.ProposalItemDto.nationType == '2') {
              if (this.ProposalItemDto.countryName == '') {
                this.text8.countryPrompt = '请选择国家';
              } else {
                this.text8.countryPrompt = '';
              }

              if (this.ProposalItemDto.detailAddress == '') {
                this.text8.detailAddressPrompt = '请输入详细地址';
              } else {
                this.text8.detailAddressPrompt = '';
              }
            }
          }
        } else {
          this.text5.storageStartTime = '';
          this.text5.storageEndTime = '';
          this.text5.storagePeriod = '';
          this.text8.countryPrompt = '';
          this.text8.provincePrompt = '';
          this.text8.cityPrompt = '';
          this.text8.areaPrompt = '';
          this.text8.roadNamePrompt = '';
          this.text8.detailAddressPrompt = '';
        }
      } // 发票信息模块校验


      if (this.invoiceCollectedFlag) {
        if (this.ProposalInvoiceDto.invoiceEmail === null || this.ProposalInvoiceDto.invoiceEmail === '') {
          this.text7.invoiceEmail = '请输入发票接收邮箱';
        } else {
          this.text7.invoiceEmail = '';
          var re = /^((([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6}\,))*(([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})))$/;

          if (!re.test(this.ProposalInvoiceDto.invoiceEmail)) {
            this.text7.invoiceEmail = '发票接收邮箱格式不正确';
          }
        }

        if (this.ProposalInvoiceDto.isThirdPartyPayment === null || this.ProposalInvoiceDto.isThirdPartyPayment === '') {
          this.text7.isThirdPartyPayment = '请选择是否第三方支付';
        } else {
          this.text7.isThirdPartyPayment = '';

          if (this.ProposalInvoiceDto.isThirdPartyPayment === '1') {
            if (this.ProposalInvoiceDto.actualPayer === null || this.ProposalInvoiceDto.actualPayer === '') {
              this.text7.actualPayer = '请输入实际付款人/公司名称';
            } else {
              this.text7.actualPayer = '';
            }

            if (this.ProposalInvoiceDto.invoiceHeader === null || this.ProposalInvoiceDto.invoiceHeader === '') {
              this.text7.invoiceHeader = '请输入发票抬头';
            } else {
              this.text7.invoiceHeader = '';
            }

            if (this.ProposalInvoiceDto.taxpayerIdentityType === null || this.ProposalInvoiceDto.taxpayerIdentityType === '') {
              this.text7.taxpayerIdentityType = '请选择纳税人身份';
            } else {
              this.text7.taxpayerIdentityType = '';
            }
          } else {
            this.text7.actualPayer = '';
            this.text7.invoiceHeader = '';
            this.text7.taxpayerIdentityType = '';
          }
        }
      } //------运输方式为船舶时必录，必须有一条航程信息


      if ( //					this.text1.dates != "" || this.text1.insuranceCompanyName != "" || this.text1.companyName != "" ||
      //
      //					this.text2.applicantName != "" || this.text2.registeredAddress != "" || this.text2.linkmanName != "" || this.text2.identifyType != "" ||
      //
      //					this.text2.identifyNumber != "" || this.text2.linkmanPhone != "" || this.text2.linkmanAddress != "" || this.text3.insuredName != "" ||
      //
      //					this.text3.insuredEnName != "" || this.text3.identifyType != "" || this.text3.identifyNumber != "" || this.text3.address != "" ||
      //
      //					this.text3.email != "" || this.text3.phone != "" ||
      //					this.text4.conveyanceWayCode != "" ||
      //
      this.text4.conveyanceCode != "" || this.text4.clinchWayCode != "" || this.text4.startTime != "" || this.text4.freight != "" || this.text4.freightCurrency != "" || this.text4.startSiteCountryCode != "" || this.text4.endSiteCountryCode != "" || this.conveyanceWayCode_3_proposalConveyanceListDtoList != "" || this.text5.packingWayCode != "" || this.text5.isRefrigeRate != "" || this.text5.isContainer != "" || this.text5.invoicNo != "" || this.text5.ladingNO != "" || this.text5.marks != "" || this.text5.invoicAmount != "" || this.text5.invoicCurrencyCode != "" || this.text5.isStorage != "" || this.text5.storageStartTime != "" || this.text5.storageEndTime != "" || this.text5.storagePeriod != "" || this.text8.countryPrompt != "" || this.text8.provincePrompt != "" || this.text8.cityPrompt != "" || this.text8.areaPrompt != "" || this.text8.roadNamePrompt != "" || this.text8.detailAddressPrompt != "" || this.text6.amountCurrencyCode != "" || this.text6.remiumCurrencyCode != "" || this.text6.plusRate != "" || this.text7.invoiceEmail != "" || this.text7.isThirdPartyPayment != "" || this.text7.actualPayer != "" || this.text7.invoiceHeader != "" || this.text7.taxpayerIdentityType != "") {
        debugger;
        this.fromdata = true;
        this.$message({
          message: '请完成必填项！',
          type: 'warning'
        });
      } else {
        this.box_8_cont = [];

        if (this.ProposalApplicantDto.identifyType && this.ProposalApplicantDto.identifyType == '10' && this.ProposalApplicantDto.nationalFlag != '2') {
          if (this.ProposalApplicantDto.identifyNumber && /^[0-9a-zA-Z]{18}$/.test(this.ProposalApplicantDto.identifyNumber)) {
            this.fromdata = false;
          } else {
            console.log(this.ProposalApplicantDto.identifyNumber + '********************' + this.ProposalApplicantDto.identifyType);
            this.box_8_cont = ['投保人信息：境内外标识为不为境外时，且证件类型为社会统一信用代码时，证件号必须是由18位数字或字母组成的。'];
            this.box_8 = true;
            this.fromdata = true;
          }
        }

        if (this.ProposalInsuredDto.identifyType && this.ProposalInsuredDto.identifyType == '10' && this.ProposalInsuredDto.nationalFlag != '2') {
          if (this.ProposalInsuredDto.identifyNumber && /^[0-9a-zA-Z]{18}$/.test(this.ProposalInsuredDto.identifyNumber)) {} else {
            console.log(this.ProposalInsuredDto.identifyNumber + '********************' + this.ProposalInsuredDto.identifyType);
            this.box_8_cont.push('被保险人信息：境内外标识为不为境外时，且证件类型为社会统一信用代码时，证件号必须是由18位数字或字母组成的。');
            this.box_8 = true;
            this.fromdata = true;
          }
        }

        if (this.ProposalItemDto.nationType != '' && this.ProposalItemDto.nationType == '1') {
          console.log('MMMMMMMMMMMMMMMMMMMMMMMMMM');
          console.log(this.text8.countryPrompt);
          console.log(this.text8.detailAddressPrompt);
          console.log(this.text8.provincePrompt);
          console.log(this.text8.cityPrompt);
          console.log(this.text8.areaPrompt);
          console.log(this.text8.roadNamePrompt);

          if (this.text8.countryPrompt != "" || this.text8.detailAddressPrompt != "" || this.text8.provincePrompt != "" || this.text8.cityPrompt != "" || this.text8.areaPrompt != "" || this.text8.roadNamePrompt != "") {
            this.fromdata = true;
            this.$message({
              message: '请完成必填项！',
              type: 'warning'
            });
          }
        } else if (this.ProposalItemDto.nationType == '2') {
          if (this.text8.countryPrompt != "" || this.text8.detailAddressPrompt != "") {
            this.fromdata = true;
            this.$message({
              message: '请完成必填项！',
              type: 'warning'
            });
          }
        }
      }
    },
    //匹配责任信息
    matching_but: function matching_but() {
      var _this27 = this;

      this.loing_box = true;
      this.rules_check();
      console.log('校验值------', this.fromdata);

      if (this.fromdata == true) {
        this.loing_box = false;
        return;
      } // 判断总价/单价/发票金额为字符串时转换为数字
      // 发票金额


      if (typeof this.ProposalItemDto.invoicAmount == "string") {
        this.ProposalItemDto.invoicAmount = parseFloat(this.ProposalItemDto.invoicAmount.replace(/,/g, "")); // console.log(this.ProposalItemDto.invoicAmount,'pp***')
      } else {
        this.ProposalItemDto.invoicAmount = this.ProposalItemDto.invoicAmount;
      }

      for (var i = 0; i < this.ProposalItemDto.proposalItemCargoDtoList.length; i++) {
        // 总价
        if (typeof this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount == "string") {
          this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = parseFloat(this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount.replace(/,/g, "")); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount)
        } else {
          this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount;
        } // 单价


        if (typeof this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount == "string") {
          this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = parseFloat(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount.replace(/,/g, "")); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)
        } else {
          this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount;
        } // 车辆价格


        if (typeof this.ProposalItemDto.proposalItemCargoDtoList[i].vehiclePrice == "string") {
          this.ProposalItemDto.proposalItemCargoDtoList[i].vehiclePrice = parseFloat(this.ProposalItemDto.proposalItemCargoDtoList[i].vehiclePrice.replace(/,/g, ""));
        } else {
          this.ProposalItemDto.proposalItemCargoDtoList[i].vehiclePrice = this.ProposalItemDto.proposalItemCargoDtoList[i].vehiclePrice;
        } //数量


        if (typeof this.ProposalItemDto.proposalItemCargoDtoList[i].quantity == "string") {
          this.ProposalItemDto.proposalItemCargoDtoList[i].quantity = parseFloat(this.ProposalItemDto.proposalItemCargoDtoList[i].quantity.replace(/,/g, "")); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)
        } else {
          this.ProposalItemDto.proposalItemCargoDtoList[i].quantity = this.ProposalItemDto.proposalItemCargoDtoList[i].quantity;
        }
      }

      var identifyNumber = this.ProposalInsuredDto.identifyNumber;

      if (identifyNumber == undefined && identifyNumber == null) {
        identifyNumber = '';
      }

      var data = {
        proposalConveyanceDto: this.ProposalConveyanceDto,
        //运输
        proposalItemDto: this.ProposalItemDto,
        //  标的
        protocol: {
          protocolNo: this.ProposalMainDto.protocolNo,
          riskCode: this.ProposalMainDto.riskCode
        },
        proposalKindDto: {
          amountCurrencyCode: this.ProposalKindDto.amountCurrencyCode,
          amountCurrency: this.ProposalKindDto.amountCurrency,
          remiumCurrencyCode: this.ProposalKindDto.remiumCurrencyCode,
          remiumCurrency: this.ProposalKindDto.remiumCurrency,
          plusRate: this.ProposalKindDto.plusRate
        },
        identifyNumber: identifyNumber
      }; // 贸易条件校验优化 20240805

      var flag = false;
      var riskCode = this.ProposalMainDto.riskCode;
      var clinchWayName = this.ProposalConveyanceDto.clinchWayName;
      var tradeTerms = '';
      var promptStatement = '';

      if (riskCode !== '' && clinchWayName !== '' && (riskCode === 'CEXP' || riskCode === 'CMAR')) {
        if (riskCode === 'CEXP') {
          tradeTerms = 'CIF,CIP,DAT,DAP,DDP,DDU,DES,DEQ,DAF';
          promptStatement = '1.根据您的贸易条件，被保险人应为进口方（买方），请确认：<br>' + '1）被保险人是否为进口方（买方）；<br>' + '2）有无重复投保；<br>' + '3）是否需要投保。<br>' + '2.如被保险人无货物所有权可能导致出险后无法理赔，请了解。';
        } else if (riskCode === 'CMAR') {
          tradeTerms = 'EXW,FCA,FAS,FOB,CFR,C&F,CPT';
          promptStatement = '1.根据您的贸易条件，被保险人应为出口方（卖方），请确认：<br>' + '1）被保险人是否为出口方（卖方）<br>' + '2）有无重复投保<br>' + '3）是否需要投保。<br>' + '2.如被保险人无货物所有权可能导致出险后无法理赔，请了解。';
        }

        if (!tradeTerms.includes(clinchWayName)) {
          flag = true;
        }
      }

      if (flag) {
        var messageVNodes = this.$createElement('p', {
          domProps: {
            innerHTML: promptStatement
          }
        });
        this.$confirm(messageVNodes, '提示', {
          confirmButtonText: '无重复投保,确认投保',
          cancelButtonText: '取消投保',
          type: 'warning',
          customClass: 'elmessageWidth'
        }).then(function () {
          _this27.autoMatchKindInfo1(data);
        }).catch(function () {
          _this27.loing_box = false;
        });
      } else {
        this.autoMatchKindInfo1(data);
      }
    },
    autoMatchKindInfo1: function autoMatchKindInfo1(data) {
      var _this28 = this;

      autoMatchKindInfo_fun(data).then(function (res) {
        if (res.rtnCode === '0000') {
          _this28.ProposalKindDto.amountCurrency = res.policyKindDto.amountCurrency;
          _this28.ProposalKindDto.amountCurrencyCode = res.policyKindDto.amountCurrencyCode;
          _this28.ProposalKindDto.exchangeRate = res.policyKindDto.exchangeRate; // this.ProposalKindDto.plusRate = res.policyKindDto.plusRate

          _this28.ProposalKindDto.remiumCurrency = res.policyKindDto.remiumCurrency;
          _this28.ProposalKindDto.remiumCurrencyCode = res.policyKindDto.remiumCurrencyCode; // this.ProposalKindDto.sumPremium = res.policyKindDto.sumPremium
          // this.ProposalKindDto.sunAmount = res.policyKindDto.sunAmount
          // 匹配成功后根据保额/保费币别判断总保额总保费显示

          if (_this28.ProposalKindDto.amountCurrencyCode == "JPY") {
            _this28.ProposalKindDto.sunAmount = toThousands(Math.round(res.policyKindDto.sunAmount));
          } else {
            _this28.ProposalKindDto.sunAmount = num3_type_fun(res.policyKindDto.sunAmount);
          }

          if (_this28.ProposalKindDto.remiumCurrencyCode == "JPY") {
            _this28.ProposalKindDto.sumPremium = toThousands(Math.round(res.policyKindDto.sumPremium));
          } else {
            _this28.ProposalKindDto.sumPremium = num3_type_fun(res.policyKindDto.sumPremium);
          }

          _this28.ProposalKindDto.limitMiniPremium = res.policyKindDto.limitMiniPremium;
          _this28.ProposalKindDto.proposalItemKindDtoList = res.policyKindDto.policyItemKindDtoList; // console.log(res.policyKindDto.policyItemKindDtoList,'000')

          for (var i = 0; i < res.policyKindDto.policyItemKindDtoList.length; i++) {
            console.log(res.policyKindDto.policyItemKindDtoList, "-------******");

            if (res.policyKindDto.policyItemKindDtoList[i].clauseType == '附加险') {
              // 仓储附加险-做成基础配置
              if (res.policyKindDto.policyItemKindDtoList[i].editFlag) {
                _this28.ProposalKindDto.proposalItemKindDtoList[i].amount = num3_type_fun(res.policyKindDto.policyItemKindDtoList[i].amount);
              } else {
                _this28.ProposalKindDto.proposalItemKindDtoList[i].amount = '-';
              }
            } else {
              if (_this28.ProposalKindDto.amountCurrencyCode == "JPY") {
                _this28.ProposalKindDto.proposalItemKindDtoList[i].premium = toThousands(Math.round(res.policyKindDto.policyItemKindDtoList[i].premium));
                _this28.ProposalKindDto.proposalItemKindDtoList[i].amount = toThousands(Math.round(res.policyKindDto.policyItemKindDtoList[i].amount));
              } else {
                _this28.ProposalKindDto.proposalItemKindDtoList[i].premium = num3_type_fun(res.policyKindDto.policyItemKindDtoList[i].premium);
                _this28.ProposalKindDto.proposalItemKindDtoList[i].amount = num3_type_fun(res.policyKindDto.policyItemKindDtoList[i].amount);
              }
            }
          } //保费计算成功之后 刷新回显被保险人信息 add 2022-03-07


          if (res.protocolApplicantDto != null) {
            // this.ProposalApplicantDto = res.protocolApplicantDto
            _this28.ProposalApplicantDto.applicantName = res.protocolApplicantDto.insuredName;
            _this28.ProposalApplicantDto.identifyNumber = res.protocolApplicantDto.identifyNumber;
            _this28.ProposalApplicantDto.identifyType = res.protocolApplicantDto.idEntifyTypeCode;
            _this28.ProposalApplicantDto.linkmanName = res.protocolApplicantDto.linkmanName;
            _this28.ProposalApplicantDto.registeredAddress = res.protocolApplicantDto.registeredAddress;
            _this28.ProposalApplicantDto.unitNature = res.protocolApplicantDto.unitNature;
            _this28.ProposalApplicantDto.unitNatureName = res.protocolApplicantDto.unitNatureName;
            _this28.ProposalApplicantDto.nationalFlagName = res.protocolApplicantDto.nationalFlagName;
            _this28.ProposalApplicantDto.nationalFlag = res.protocolApplicantDto.nationalFlag;
            _this28.ProposalApplicantDto.insuredProvince = res.protocolApplicantDto.insuredProvince;
            _this28.ProposalApplicantDto.provinceList = res.protocolApplicantDto.provinceList;
            _this28.ProposalApplicantDto.provinceCode = res.protocolApplicantDto.provinceCode;
            _this28.ProposalApplicantDto.cityCode = res.protocolApplicantDto.cityCode;
            _this28.ProposalApplicantDto.areaCode = res.protocolApplicantDto.areaCode;
            _this28.ProposalApplicantDto.provinceName = res.protocolApplicantDto.provinceName;
            _this28.ProposalApplicantDto.cityName = res.protocolApplicantDto.cityName;
            _this28.ProposalApplicantDto.areaName = res.protocolApplicantDto.areaName;
            var newArrArea = [];

            if (res.protocolApplicantDto.provinceCode != "") {
              newArrArea.push(res.protocolApplicantDto.provinceCode);
              newArrArea.push(res.protocolApplicantDto.cityCode);
              newArrArea.push(res.protocolApplicantDto.areaCode);
            }

            _this28.ProposalApplicantDto.provinceList = newArrArea;
            _this28.ProposalApplicantDto.applicantName = res.protocolApplicantDto.insuredName;
            _this28.ProposalApplicantDto.identifyType = res.protocolApplicantDto.idEntifyTypeCode;
          }

          if (res.protocolMainDto != null) {
            var formatter = new Intl.DateTimeFormat('zh-CN', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            });
            _this28.ProposalMainDto.dates = [formatter.format(new Date(res.protocolMainDto.agreementStartDate)).replace(/\//g, '-'), formatter.format(new Date(res.protocolMainDto.agreementEndDate)).replace(/\//g, '-')];
            _this28.ProposalMainDto.insuranceCompanyName = res.protocolMainDto.insurancecompanyName; //this.ProposalMainDto.companyName=res.protocolMainDto.intermediaryOrganName
          } //refreshFlag为1时刷新、0不刷新


          if (res.refreshFlag == '1') {
            console.log('被保险人:刷新');
            _this28.ProposalInsuredDto = res.proposalInsuredDto;
          } else {
            console.log('被保险人:不刷新');
          } //根据op协议号数据
          // 日本元或非日本元时 千分位展示
          // 发票金额
          // if(this.ProposalItemDto.invoicCurrencyCode == "JPY"){
          // 	this.ProposalItemDto.invoicAmount = toThousands(Math.round(this.ProposalItemDto.invoicAmount))
          // 	console.log(this.ProposalItemDto.invoicAmount,'pp***')
          // }else{
          // 	this.ProposalItemDto.invoicAmount = num3_type_fun(this.ProposalItemDto.invoicAmount)
          // 	console.log(this.ProposalItemDto.invoicAmount)
          // }
          // for(var i = 0; i < this.ProposalItemDto.proposalItemCargoDtoList.length; i++){
          // 	// 总价
          // 	if(this.ProposalItemDto.invoicCurrencyCode == "JPY"){
          // 		this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = toThousands(Math.round(this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount))
          // 		console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount)
          // 	}else{
          // 		this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = num5_type_fun(this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount)
          // 	}
          // 	// 单价
          // 	if(this.ProposalItemDto.invoicCurrencyCode == "JPY"){
          // 		this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = toThousands(Math.round(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount))
          // 		// console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)
          // 	}else{
          // 		this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = num4_type_fun(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)
          // 	}
          // }
          // this.box_6 = true


          _this28.box_hwqd = true;

          _this28.$message({
            message: '保费计算成功',
            type: 'success'
          }); // 刷新主险/附加险预览信息


          if (_this28.index_6 !== null && _this28.index_6 !== '') {
            _this28.modify_view_6(_this28.index_6, 'syn');
          }

          var protocolNo1 = _this28.ProposalMainDto.protocolNo;
          var ladingNo1 = _this28.ProposalItemDto.ladingNO;
          var invoicNo1 = _this28.ProposalItemDto.invoicNo;
          var invoicAmount1 = _this28.ProposalItemDto.invoicAmount;
          var invoicCurrencyCode1 = _this28.ProposalItemDto.invoicCurrencyCode;

          if (!ladingNo1) {
            ladingNo1 = '';
          }

          if (!invoicNo1) {
            invoicNo1 = '';
          }

          if (!invoicAmount1) {
            invoicAmount1 = 0;
          }

          if (!invoicCurrencyCode1) {
            invoicCurrencyCode1 = '';
          }

          var data1 = {
            protocolNo: protocolNo1,
            ladingNO: ladingNo1.trim(),
            invoicNo: invoicNo1.trim(),
            invoicAmount: invoicAmount1,
            invoicCurrencyCode: invoicCurrencyCode1
          };
          checkOCisBlock(data1).then(function (res) {
            if (res.rtnCode == "1111") {
              _this28.proposalNO = res.proposalNo;
              _this28.inVoIcNo = res.invoicNo;
              _this28.inVoIcCurrency = res.invoicCurrencyCode;
              _this28.ladIngNo = res.ladingNO;
              _this28.inVoIcAmount = res.invoicAmount;
              _this28.proposalStatus = res.proposalStatus;
              console.log(">>>校验成功<<<<");

              if (res.rtnCode == "1111") {
                var messageStr = '该协议号（' + _this28.ProposalMainDto.protocolNo + '）下有下列重复项：';

                if (res.ladingNO) {
                  _this28.checkLadingNO = res.ladingNO;
                  messageStr += '提单号：' + _this28.checkLadingNO;
                }

                if (res.invoicNo) {
                  _this28.checkInvoicNo = res.invoicNo;
                  messageStr += '发票号：' + _this28.checkInvoicNo;
                }

                if (res.invoicCurrencyCode) {
                  _this28.checkInvoicCurrencyCode = res.invoicCurrencyCode;
                  messageStr += '发票币别：' + _this28.checkInvoicCurrencyCode;
                }

                if (res.invoicAmount) {
                  _this28.checkInvoicAmount = res.invoicAmount;
                  messageStr += '发票金额：' + _this28.checkInvoicAmount;
                }

                _this28.isRepetition_s = true;

                _this28.$message({
                  message: messageStr,
                  type: 'warning'
                });
              }
            } else {
              console.log(">>>校验请求失败<<<<");
            }
          });
          _this28.isSubmit_s = true;
          console.log('是否协议结算', res.isAgreementBalance);
          console.log('是否单独收费', res.isAloneBalance);

          if (res.isAgreementBalance != res.isAloneBalance) {
            _this28.showFlag = true;

            if (res.isAgreementBalance == '1' && res.insuranceCompanyCode == 'IC0009') {
              _this28.isAgrB = true;
            } else {
              _this28.isAgrB = false;
            } //开始对 特别约定 的保费和费率选项进行校验
            //这里说明可以增添这个保费和费率的选项 ，如果之前的特约内容没有信息，那么这里开始添加


            for (var k = 0; k < _this28.ProposalEngageDtoList.length; k++) {
              if (_this28.ProposalEngageDtoList[k].engageCode == "CRM012") {
                if (_this28.riskCode == "CINL") {
                  if (_this28.ProposalKindDto.limitMiniPremium == "" || _this28.ProposalKindDto.limitMiniPremium == null) {
                    _this28.ProposalEngageDtoList[k].engageContent = "保费: " + _this28.ProposalKindDto.remiumCurrencyCode + " " + _this28.ProposalKindDto.sumPremium + '\r\n' + "费率: " + _this28.ProposalKindDto.proposalItemKindDtoList[0].rate + "%";
                  } else {
                    _this28.ProposalEngageDtoList[k].engageContent = "保费: " + _this28.ProposalKindDto.remiumCurrencyCode + " " + _this28.ProposalKindDto.limitMiniPremium + '\r\n' + "费率: " + _this28.ProposalKindDto.proposalItemKindDtoList[0].rate + "%";
                  }
                } else if (_this28.riskCode == "CMAR" || _this28.riskCode == "CEXP") {
                  if (_this28.ProposalKindDto.limitMiniPremium == "" || _this28.ProposalKindDto.limitMiniPremium == null) {
                    _this28.ProposalEngageDtoList[k].engageContent = "Premium: " + _this28.ProposalKindDto.remiumCurrencyCode + " " + _this28.ProposalKindDto.sumPremium + '\r\n' + "Rate: " + _this28.ProposalKindDto.proposalItemKindDtoList[0].rate + "%";
                  } else {
                    _this28.ProposalEngageDtoList[k].engageContent = "Premium: " + _this28.ProposalKindDto.remiumCurrencyCode + " " + _this28.ProposalKindDto.limitMiniPremium + '\r\n' + "Rate: " + _this28.ProposalKindDto.proposalItemKindDtoList[0].rate + "%";
                  }
                }
              }
            }
          } else {
            //这里说明不可以添加这个保费和费率的选项，需要将对应的删除
            for (var k = 0; k < _this28.ProposalEngageDtoList.length; k++) {
              if (_this28.ProposalEngageDtoList[k].engageCode == "CRM012") {
                _this28.ProposalEngageDtoList.splice(k, 1);
              }
            }

            _this28.isAgrB = false;
            _this28.showFlag = false;
          }
          /*可编辑特约复制*/


          var oldList = _this28.ProposalEngageDtoList;
          /*特约赋值*/

          _this28.ProposalEngageDtoList = res.proposalEngageDtoList; //2022-04-12 YCKK-856 批单需求保费计算根据匹配到的批单刷新免赔信息

          if (res.proposalLimitDtoList != null) {
            _this28.ProposalLimitDtoList = res.proposalLimitDtoList;

            for (var n = 0; n < _this28.ProposalLimitDtoList.length; n++) {
              if (null != _this28.ProposalLimitDtoList[n].viewType && undefined != _this28.ProposalLimitDtoList[n].viewType) {
                _this28.ProposalLimitDtoList[n].viewType = _this28.ProposalLimitDtoList[n].limitCondit + _this28.ProposalLimitDtoList[n].viewType;
              } else {
                _this28.ProposalLimitDtoList[n].viewType = _this28.ProposalLimitDtoList[n].limitCondit;
              }
            }
          }

          if (oldList != null) {
            for (var i = 0; i < oldList.length; i++) {
              if (oldList[i].updateFlag == '1' || oldList[i].engageCode == 'CRM012') {
                _this28.ProposalEngageDtoList.push(oldList[i]);
              }
            }
          }
        } else if (res.rtnCode === '7997') {
          _this28.box_8_cont = [];
          _this28.box_8 = true;

          if (res.resultErrList != null) {
            for (var i = 0; i < res.resultErrList.length; i++) {
              _this28.box_8_cont.push(res.resultErrList[i].message);
            }
          }
        } else if (res.rtnCode === '9999') {
          _this28.$message({
            message: res.rtnMsg,
            type: 'warning'
          });

          _this28.loing_box = false;
        } else {
          _this28.$message.error(res.rtnMsg);

          _this28.loing_box = false;
        }

        _this28.loing_box = false;
      }, function (res) {
        _this28.loing_box = false;
      });
    },
    //保费计算
    calculation_but: function calculation_but() {
      var _this29 = this;

      console.log(this.isSubmit_s);

      if (this.isSubmit_s == false) {
        this.$message({
          message: '请先进行保费计算',
          type: 'warning'
        });
      } else if (this.isSubmit_s == true) {
        var data = {
          proposalConveyanceDto: this.ProposalConveyanceDto,
          //运输
          proposalItemDto: this.ProposalItemDto,
          //  标的
          protocol: {
            protocolNo: this.ProposalMainDto.protocolNo,
            riskCode: this.ProposalMainDto.riskCode
          },
          proposalKindDto: {
            amountCurrencyCode: this.ProposalKindDto.amountCurrencyCode,
            amountCurrency: this.ProposalKindDto.amountCurrency,
            remiumCurrencyCode: this.ProposalKindDto.remiumCurrencyCode,
            remiumCurrency: this.ProposalKindDto.remiumCurrency,
            plusRate: this.ProposalKindDto.plusRate,
            policyItemKindDtoList: this.ProposalKindDto.proposalItemKindDtoList
          }
        }; //					var data = {
        //						"proposalConveyanceDto": {
        //							"conveyanceWayCode": "3",
        //							"conveyanceWayName": "船舶",
        //							"clinchWayCode": "1",
        //							"clinchWayName": "CIF",
        //							"freight": "5",
        //							"freightCurrency": "HKD",
        //							"freightCurrencyName": "港币",
        //							"startTime": "2020-07-24 00:00:00",
        //							"proposalConveyanceListDtoList": [{
        //								"voyageNumber": 1,
        //								"startSiteCountryCode": "ALB",
        //								"startSiteCountryName": "阿尔巴尼亚",
        //								"startSiteCityCode": "ALB009",
        //								"startSiteCityName": "圣吉尼（阿尔巴尼亚）",
        //								"endSiteCountryCode": "ALB",
        //								"endSiteCountryName": "阿尔巴尼亚",
        //								"endSiteCityCode": "ALB009",
        //								"endSiteCityName": "圣吉尼（阿尔巴尼亚）",
        //								"blName": "4",
        //								"voyageNo": "4",
        //								"shipClassCode": "1",
        //								"shipClassName": "人民公社",
        //								"shipTypesCode": "1",
        //								"shipTypes": "一级",
        //								"vessel": 24
        //							}]
        //						},
        //						"proposalItemDto": {
        //							//														"containerType": "冷藏集装箱",
        //							//														"containerTypeCode": "0",
        //							"isRefrigeRate ": "0",
        //							"isContainer ": "0",
        //							"customslistNo": "65",
        //							"invoicAmount": 300,
        //							"invoicCurrency": "港币",
        //							"invoicCurrencyCode": "HKD",
        //							"invoicNo": "5",
        //							"ladingNO": "5",
        //							"marks": "5",
        //							"packingWay": "00",
        //							"packingWayCode": "00",
        //							"proposalItemCargoDtoList": [{
        //									"cargoCode": "1",
        //									"itemType": "S1",
        //									"cargoName": "商品1",
        //									"cargoEnName": "shangpin1",
        //									"quantity": "2",
        //									"unitAmount": 100,
        //									"totalAmount": 200,
        //									"serialNo": 1,
        //									"isNewOrOld": "01",
        //									"unit": "007",
        //									"unitName": "个"
        //								},
        //								{
        //									"cargoCode": "2",
        //									"itemType": "S2",
        //									"cargoName": "商品2",
        //									"cargoEnName": "shangpin2",
        //									"quantity": "2",
        //									"unitAmount": 50,
        //									"totalAmount": 100,
        //									"serialNo": 2,
        //									"unit": "007",
        //									"isNewOrOld": "01",
        //									"unitName": "个"
        //								}
        //							],
        //							"remark": "1"
        //						},
        //						"protocol": {
        //							"protocolNo": "zpyOC21200192000102002",
        //							"riskCode": "CMAR1"
        //						},
        //						"proposalKindDto": {
        //							"amountCurrencyCode": "HKD",
        //							"amountCurrency": "港币",
        //							"remiumCurrencyCode": "HKD",
        //							"remiumCurrency": "港币",
        //							"plusRate": 110,
        //							"policyItemKindDtoList": this.ProposalKindDto.proposalItemKindDtoList
        //						}
        //
        //					}

        premiumCalculation_fun(data).then(function (res) {
          _this29.ProposalKindDto.amountCurrency = res.policyKindDto.amountCurrency;
          _this29.ProposalKindDto.amountCurrencyCode = res.policyKindDto.amountCurrencyCode;
          _this29.ProposalKindDto.exchangeRate = res.policyKindDto.exchangeRate;
          _this29.ProposalKindDto.plusRate = res.policyKindDto.plusRate;
          _this29.ProposalKindDto.remiumCurrency = res.policyKindDto.remiumCurrency;
          _this29.ProposalKindDto.remiumCurrencyCode = res.policyKindDto.remiumCurrencyCode;
          _this29.ProposalKindDto.sumPremium = res.policyKindDto.sumPremium;
          _this29.ProposalKindDto.sunAmount = res.policyKindDto.sunAmount;
          _this29.ProposalKindDto.proposalItemKindDtoList = res.policyKindDto.policyItemKindDtoList;

          _this29.$message({
            message: '保费计算成功',
            type: 'success'
          }); // this.isSubmit_cont = true

        });
      }
    },
    //暂存校验
    rules_check_Temporary: function rules_check_Temporary() {
      this.box_8_cont = [];

      if (this.ProposalConveyanceDto.conveyanceWayCode != "" || this.ProposalConveyanceDto.clinchWayCode != "" || this.ProposalConveyanceDto.startTime != "" || this.ProposalConveyanceDto.freight != "" || this.ProposalConveyanceDto.freightCurrency != "") {
        if (this.ProposalConveyanceDto.proposalConveyanceListDtoList.length <= 0) {
          this.box_8_cont.push('必须有一条航程信息');
        }
      }

      if (this.ProposalItemDto.packingWayCode != "" || this.ProposalItemDto.isRefrigeRate != "" || this.ProposalItemDto.isContainer != "" || this.ProposalItemDto.ladingNO != "" || this.ProposalItemDto.invoicNo != "" || this.ProposalItemDto.marks != "" || this.ProposalItemDto.storagePeriod != "" || this.ProposalItemDto.invoicCurrencyCode != "") {
        if (this.ProposalItemDto.proposalItemCargoDtoList.length <= 0) {
          this.box_8_cont.push('必须有一条货运货物信息');
        }
      }

      if (this.ProposalKindDto.amountCurrencyCode != "" || this.ProposalKindDto.remiumCurrencyCode != "" || this.ProposalKindDto.plusRate != "") {
        if (this.ProposalKindDto.proposalItemKindDtoList.length <= 0) {
          this.box_8_cont.push('必须有一条主附险信息');
        }
      }

      if (this.box_8_cont.length > 0) {
        this.box_8 = true;
        this.Temporary_but_flg = false;
      } else {
        this.Temporary_but_flg = true;
      }
    },
    //暂存
    Temporary_but: function Temporary_but() {
      // console.log(this.ProposalKindDto)
      // this.rules_check_Temporary()
      // if(this.Temporary_but_flg == true) {
      this.Submit_data(0); //影像文件是否上传
      // let fileUploadFlag = false
      // for (let i = 0; i < this.fileList.length; i++) {
      //   if (this.fileList[i].type === undefined || this.fileList[i].type !== 'old') {
      //     fileUploadFlag = true
      //   }
      // }
      // if (fileUploadFlag) {
      //   this.$confirm('您上传的附件尚未提交，请点击“上传文件”进行提交保存。', '提示', {
      //     confirmButtonText: '继续暂存',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.Submit_data(0)
      //   })
      // }else {
      //   this.Submit_data(0)
      // }
    },
    //提交
    Submit_but: function Submit_but() {
      var _this30 = this;

      var protocolNo = this.ProposalMainDto.protocolNo;
      var ladingNO = this.ProposalItemDto.ladingNO;
      var invoicNo = this.ProposalItemDto.invoicNo;
      var invoicAmount = this.ProposalItemDto.invoicAmount;
      var invoicCurrencyCode = this.ProposalItemDto.invoicCurrencyCode;

      if (ladingNO == undefined || ladingNO == null) {
        ladingNO = '';
      }

      if (invoicNo == undefined || invoicNo == null) {
        invoicNo = '';
      }

      if (invoicAmount == undefined || invoicAmount == null) {
        invoicAmount = 0;
      }

      if (invoicCurrencyCode == undefined || invoicCurrencyCode == null) {
        invoicCurrencyCode = '';
      }

      var data = {
        protocolNo: protocolNo,
        ladingNO: ladingNO.trim(),
        invoicNo: invoicNo.trim(),
        invoicAmount: invoicAmount,
        invoicCurrencyCode: invoicCurrencyCode
      };
      console.log(this.isSubmit_s); // if(this.ProposalMainDto.proposalNo == "" || this.ProposalMainDto.proposalNo == null) {
      // 	this.$message({
      // 		message: '请先进行暂存操作',
      // 		type: 'warning'
      // 	});
      // }else if(this.isSubmit_s == false) {

      var insuredNameCheckFlag = false; // 被保险人名称校验

      if (this.ProposalInsuredDto.isUpdateInsuredName === '1') {
        // 1--可修改    0----不可修改
        var insuredName = this.ProposalInsuredDto.insuredName; // const str = '供应链、冷链、冷库、报关、集装箱、货柜、联运、仓运、快运、配送、搬家、快递、运输、货运、航运、海运、外运、货代、物运、仓储、物流'
        // const strings = str.split('、')

        if (this.insuredNameCheck.length <= 0) {
          console.log('被保险人名称校验异常');
        }

        for (var i = 0; i < this.insuredNameCheck.length; i++) {
          var codeCname = this.insuredNameCheck[i].value;

          if (insuredName.includes(codeCname)) {
            insuredNameCheckFlag = true;
            break;
          }
        }
      } // 仓储附加险校验


      var storageLengthCheckFlag = false;
      var storageAmountCheckFlag = false;

      if (this.ProposalKindDto != null && this.ProposalItemDto != null && this.ProposalItemDto.isStorage === '1') {
        var storageProposalItemKindDtoList = this.ProposalKindDto.proposalItemKindDtoList.filter(function (item) {
          return item.editFlag === true;
        });

        if (storageProposalItemKindDtoList !== null && storageProposalItemKindDtoList.length > 0) {
          if (storageProposalItemKindDtoList.length >= 2) {
            storageLengthCheckFlag = true;
          } else {
            if (parseFloat(storageProposalItemKindDtoList[0].amount.replace(/,/g, '')) > parseFloat(this.ProposalKindDto.sunAmount.replace(/,/g, ''))) {
              storageAmountCheckFlag = true;
            }
          }
        }
      } //当“仓储\展览\加工\安装起期”大于协议止期，增加软提示：本申请单的“仓储/展览/加工/安装起期”不在OP保单期限范围内，请确认是否录入准确。


      if (this.ProposalItemDto.storageStartTime !== null && this.ProposalItemDto.storageStartTime !== '' && this.ProposalItemDto.storageStartTime !== undefined) {
        if (this.ProposalItemDto.storageStartTime > this.ProposalMainDto.agreementEndDate) {
          this.$confirm('本申请单的“仓储/展览/加工/安装起期”不在OP保单期限范围内，请确认是否录入准确', '提示', {
            confirmButtonText: '继续提交',
            cancelButtonText: '撤回修改',
            type: 'warning'
          }).then(function () {
            console.log('用户点击 继续提交');

            _this30.submit_end(storageLengthCheckFlag, storageAmountCheckFlag, insuredNameCheckFlag);
          }).catch(function () {
            // 用户点击"取消"或关闭弹窗的逻辑
            console.log('用户点击 撤回修改');
          });
        } else {
          this.submit_end(storageLengthCheckFlag, storageAmountCheckFlag, insuredNameCheckFlag);
        }
      } else {
        this.submit_end(storageLengthCheckFlag, storageAmountCheckFlag, insuredNameCheckFlag);
      }
    },
    submit_end: function submit_end(storageLengthCheckFlag, storageAmountCheckFlag, insuredNameCheckFlag) {
      var _this31 = this;

      if (this.isSubmit_s === false) {
        this.$message({
          message: '请先进行保费计算',
          type: 'warning'
        });
      } else {
        if (storageLengthCheckFlag || storageAmountCheckFlag) {
          this.$message({
            message: storageLengthCheckFlag ? '该单涉及2条及以上仓储类附加险条款，无法线上出单。' : '仓储类附加条款保额大于保单保额，请确认。',
            type: 'warning'
          });
        } else {
          // 发票支付凭证
          if (this.invoiceCollectedFlag && this.ProposalInvoiceDto.isThirdPartyPayment === '1' && this.fileList.length <= 0) {
            this.$confirm('当前为第三方支付，请点击"上传影像"后上传支付凭证。', '提示', {
              showCancelButton: false,
              confirmButtonText: '确定',
              type: 'warning'
            });
          } else {
            //保额币别 与 保费币别 校验是否一致
            //保额币别
            var amountCurrencyCode = this.ProposalKindDto.amountCurrencyCode; //保费币别

            var remiumCurrencyCode = this.ProposalKindDto.remiumCurrencyCode;

            if (!(amountCurrencyCode === remiumCurrencyCode)) {
              this.$message.error('投保单保额、保费币种不一致，请修改');
            } else {
              if (insuredNameCheckFlag) {
                this.$confirm('被保险人应为货主，本单为承运人，请确认被保险人是否有货物所有权。如被保险人无货物所有权可能导致出险后无法理赔，请了解。', '提示', {
                  confirmButtonText: '确认有货权',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  _this31.$confirm('请确认申请单是否已全部准确录入。', '提示', {
                    confirmButtonText: '继续提交',
                    cancelButtonText: '撤回修改',
                    type: 'warning'
                  }).then(function () {
                    _this31.Submit_data(1);
                  });
                });
              } else {
                this.$confirm('请确认申请单是否已全部准确录入。', '提示', {
                  confirmButtonText: '继续提交',
                  cancelButtonText: '撤回修改',
                  type: 'warning'
                }).then(function () {
                  _this31.Submit_data(1);
                });
              }
            }
          }
        }
      }
    },
    //------- 暂存/提交函数
    Submit_data: function Submit_data(type) {
      var _this32 = this;

      this.loing_box = true;
      console.log('----------------暂存数据---------------');
      var arr_list = {
        proposalItemKindDtoList: []
      };
      console.log();

      if (this.ProposalKindDto != null) {
        arr_list.amountCurrency = this.ProposalKindDto.amountCurrency;
        arr_list.amountCurrencyCode = this.ProposalKindDto.amountCurrencyCode;
        arr_list.exchangeRate = this.ProposalKindDto.exchangeRate;
        arr_list.plusRate = this.ProposalKindDto.plusRate;
        arr_list.premiumCurrency = this.ProposalKindDto.remiumCurrency;
        arr_list.premiumCurrencyCode = this.ProposalKindDto.remiumCurrencyCode;

        if (this.ProposalKindDto.sumPremium) {
          arr_list.sumPremium = parseFloat(this.ProposalKindDto.sumPremium.replace(/,/g, ""));
        }

        if (this.ProposalKindDto.sunAmount) {
          arr_list.sunAmount = parseFloat(this.ProposalKindDto.sunAmount.replace(/,/g, ""));
        }

        arr_list.limitMiniPremium = this.ProposalMainDto.limitMiniPremium;

        if (this.ProposalKindDto.sunAmount) {
          arr_list.amount = parseFloat(this.ProposalKindDto.sunAmount.replace(/,/g, ""));
        }

        if (this.ProposalKindDto.sumPremium) {
          arr_list.premium = parseFloat(this.ProposalKindDto.sumPremium.replace(/,/g, ""));
        }

        if (this.ProposalKindDto.proposalItemKindDtoList.length != 0) {
          for (var i = 0; i < this.ProposalKindDto.proposalItemKindDtoList.length; i++) {
            var obj = {};
            obj.itemKindNo = this.ProposalKindDto.proposalItemKindDtoList[i].itemKindNo;
            obj.clauseTypeCode = this.ProposalKindDto.proposalItemKindDtoList[i].clauseTypeCode;
            obj.clauseType = this.ProposalKindDto.proposalItemKindDtoList[i].clauseType;
            obj.clauseCode = this.ProposalKindDto.proposalItemKindDtoList[i].clauseCode;
            obj.clauseName = this.ProposalKindDto.proposalItemKindDtoList[i].clauseName;
            obj.kindCode = this.ProposalKindDto.proposalItemKindDtoList[i].kindCode;
            obj.kindName = this.ProposalKindDto.proposalItemKindDtoList[i].kindName;
            obj.amount = parseFloat(this.ProposalKindDto.proposalItemKindDtoList[i].amount.replace(/,/g, ""));
            obj.rate = this.ProposalKindDto.proposalItemKindDtoList[i].rate;

            if (typeof this.ProposalKindDto.proposalItemKindDtoList[i].premium == 'string') {
              obj.premium = parseFloat(this.ProposalKindDto.proposalItemKindDtoList[i].premium.replace(/,/g, ""));
              console.log("*****", obj.premium);
            } else {
              obj.premium = this.ProposalKindDto.proposalItemKindDtoList[i].premium;
            } // obj.premium = this.ProposalKindDto.proposalItemKindDtoList[i].premium


            obj.remark = this.ProposalKindDto.proposalItemKindDtoList[i].remark;
            obj.unitAmount = parseFloat(this.ProposalKindDto.proposalItemKindDtoList[i].amount.replace(/,/g, "")); // obj.unitPremium = this.ProposalKindDto.proposalItemKindDtoList[i].premium

            if (typeof this.ProposalKindDto.proposalItemKindDtoList[i].premium == 'string') {
              obj.unitPremium = parseFloat(this.ProposalKindDto.proposalItemKindDtoList[i].premium.replace(/,/g, ""));
              console.log("*****", obj.unitPremium);
            } else {
              obj.unitPremium = this.ProposalKindDto.proposalItemKindDtoList[i].premium;
            } //					if(this.ProposalKindDto.proposalItemKindDtoList[i].clauseTypeCode == "1") {
            //						obj.calculateFlag = "Y"
            //					} else if(this.ProposalKindDto.proposalItemKindDtoList[i].clauseTypeCode == "2") {
            //						obj.calculateFlag = "N"
            //					}


            arr_list.proposalItemKindDtoList.push(obj);
          }
        }
      }

      console.log(this.ProposalKindDto);

      if (this.ProposalKindDto != null) {
        if (this.ProposalKindDto.sunAmount) {
          this.ProposalMainDto.sumAmount = this.ProposalKindDto.sunAmount.replace(/,/g, "");
        }

        if (this.ProposalKindDto.sumPremium) {
          this.ProposalMainDto.sumPremium = this.ProposalKindDto.sumPremium.replace(/,/g, "");
        }

        console.log("1111");
        this.ProposalMainDto.amountCurrencyCode = this.ProposalKindDto.amountCurrencyCode;
        this.ProposalMainDto.amountCurrency = this.ProposalKindDto.amountCurrency;
        this.ProposalMainDto.premiumCurrencyCode = this.ProposalKindDto.remiumCurrencyCode;
        this.ProposalMainDto.premiumCurrency = this.ProposalKindDto.remiumCurrency;
        this.ProposalMainDto.limitMiniPremium = this.ProposalKindDto.limitMiniPremium;

        if (this.ProposalKindDto.proposalItemKindDtoList.length > 0) {
          for (var i = 0; i < this.ProposalKindDto.proposalItemKindDtoList.length; i++) {
            if (this.ProposalKindDto.proposalItemKindDtoList[i].clauseType == "主险") {
              if (this.ProposalKindDto.proposalItemKindDtoList[i].policyItemCargoDtoList != undefined) {
                for (var j = 0; j < this.ProposalKindDto.proposalItemKindDtoList[i].policyItemCargoDtoList.length; j++) {
                  this.ProposalItemDto.proposalItemCargoDtoList[j].feeRate = this.ProposalKindDto.proposalItemKindDtoList[i].policyItemCargoDtoList[j].feeRate;
                  this.ProposalItemDto.proposalItemCargoDtoList[j].carGoAmount = this.ProposalKindDto.proposalItemKindDtoList[i].policyItemCargoDtoList[j].amount;
                  this.ProposalItemDto.proposalItemCargoDtoList[j].carGoPremium = this.ProposalKindDto.proposalItemKindDtoList[i].policyItemCargoDtoList[j].premium;
                }
              }
            }
          }
        }
      } // 判断单价/总价/发票金额为字符串时转换数字
      // 发票金额


      if (typeof this.ProposalItemDto.invoicAmount == "string") {
        this.ProposalItemDto.invoicAmount = parseFloat(this.ProposalItemDto.invoicAmount.replace(/,/g, "")); // console.log(this.ProposalItemDto.invoicAmount,'pp***')
      } else {
        this.ProposalItemDto.invoicAmount = this.ProposalItemDto.invoicAmount;
      }

      for (var i = 0; i < this.ProposalItemDto.proposalItemCargoDtoList.length; i++) {
        // 总价
        if (typeof this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount == "string") {
          this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = parseFloat(this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount.replace(/,/g, "")); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount)
        } else {
          this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount;
        } // 单价


        if (typeof this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount == "string") {
          this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = parseFloat(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount.replace(/,/g, "")); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)
        } else {
          this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount;
        } // 车辆价格


        if (typeof this.ProposalItemDto.proposalItemCargoDtoList[i].vehiclePrice == "string") {
          this.ProposalItemDto.proposalItemCargoDtoList[i].vehiclePrice = parseFloat(this.ProposalItemDto.proposalItemCargoDtoList[i].vehiclePrice.replace(/,/g, ""));
        } else {
          this.ProposalItemDto.proposalItemCargoDtoList[i].vehiclePrice = this.ProposalItemDto.proposalItemCargoDtoList[i].vehiclePrice;
        } //数量


        if (typeof this.ProposalItemDto.proposalItemCargoDtoList[i].quantity == "string") {
          this.ProposalItemDto.proposalItemCargoDtoList[i].quantity = parseFloat(this.ProposalItemDto.proposalItemCargoDtoList[i].quantity.replace(/,/g, "")); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)
        } else {
          this.ProposalItemDto.proposalItemCargoDtoList[i].quantity = this.ProposalItemDto.proposalItemCargoDtoList[i].quantity;
        }
      } //				console.log(this.ProposalMainDto)
      //				console.log(arr_list)


      console.log('shipFlag=' + this.shipFlag);

      if (this.shipFlag) {
        this.ProposalMainDto.shipInvokeFlag = '1';
      } else {
        this.ProposalMainDto.shipInvokeFlag = '0';
      }

      for (var k = 0; k < this.ProposalEngageDtoList.length; k++) {
        if (this.ProposalEngageDtoList[k].engageCode == "CRM012") {
          this.ProposalEngageDtoList[k].updateFlag = "0";
        }
      }

      var data = {
        proposalMainDto: this.ProposalMainDto,
        //基本信息
        proposalApplicantDto: this.ProposalApplicantDto,
        //投保人
        proposalInsuredDto: this.ProposalInsuredDto,
        //被保险人
        proposalConveyanceDto: this.ProposalConveyanceDto,
        //运输
        proposalItemDto: this.ProposalItemDto,
        //  标的
        proposalKindDto: arr_list,
        //  主附加险
        proposalEngageDtoList: this.ProposalEngageDtoList,
        //   特约
        proposalLimitDtoList: this.ProposalLimitDtoList,
        //   限额免赔
        proposalInvoiceDto: this.invoiceCollectedFlag ? this.ProposalInvoiceDto : null,
        // 发票信息
        proposalNO: this.proposalNO,
        inVoIcNo: this.inVoIcNo,
        inVoIcCurrency: this.inVoIcCurrency,
        ladIngNo: this.ladIngNo,
        proposalStatus: this.proposalStatus,
        inVoIcAmount: this.inVoIcAmount,
        repetitionType: this.isRepetition_s,
        typeFlag: type //(0-暂存,1-提交)

      }; //				var data = {
      //					proposalMainDto: this.ProposalMainDto, //基本信息
      //					proposalApplicantDto: this.ProposalApplicantDto, //投保人
      //					proposalInsuredDto: this.ProposalInsuredDto, //被保险人
      //
      //					"proposalConveyanceDto": {
      //						"conveyanceWayCode": "3",
      //						"conveyanceWayName": "船舶",
      //						"clinchWayCode": "4",
      //						"clinchWayName": "EXW",
      //						"freight": "5",
      //						"freightCurrency": "HKD",
      //						"freightCurrencyName": "港币",
      //						"startTime": "2020-07-24 00:00:00",
      //						"proposalConveyanceListDtoList": [{
      //							"voyageNumber": 1,
      //							"startSiteCountryCode": "ALB",
      //							"startSiteCountryName": "阿尔巴尼亚",
      //							"startSiteCityCode": "ALB009",
      //							"startSiteCityName": "圣吉尼（阿尔巴尼亚）",
      //							"endSiteCountryCode": "ALB",
      //							"endSiteCountryName": "阿尔巴尼亚",
      //							"endSiteCityCode": "ALB009",
      //							"endSiteCityName": "圣吉尼（阿尔巴尼亚）",
      //							"blName": "4",
      //							"voyageNo": "4",
      //							"shipClassCode": "1",
      //							"shipClassName": "人民公社",
      //							"shipTypesCode": "1",
      //							"shipTypes": "一级",
      //							"vessel": 24
      //						}]
      //					},
      //					"proposalItemDto": {
      //						//														"containerType": "冷藏集装箱",
      //						//														"containerTypeCode": "0",
      //						"isRefrigeRate ": "0",
      //						"isContainer ": "0",
      //						"customslistNo": "65",
      //						"invoicAmount": 300,
      //						"invoicCurrency": "港币",
      //						"invoicCurrencyCode": "HKD",
      //						"invoicNo": "5",
      //						"ladingNO": "5",
      //						"marks": "5",
      //						"packingWay": "00",
      //						"packingWayCode": "00",
      //						"proposalItemCargoDtoList": [{
      //								"cargoCode": "1",
      //								"itemType": "S1",
      //								"cargoName": "商品1",
      //								"cargoEnName": "shangpin1",
      //								"quantity": "2",
      //								"unitAmount": 100,
      //								"totalAmount": 200,
      //								"serialNo": 1,
      //								"isNewOrOld": "01",
      //								"unit": "007",
      //								"unitName": "个"
      //							},
      //							{
      //								"cargoCode": "2",
      //								"itemType": "S2",
      //								"cargoName": "商品2",
      //								"cargoEnName": "shangpin2",
      //								"quantity": "2",
      //								"unitAmount": 50,
      //								"totalAmount": 100,
      //								"serialNo": 2,
      //								"unit": "007",
      //								"isNewOrOld": "01",
      //								"unitName": "个"
      //							}
      //						],
      //						"remark": "1"
      //					},
      //					proposalKindDto: arr_list, //  主附加险
      //
      //					proposalEngageDtoList: this.ProposalEngageDtoList, //   特约
      //					proposalLimitDtoList: this.ProposalLimitDtoList, //   限额免赔
      //					"typeFlag": type
      //				}

      data.proposalInsuredDto.serialNo = "1";
      saveOrSubmit(data).then(function (res) {
        //					console.log(res)
        if (res.rtnCode == "0000") {
          _this32.ProposalMainDto.proposalNo = res.proposalNo;

          if (type == "0") {
            _this32.$message({
              message: '暂存成功',
              type: 'success'
            }); // 日本元或非日本元时 千分位展示
            // 发票金额


            if (_this32.ProposalItemDto.invoicCurrencyCode == "JPY") {
              _this32.ProposalItemDto.invoicAmount = toThousands(Math.round(_this32.ProposalItemDto.invoicAmount));
              console.log(_this32.ProposalItemDto.invoicAmount, 'pp***');
            } else {
              _this32.ProposalItemDto.invoicAmount = num3_type_fun(_this32.ProposalItemDto.invoicAmount);
              console.log(_this32.ProposalItemDto.invoicAmount);
            }

            console.log('暂存提交---------------1');

            for (var i = 0; i < _this32.ProposalItemDto.proposalItemCargoDtoList.length; i++) {
              // 总价
              if (_this32.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount != null) {
                if (_this32.ProposalItemDto.invoicCurrencyCode == "JPY") {
                  _this32.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = toThousands(Math.round(_this32.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount)); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount)
                } else {
                  _this32.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount = num5_type_fun(_this32.ProposalItemDto.proposalItemCargoDtoList[i].totalAmount);
                }
              }

              _this32.ProposalItemDto.proposalItemCargoDtoList[i].quantity = num4_type_fun(_this32.ProposalItemDto.proposalItemCargoDtoList[i].quantity); // 单价

              if (_this32.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount != null) {
                if (_this32.ProposalItemDto.invoicCurrencyCode == "JPY") {
                  _this32.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = toThousands(Math.round(_this32.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)); // console.log(this.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount)
                } else {
                  _this32.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount = num4_type_fun(_this32.ProposalItemDto.proposalItemCargoDtoList[i].unitAmount);
                }
              }
            }

            _this32.init_geton();
          } else {
            // this.$message({
            // 	message: '提交成功',
            // 	type: 'success'
            // });
            // this.$store.dispatch('delVisitedViews', this.$route)
            // this.$router.push({
            // 	name: 'submitsuccess',
            // 	params: {
            // 		proposalNo: res.proposalNo,
            // 		protocolNo: this.ProposalMainDto.protocolNo
            // 	}
            // });
            _this32.box_10 = true;

            _this32.init_geton();

            _this32.cont_proposalNo = res.proposalNo;
          }
        } else {
          var datastr = res.data;

          if (datastr == null) {
            datastr = '';
          }

          if (type == "0") {
            if (res.rtnCode == "9999") {
              _this32.$message({
                message: "暂存失败 " + datastr,
                type: 'warning'
              });
            } // this.$message.error('暂存失败');

          } else {
            // this.$message.error('提交失败');
            console.log("提交失败------------------");

            if (res.rtnCode == "9999") {
              _this32.$message({
                message: "提交失败 " + datastr,
                type: 'warning'
              });
            }
          }
        }

        _this32.loing_box = false;
      }, function (res) {
        _this32.loing_box = false;
      });
    },
    //------- 继续操作
    go_operate: function go_operate() {
      this.$router.push({
        name: 'submitsuccess',
        params: {
          proposalNo: this.cont_proposalNo,
          protocolNo: this.ProposalMainDto.protocolNo
        }
      });
      this.loing_box = false;
      this.box_8 = false;
    },
    // 获取自核是否成功
    init_geton: function init_geton() {
      var _this33 = this;

      this.applicationNo = this.ProposalMainDto.proposalNo;
      var reqdata = {
        proposalNo: this.ProposalMainDto.proposalNo
      };
      policyfromcheck_fun(reqdata).then(function (res) {
        if (res.isUndwrt == "1") {
          _this33.cigreen = true; //this.cigary = false;
        } else if (res.isUndwrt == "0") {
          _this33.nuclearfailure = res.isUndwrtMessage;
          _this33.since = true;
          _this33.cigreen = false; //this.cigary = true
        }
      });
    },
    // 这是一个定时器
    doPolicyTimer: function doPolicyTimer(type) {
      var _this34 = this;

      var doPolicyTimerId = setInterval(function () {
        var timeCount = Date.now();
        console.log("轮询" + timeCount + '    type:' + type);

        if (timeCount - _this34.doPolicyCount > 120000) {
          console.log("轮询结束--------2分钟超时关闭");
          clearInterval(doPolicyTimerId);

          _this34.$alert('<p>数据正在推送核心，请稍等片刻再查询投保单状态，投保单状态变更前请不要进行重复操作</p>', '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: function callback(action) {
              _this34.$store.dispatch('delVisitedViews', _this34.$route);

              _this34.$router.push({
                path: "/policymanagement/policysearch"
              });
            }
          });

          _this34.loing_box = false;
        } else {
          console.log("判断是否轮询");

          if (_this34.doPolicy1 == 0 && _this34.doPolicy2 == 0) {
            console.log("每隔5秒-------------------轮询接口调用开始");
            var data = {
              reqProposalCallDtoList: [{
                proposalNo: _this34.cont_proposalNo,
                type: type
              }]
            };

            if (type == '1' || type == '2') {
              proposalCallBack_fun(data).then(function (res) {
                if (res.rtnCode == '0000') {
                  var typeStr1 = '电子保单';

                  if ('2' == type) {
                    typeStr1 = 'CI凭证';
                  }

                  var businessNo = res.businessNo;

                  if (businessNo == null) {
                    businessNo = '';
                  }

                  if (res.policyNo == null) {
                    console.log(typeStr1 + '<<<<<<<<<<<<<<<<<<' + type);

                    _this34.$alert('<p>询价单号：' + businessNo + '</p><p>申请' + typeStr1 + '，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                      dangerouslyUseHTMLString: true,
                      confirmButtonText: '确定',
                      callback: function callback(action) {
                        _this34.$store.dispatch('delVisitedViews', _this34.$route);

                        _this34.$router.push({
                          path: "/policymanagement/policysearch"
                        });
                      }
                    });
                  } else {
                    console.log(typeStr1 + '<<<<<<<<<<<<<<<<<<' + type);

                    _this34.$alert('<p>询价单号：' + businessNo + '</p><p>保单号：' + res.policyNo + '</p><p>申请' + typeStr1 + '，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                      dangerouslyUseHTMLString: true,
                      confirmButtonText: '确定',
                      callback: function callback(action) {
                        _this34.$store.dispatch('delVisitedViews', _this34.$route);

                        _this34.$router.push({
                          path: "/policymanagement/policysearch"
                        });
                      }
                    });
                  }

                  _this34.doPolicy2 = 1;
                  _this34.loing_box = false;
                } else if (res.rtnCode == '9999') {
                  console.log("没有结果继续轮询");
                } else if (res.rtnCode == '0001') {
                  _this34.$message({
                    message: '推送保险公司失败，请联系保险公司管理员！',
                    type: 'warning'
                  });
                }
              });
            }
          } else {
            console.log("判断不轮询-----------轮询结束--------状态变化关闭");
            clearInterval(doPolicyTimerId);
          }
        }
      }, 5000);
    },
    //-------------------------    1-申请电子保单，2-申请CI凭证，3-申报
    get_data: function get_data(type) {
      var _this35 = this;

      console.log('0000000000000', type);
      this.box_10 = false;
      this.loing_box = true;
      console.log('函数里', this.new_address_list);
      var data = {
        address: this.new_address_list,
        reqProposalCallDtoList: [{
          proposalNo: this.cont_proposalNo,
          protocolNo: this.ProposalMainDto.protocolNo,
          type: type
        }],
        originalAmount: this.agentPrint.originalAmount || '',
        copyAmount: this.agentPrint.copyAmount || ''
      };
      var strType = '电子保单';

      if (type == '2') {
        strType = 'CI凭证';
      }

      if (type == '1' || type == '2') {
        proposalCallWriteBack_fun(data).then(function (res) {
          console.log("申请电子保单/CI凭证结果开始" + _this35.doPolicy2);
          _this35.forbidFastClickFlag = false;

          if (_this35.doPolicy2 == 0) {
            console.log(res.rtnCode);

            if (res.rtnCode == "0000") {
              // this.$message({
              // 	message: '申请电子保单，提交成功，请在投保单/保单查询菜单执行后续操作',
              // 	type: 'success'
              // });
              // alert("询价单号：" + res.businessNo + "\n" + "申请电子保单，提交成功，请在投保单/保单查询菜单执行后续操作")
              if (res.policyNo == null) {
                _this35.$alert('<p>询价单号：' + res.businessNo + '</p><p>申请' + strType + '，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: '确定',
                  callback: function callback(action) {
                    _this35.$store.dispatch('delVisitedViews', _this35.$route);

                    _this35.$router.push({
                      path: "/policymanagement/policysearch"
                    });
                  }
                });
              } else {
                var policyNoRes = res.policyNo;

                if (policyNoRes === null || policyNoRes === undefined) {
                  policyNoRes = '';
                }

                _this35.$alert('<p>询价单号：' + res.businessNo + '</p><p>保单号：' + policyNoRes + '</p><p>申请' + strType + '，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: '确定',
                  callback: function callback(action) {
                    _this35.$store.dispatch('delVisitedViews', _this35.$route);

                    _this35.$router.push({
                      path: "/policymanagement/policysearch"
                    });
                  }
                });
              }
            } else if (res.rtnCode == "9999") {
              // this.$message({
              // 	message: '申请电子保单，提交失败',
              // 	type: 'warning'
              // });
              // alert("申请电子保单，提交失败")
              _this35.$alert('<p>' + res.data + '</p>', '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: function callback(action) {
                  _this35.$store.dispatch('delVisitedViews', _this35.$route);

                  _this35.$router.push({
                    path: "/policymanagement/policysearch"
                  });
                }
              });
            } else if (res.rtnCode == '0001') {
              _this35.$message({
                message: '推送保险公司失败，请联系保险公司管理员！',
                type: 'warning'
              });
            } else {
              /*this.$alert('<p>申请电子保单，提交失败</p>', '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: action => {
                  this.$store.dispatch('delVisitedViews', this.$route);
                  this.$router.push({
                    path: `/policymanagement/policysearch`
                  });
                }
              });*/
            }

            console.log("------------------------");
            _this35.loing_box = false;
            _this35.doPolicy1 = 1;
          }
        }, function (res) {
          _this35.forbidFastClickFlag = false;
          _this35.loing_box = false;
        });
      }
      /*
      else if (type == "2") {
      	proposalCallWriteBack_fun(data).then(res => {
      			if(res.rtnCode == "0000") {
      			// this.$message({
      			// 	message: '提交成功',
      			// 	type: 'success'
      			// });
      			this.$alert('<p>申请CI凭证成功</p>', '', {
      				dangerouslyUseHTMLString: true,
      				confirmButtonText: '确定',
      				callback: action => {
      					this.$store.dispatch('delVisitedViews', this.$route);
      					this.$router.push({
      						path: `/policymanagement/policysearch`
      					});
      				}
      			});
      		}else if (res.rtnCode == "9999") {
      			// this.$message({
      			// 	message: '该记录不满足自核规则，需转小保单投保',
      			// 	type: 'warning'
      			// });
      			this.$alert('<p>申请CI凭证失败</p>', '', {
      				dangerouslyUseHTMLString: true,
      				confirmButtonText: '确定',
      				callback: action => {
      					this.$store.dispatch('delVisitedViews', this.$route);
      					this.$router.push({
      						path: `/policymanagement/policysearch`
      					});
      				}
      			});
      		}
      		this.loing_box = false
      	})
      	}*/
      else if (type == "3") {
          proposalCallWriteBack_fun(data).then(function (res) {
            if (res.rtnCode == "0000") {
              // this.$message({
              // 	message: '申报确认，提交成功，请在投保单/保单查询菜单执行后续操作',
              // 	type: 'success'
              // });
              _this35.$alert('<p>批改申请单号：' + res.businessNo + '</p><p>申报确认，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: function callback(action) {
                  _this35.$store.dispatch('delVisitedViews', _this35.$route);

                  _this35.$router.push({
                    path: "/policymanagement/policysearch"
                  });
                }
              });
            } else if (res.rtnCode == "9999") {
              // this.$message({
              // 	message: '申报确认，提交失败',
              // 	type: 'warning'
              // });
              _this35.$alert('<p>' + res.data + '</p>', '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: function callback(action) {
                  _this35.$store.dispatch('delVisitedViews', _this35.$route);

                  _this35.$router.push({
                    path: "/policymanagement/policysearch"
                  });
                }
              });
            }

            _this35.loing_box = false;
          });
        }

      ;
    },
    // 申请电子保单 ci凭证
    cancelPrintAgent: function cancelPrintAgent() {
      this.agentPrintShow = false;
      this.$refs['agentPrint'].resetFields();
    },
    savePrintAgent: function savePrintAgent() {
      var _this36 = this;

      this.forbidFastClickFlag = true;
      this.$refs['agentPrint'].validate(function (valid) {
        if (valid) {
          _this36.agentPrintShow = false;

          if (_this36.agentPrintTitle === '电子保单') {
            if (_this36.ProposalMainDto.insuranceCompanyCode == 'IC0009') {
              setTimeout(_this36.doPolicyTimer('1'), 20000);
            }

            _this36.get_data(1);
          } else if (_this36.agentPrintTitle === 'CI凭证') {
            if (_this36.ProposalMainDto.insuranceCompanyCode == 'IC0009') {
              setTimeout(_this36.doPolicyTimer('2'), 20000);
            }

            _this36.get_data(2);
          }

          _this36.$refs['agentPrint'].resetFields();
        }
      });
    },
    //申请电子保单
    ask_policy: function ask_policy() {
      var _this37 = this;

      console.log(this.ProposalKindDto.sumPremium);
      console.log(this.ProposalKindDto.limitMiniPremium);
      this.ProposalKindDto.sumPremium = this.ProposalKindDto.sumPremium.replaceAll(',', '');
      console.log(this.ProposalKindDto.sumPremium);
      console.log(this.ProposalKindDto.limitMiniPremium);

      if (Number(this.ProposalKindDto.sumPremium) <= Number(this.ProposalKindDto.limitMiniPremium)) {
        var risk = this.$route.params.riskName;
        debugger;
        var remiumCurrency = this.ProposalKindDto.remiumCurrency;

        if (this.ProposalKindDto.remiumCurrency == '人民币元 - CNY') {
          remiumCurrency = this.ProposalKindDto.remiumCurrency.substring(0, 3);
        }

        remiumCurrency = remiumCurrency.split("-");

        if (risk == "陆上运输货物保险") {
          this.box_10 = false;
          this.$confirm('本保单的实际应收保费低于最低保费：' + remiumCurrency[0].trim() + this.ProposalKindDto.limitMiniPremium + '元 ，本单将按最低保费收取并附加 "CAG133-三井住友附加最低保费保险条款"，请了解。', '提示', {
            confirmButtonText: '了解并确定',
            cancelButtonText: '取消并退回',
            type: 'warning',
            customClass: 'custom-message-frame'
          }).then(function () {
            _this37.agentPrintShow = true;
            _this37.agentPrintTitle = '电子保单';
            _this37.doPolicy1 = 0;
            _this37.doPolicy2 = 0;
            _this37.doPolicyCount = Date.now();
            var data = {
              //投保单申请号
              proposalNo: _this37.ProposalMainDto.proposalNo,
              //产品名称
              riskName: _this37.$route.params.riskName
            };
            console.log(data);
            saveNewClause(data).then(function (res) {
              if (res.resultCode == '0000') {
                _this37.$message({
                  message: '保存条款成功',
                  type: 'success'
                });
              } else if (res.resultCode == '9999') {
                _this37.$message({
                  message: '保存条款失败',
                  type: 'error'
                });

                return;
              }
            });
          }).catch(function () {
            _this37.box_10 = true;
          });
        } else if (risk == "进口货物运输保险") {
          this.box_10 = false;
          this.$confirm('本保单的实际应收保费低于最低保费：' + remiumCurrency[0].trim() + this.ProposalKindDto.limitMiniPremium + '元 ，本单将按最低保费收取并附加 "CAG133E-MINIMUM PREMIUM CLAUSE"，请了解。', '提示', {
            confirmButtonText: '了解并确定',
            cancelButtonText: '取消并退回',
            type: 'warning',
            customClass: 'custom-message-frame'
          }).then(function () {
            _this37.agentPrintShow = true;
            _this37.agentPrintTitle = '电子保单';
            _this37.doPolicy1 = 0;
            _this37.doPolicy2 = 0;
            _this37.doPolicyCount = Date.now();
            var data = {
              //投保单申请号
              proposalNo: _this37.ProposalMainDto.proposalNo,
              //产品名称
              riskName: _this37.$route.params.riskName
            };
            console.log(data);
            saveNewClause(data).then(function (res) {
              if (res.resultCode == '0000') {
                _this37.$message({
                  message: '保存条款成功',
                  type: 'success'
                });
              } else if (res.resultCode == '9999') {
                _this37.$message({
                  message: '保存条款失败',
                  type: 'error'
                });

                return;
              }
            });
          }).catch(function () {
            _this37.box_10 = true;
          });
        } else if (risk == "出口货物运输保险") {
          this.box_10 = false;
          this.$confirm('本保单的实际应收保费低于最低保费：' + remiumCurrency[0].trim() + this.ProposalKindDto.limitMiniPremium + '元 ，本单将按最低保费收取并附加 "CAG133E-MINIMUM PREMIUM CLAUSE"，请了解。', '提示', {
            confirmButtonText: '了解并确定',
            cancelButtonText: '取消并退回',
            type: 'warning',
            customClass: 'custom-message-frame'
          }).then(function () {
            _this37.agentPrintShow = true;
            _this37.agentPrintTitle = '电子保单';
            _this37.doPolicy1 = 0;
            _this37.doPolicy2 = 0;
            _this37.doPolicyCount = Date.now();
            var data = {
              //投保单申请号
              proposalNo: _this37.ProposalMainDto.proposalNo,
              //产品名称
              riskName: _this37.$route.params.riskName
            };
            console.log(data);
            saveNewClause(data).then(function (res) {
              if (res.resultCode == '0000') {
                _this37.$message({
                  message: '保存条款成功',
                  type: 'success'
                });
              } else if (res.resultCode == '9999') {
                _this37.$message({
                  message: '保存条款失败',
                  type: 'error'
                });

                return;
              }
            });
          }).catch(function () {
            _this37.box_10 = true;
          });
        }
      } else {
        this.agentPrintShow = true;
        this.agentPrintTitle = '电子保单';
        this.doPolicy1 = 0;
        this.doPolicy2 = 0;
        this.doPolicyCount = Date.now();
      }
    },
    //申请电子凭证
    ask_policy_assess1: function ask_policy_assess1() {
      this.agentPrintShow = true;
      this.agentPrintTitle = 'CI凭证';
      this.doPolicy1 = 0;
      this.doPolicy2 = 0;
      this.doPolicyCount = Date.now();
    },
    close_CheckOC: function close_CheckOC() {
      this.box_11 = false;
    },
    ask_policy_assess: function ask_policy_assess() {
      this.agentShow = true;
    },
    //申报确认
    ask_policy_confirm: function ask_policy_confirm() {
      this.get_data(3);
    },
    handleClose_box: function handleClose_box(done) {
      this.box_10 = false;
      this.$store.dispatch('delVisitedViews', this.$route);
      this.$router.push({
        path: "/policymanagement/policysearch"
      });
    },
    //投保单申请号
    proposalNo_ch: function proposalNo_ch(val) {
      if (val == null || val == "") {
        this.text1.proposalNo = "请输入投保单申请号";
      } else {
        this.text1.proposalNo = "";
      }
    },
    //OP协议号
    protocolNo_ch: function protocolNo_ch(val) {
      if (val == null || val == "") {
        this.text1.protocolNo = "请输入OP协议号";
      } else {
        this.text1.protocolNo = "";
      }
    },
    //OP协议期间
    dates_ch: function dates_ch(val) {
      //				console.log(val)
      if (val == null || val == "") {
        this.text1.dates = "请输入OP协议期间";
      } else {
        this.text1.dates = "";
        this.ProposalMainDto.agreementStartDate = val[0];
        this.ProposalMainDto.agreementEndDate = val[1];
      }
    },
    //保险公司
    insuranceCompanyName_ch: function insuranceCompanyName_ch(val) {
      if (val == null || val == "") {
        this.text1.insuranceCompanyName = "请输入保险公司";
      } else {
        this.text1.insuranceCompanyName = "";
      }
    },
    //分支机构
    companyName_ch: function companyName_ch(val) {
      if (val == null || val == "") {
        this.text1.companyName = "请输入分支机构";
      } else {
        this.text1.companyName = "";
      }
    },
    //投保人名称
    applicantName_ch: function applicantName_ch(val) {
      if (val == null || val == "") {
        this.text2.applicantName = "请输入投保人名称";
      } else {
        this.text2.applicantName = "";
      }
    },
    //注册地址
    registeredAddress_ch: function registeredAddress_ch(val) {
      if (val == null || val == "") {
        this.text2.registeredAddress = "请输入注册地址";
      } else {
        this.text2.registeredAddress = "";
      }
    },
    //联系人名称
    linkmanName_ch: function linkmanName_ch(val) {
      if (val == null || val == "") {
        this.text2.linkmanName = "请输入联系人名称";
      } else {
        this.text2.linkmanName = "";
      }
    },
    //证件类型
    identifyType_ch1: function identifyType_ch1(val) {
      var obj = {};
      obj = this.options.find(function (item) {
        //这里的userList就是上面遍历的数据源
        return item.value === val; //筛选出匹配数据
      });
      this.identifyNumber_ch1_1();
      this.ProposalApplicantDto.identifyTypeName = obj.label;

      if (val == null || val == "") {
        this.text2.identifyType = "请输入证件类型";
      } else {
        this.text2.identifyType = "";
      }
    },
    //证件号
    identifyNumber_ch1: function identifyNumber_ch1(val) {
      if (val == null || val == "") {
        this.text2.identifyNumber = "请输入证件号";
      } else {
        this.text2.identifyNumber = "";
      }
    },
    identifyNumber_ch1_1: function identifyNumber_ch1_1() {
      if (this.ProposalApplicantDto.identifyType && this.ProposalApplicantDto.identifyType == '10' && this.ProposalApplicantDto.nationalFlag != '2') {
        if (this.ProposalApplicantDto.identifyNumber && /^[0-9a-zA-Z]{18}$/.test(this.ProposalApplicantDto.identifyNumber)) {
          this.fromdata = false;
        } else {
          this.$message({
            message: '投保人信息：境内外标识为不为境外时，且证件类型为社会统一信用代码时，证件号必须是由18位数字或字母组成的。',
            type: 'warning'
          });
        }
      }
    },
    //联系电话
    linkmanPhone_ch: function linkmanPhone_ch(val) {
      if (val == null || val == "") {
        this.text2.linkmanPhone = "请输入联系电话";
      } else {
        if (checkPhone(val) == false) {
          this.text2.linkmanPhone = "请输入正确联系电话";
        } else {
          this.text2.linkmanPhone = "";
        }
      }
    },
    //联系地址
    linkmanAddress_ch: function linkmanAddress_ch(val) {
      if (val == null || val == "") {
        this.text2.linkmanAddress = "请输入注册地址";
      } else {
        this.text2.linkmanAddress = "";
      }
    },
    //联系邮箱地址
    linkmanEmail_ch: function linkmanEmail_ch(val) {
      var _this38 = this;

      if (val == null || val == "") {
        this.text2.email = "请输入邮箱";
      } else {
        this.text2.email = "";
        var valueList = val.split(",");
        valueList.map(function (item) {
          var re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g;

          if (item) {
            if (!re.test(item)) {
              _this38.text2.email = "电子邮箱格式不正确";
            }
          }
        });
      }
    },
    //被保险人名称
    insuredName_ch: function insuredName_ch(val) {
      if (val == null || val == "") {
        this.text3.insuredName = "请输入被保险人名称";
      } else {
        this.text3.insuredName = "";
      }
    },
    //被保险人英文名称
    insuredEnName_ch: function insuredEnName_ch(val) {
      if (val == null || val == "") {
        this.text3.insuredEnName = "请输入被保险人英文名称";
      } else {
        this.text3.insuredEnName = "";
      }
    },
    //证件类型
    identifyType_ch2: function identifyType_ch2(val) {
      // 若【境内外标识】为境外时，证件类型和证件号非必填
      var nationalFlag = this.ProposalInsuredDto.nationalFlag;

      if (nationalFlag !== '2') {
        if (val == null || val == "") {
          this.text3.identifyType = "请输入证件类型";
        } else {
          this.text3.identifyType = "";
        }
      } else {
        this.text3.identifyType = "";
      }

      var obj = {};
      obj = this.idCard_option.find(function (item) {
        //这里的userList就是上面遍历的数据源
        return item.value === val; //筛选出匹配数据
      });
      console.log('*********************' + this.ProposalInsuredDto.identifyType);
      this.identifyNumber_ch2_2();
      this.ProposalInsuredDto.identifyTypeName = obj.label;
    },
    //证件号
    identifyNumber_ch2: function identifyNumber_ch2(val) {
      // 若【境内外标识】为境外时，证件类型和证件号非必填
      var nationalFlag = this.ProposalInsuredDto.nationalFlag;

      if (nationalFlag !== '2') {
        if (val == null || val === "") {
          this.text3.identifyNumber = "请输入证件号";
        } else {
          this.text3.identifyNumber = "";
        }
      } else {
        this.text3.identifyNumber = "";
      }
    },
    identifyNumber_ch2_2: function identifyNumber_ch2_2() {
      console.log(this.ProposalInsuredDto.identifyType + '   identifyNumber_ch2_2----  ' + this.ProposalInsuredDto.nationalFlag);

      if (this.ProposalInsuredDto.identifyType && this.ProposalInsuredDto.identifyType == '10' && this.ProposalInsuredDto.nationalFlag != '2') {
        if (this.ProposalInsuredDto.identifyNumber && /^[0-9a-zA-Z]{18}$/.test(this.ProposalInsuredDto.identifyNumber)) {} else {
          this.$message({
            message: '被保险人信息：境内外标识为不为境外时，且证件类型为社会统一信用代码时，证件号必须是由18位数字或字母组成的。',
            type: 'warning'
          });
        }
      }
    },
    //地址
    address_ch: function address_ch(val) {
      if (val == null || val == "") {
        this.text3.address = "请输入地址";
      } else {
        this.text3.address = "";
      }
    },
    //邮箱
    email_ch: function email_ch(val) {
      var _this39 = this;

      if (val == null || val == "") {
        this.text3.email = "请输入邮箱";
      } else {
        this.text3.email = "";
        var valueList = val.split(",");
        valueList.map(function (item) {
          var re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g;

          if (item) {
            if (!re.test(item)) {
              _this39.text3.email = "电子邮箱格式不正确";
            }
          }
        }); //					if(validateEmail(val) == false) {
        //						this.text3.email = "请输入正确的邮箱"
        //
        //					} else {
        //						this.text3.email = ""
        //					}
      }
    },
    //电话
    phone_ch: function phone_ch(val) {
      if (val == null || val == "") {
        this.text3.phone = "请输入电话";
      } else {
        if (checkPhone(val) == false) {
          this.text3.phone = "请输入正确的电话";
        } else {
          this.text3.phone = "";
        }
      }
    },
    //-
    //运输方式
    conveyanceWayCode_ch: function conveyanceWayCode_ch(val) {
      if (val == null || val == "") {
        this.text4.conveyanceWayCode = "请输入运输方式";
      } else {
        this.text4.conveyanceWayCode = "";
      }

      this.ProposalConveyanceDto.conveyanceWayName = this.list_select(val, this.conveyance_option);
    },
    //贸易条件
    clinchWayCode_ch: function clinchWayCode_ch(val) {
      // if(val == null || val == "") {
      // 	this.text4.clinchWayCode = "请输入贸易条件"
      // } else {
      // 	this.text4.clinchWayCode = ""
      // }
      if (val == null || val == "") {
        this.ProposalConveyanceDto.clinchWayName = "";
      } else {
        this.ProposalConveyanceDto.clinchWayName = this.list_select(val, this.tradeTerms_option);
      }

      this.invoicAmountsum_fun();
    },
    // HScode
    cargoCode_ch: function cargoCode_ch(val) {
      for (var i = 0; i < this.cargoCode_option.length; i++) {
        if (val == this.cargoCode_option[i].value) {
          this.proposalItemCargoDto_obj.cargoCodeName = this.cargoCode_option[i].label;
        }
      } //				console.log(this.proposalItemCargoDto_obj.cargoCodeName)

    },
    //标的类型
    itemType_ch: function itemType_ch(val) {
      for (var i = 0; i < this.itemType_option.length; i++) {
        if (val == this.itemType_option[i].value) {
          this.proposalItemCargoDto_obj.itemTypeName = this.itemType_option[i].label;
        }
      }

      if (val == 'J01') {
        this.carShowFlag = true;
      } else {
        this.carShowFlag = false;
      }
    },
    //自定义标的类型
    itemType_ch2: function itemType_ch2(val) {
      for (var i = 0; i < this.itemType_option2.length; i++) {
        if (val == this.itemType_option2[i].value) {
          this.proposalItemCargoDto_obj.itemTypeName = this.itemType_option2[i].label;
        }
      }
    },
    //起运日期
    startTime_ch: function startTime_ch(val) {
      var startDate = new Date(this.ProposalConveyanceDto.startTime);

      if (this.ProposalItemDto.storageStartTime !== null && this.ProposalItemDto.storageStartTime !== '') {
        var startDateObj = new Date(this.ProposalItemDto.storageStartTime);

        if (startDate > startDateObj) {
          this.ProposalConveyanceDto.startTime = '';
          this.$message({
            message: '【仓储/展览/加工/安装起期】不得早于【起运日期】',
            type: 'warning'
          });
        }
      }

      if (this.ProposalItemDto.storageEndTime !== null && this.ProposalItemDto.storageEndTime !== '') {
        var endDateObj = new Date(this.ProposalItemDto.storageEndTime);

        if (startDate > endDateObj) {
          this.ProposalConveyanceDto.startTime = '';
          this.$message({
            message: '【仓储/展览/加工/安装起期】不得早于【起运日期】',
            type: 'warning'
          });
        }
      }

      this.dataChange = val;

      if (val == null || val == "") {
        // this.text4.startTime = "请输入船舶启航或飞机起飞日期"
        this.text4.startTime = "请输入起运日期";
      } else {
        this.text4.startTime = "";
      }
    },
    //运费
    freight_ch: function freight_ch(val) {
      //				if(val == null || val == "") {
      //					this.text4.freight = ""
      //				} else {
      //					if(this.ProposalConveyanceDto.freightCurrency == null || this.ProposalConveyanceDto.freightCurrency == "") {
      //						this.text4.freightCurrency = "请输入运费币别"
      //					} else {
      //						this.text4.freightCurrency = ""
      //					}
      //				}
      // 根据申报基准选择内容--运费、运费币别/其他税费、其他税费币别
      if (this.otherTaxFeesFlag) {
        if (val === "" || val === null) {
          this.text4.freight = "请输入其他税费";
        } else {
          this.text4.freight = "";
        }

        if (this.ProposalConveyanceDto.freightCurrency === "" || this.ProposalConveyanceDto.freightCurrency === null) {
          this.text4.freightCurrency = "请输入其他税费币别";
        } else {
          this.text4.freightCurrency = "";
        }
      } else {
        if (val == null || val == "") {
          this.text4.freight = "";
        } else {
          if (this.ProposalConveyanceDto.freightCurrency == null || this.ProposalConveyanceDto.freightCurrency == "") {
            this.text4.freightCurrency = "请输入运费币别";
          } else {
            this.text4.freightCurrency = "";
          }
        }
      }

      if (this.ProposalConveyanceDto.freightCurrency == "JPY") {
        this.decimalValue2 = 0;
      } else {
        this.decimalValue2 = 2;
      }

      this.invoicAmountsum_fun();
    },
    //运费币别
    freightCurrency_ch: function freightCurrency_ch(val) {
      //				if(this.ProposalConveyanceDto.freight != "") {
      //					if(val == null || val == "") {
      //						this.text4.freightCurrency = "请输入运费币别"
      //					} else {
      //						this.text4.freightCurrency = ""
      //					}
      //				}
      // 根据申报基准选择内容--运费、运费币别/其他税费、其他税费币别
      if (this.otherTaxFeesFlag) {
        if (this.ProposalConveyanceDto.freight === "" || this.ProposalConveyanceDto.freight === null) {
          this.text4.freight = "请输入其他税费";
        } else {
          this.text4.freight = "";
        }

        if (val === "" || val === null) {
          this.text4.freightCurrency = "请输入其他税费币别";
        } else {
          this.text4.freightCurrency = "";
        }
      } else {
        if (this.ProposalConveyanceDto.freight != "" && this.ProposalConveyanceDto.freight != null) {
          if (val == null || val == "") {
            this.text4.freightCurrency = "请输入运费币别";
          } else {
            this.text4.freightCurrency = "";
          }
        }
      }

      if (this.ProposalConveyanceDto.freightCurrency == "JPY") {
        this.decimalValue2 = 0;
      } else {
        this.decimalValue2 = 2;
      }

      this.ProposalConveyanceDto.freightCurrencyName = this.list_select(val, this.currency_option);
      this.invoicAmountsum_fun();
    },
    //运输工具
    conveyanceCode_ch: function conveyanceCode_ch(val) {
      if (val == null || val == "") {
        this.text4.conveyanceCode = "请输入贸易条件";
      } else {
        this.text4.conveyanceCode = "";
      }

      this.ProposalConveyanceDto.freightCurrencyName = this.list_select(val, this.currency_option);
    },
    //启运城市
    startSiteCountryCode_ch: function startSiteCountryCode_ch(val, scope) {
      this.codeTypeList_fun3(val, scope, "1");
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCountryName = this.list_select(val, this.country_option);
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCityCode = "";

      if (val == null || val == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCityCode == null || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCityCode == "") {
        this.text4.startSiteCountryCode = "不为空";
      } else {
        this.text4.startSiteCountryCode = "";
      }

      if (val == null || val == "") {
        $('.startSiteCountryCode').eq(scope.$index).find('input').css({
          'border': '1px solid #f56c6c'
        });
      } else {
        $('.startSiteCountryCode').eq(scope.$index).find('input').css({
          'border': '1px solid #dcdfe6'
        });
      }
    },
    startSiteCityCode_ch: function startSiteCityCode_ch(val, scope) {
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCityName = this.list_select(val, scope.row.city_option1);

      if (val == null || val == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCountryCode == null || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].startSiteCountryCode == "") {
        this.text4.startSiteCountryCode = "不为空";
      } else {
        this.text4.startSiteCountryCode = "";
      }

      if (val == null || val == "") {
        $('.startSiteCityCode').eq(scope.$index).find('input').css({
          'border': '1px solid #f56c6c'
        });
      } else {
        $('.startSiteCityCode').eq(scope.$index).find('input').css({
          'border': '1px solid #dcdfe6'
        });
      }
    },
    //中转城市
    //			viaSiteCountryCode_ch(val) {
    //				if(val == null || val == "" || this.ProposalConveyanceDto.viaSiteCityCode == null || this.ProposalConveyanceDto.viaSiteCityCode == "") {
    //					this.text4.viaSiteCountryCode = "请输入中转城市"
    //				} else {
    //					this.text4.viaSiteCountryCode = ""
    //				}
    //
    //			},
    //			viaSiteCityCode_ch(val) {
    //				if(val == null || val == "" || this.ProposalConveyanceDto.viaSiteCountryCode == null || this.ProposalConveyanceDto.viaSiteCountryCode == "") {
    //					this.text4.viaSiteCountryCode = "请输入中转城市"
    //				} else {
    //					this.text4.viaSiteCountryCode = ""
    //				}
    //
    //			},
    //目的地
    endSiteCountryCode_ch: function endSiteCountryCode_ch(val, scope) {
      this.codeTypeList_fun3(val, scope, "2");
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCountryName = this.list_select(val, this.country_option);
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCityCode = "";

      if (val == null || val == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCityCode == null || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCityCode == "") {
        this.text4.endSiteCountryCode = "不为空";
      } else {
        this.text4.endSiteCountryCode = "";
      }

      if (val == null || val == "") {
        $('.endSiteCountryCode').eq(scope.$index).find('input').css({
          'border': '1px solid #f56c6c'
        });
      } else {
        $('.endSiteCountryCode').eq(scope.$index).find('input').css({
          'border': '1px solid #dcdfe6'
        });
      }
    },
    endSiteCityCode_ch: function endSiteCityCode_ch(val, scope) {
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCityName = this.list_select(val, scope.row.city_option2);

      if (val == null || val == "" || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCountryCode == null || this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].endSiteCountryCode == "") {
        this.text4.endSiteCountryCode = "不为空";
      } else {
        this.text4.endSiteCountryCode = "";
      }

      if (val == null || val == "") {
        $('.endSiteCityCode').eq(scope.$index).find('input').css({
          'border': '1px solid #f56c6c'
        });
      } else {
        $('.endSiteCityCode').eq(scope.$index).find('input').css({
          'border': '1px solid #dcdfe6'
        });
      }
    },
    //其他运输工具
    blName_ch: function blName_ch(val, scope) {
      if (val == null || val == "") {
        /*this.text4.blName = "请输入其他运输工具"
        $('.blName').eq(scope.$index).find('input').css({
        	'border': '1px solid #f56c6c'
        })*/
      } else {
        this.text4.blName = "";
        $('.blName').eq(scope.$index).find('input').css({
          'border': '1px solid #ccc'
        });
      }
    },
    //船舶航次
    voyageNo_ch: function voyageNo_ch(val, scope) {
      if (this.ProposalConveyanceDto.conveyanceWayCode == '3' || this.ProposalConveyanceDto.conveyanceWayCode == "8" || this.ProposalConveyanceDto.conveyanceWayCode == "10") {
        if (val == null || val == "") {
          /*this.text4.voyageNo = "请输入船舶航次"
          $('.voyageNo').eq(scope.$index).find('input').css({
          	'border': '1px solid #f56c6c'
          })*/
          this.text4.voyageNo = "";
        } else {
          this.text4.voyageNo = "";
          $('.voyageNo').eq(scope.$index).find('input').css({
            'border': '1px solid #ccc'
          });
        }
      }
    },
    //船级
    shipClassCode_ch: function shipClassCode_ch(val, scope) {
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].shipClassName = this.list_select(val, this.shipClass_option);
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].nShipClassCode = ''; // 清空自选

      if (this.ProposalConveyanceDto.conveyanceWayCode == '3' || this.ProposalConveyanceDto.conveyanceWayCode == "8" || this.ProposalConveyanceDto.conveyanceWayCode == "10") {
        if (val == null || val == "") {
          /*this.text4.shipClassCode = "请输入船舶航次"
          $('.shipClassCode').eq(scope.$index).find('input').css({
          	'border': '1px solid #f56c6c'
          })*/
        } else {
          this.text4.shipClassCode = "";
          $('.shipClassCode').eq(scope.$index).find('input').css({
            'border': '1px solid #ccc'
          });
        }
      }
    },
    //船舶类型
    shipTypesCode_ch: function shipTypesCode_ch(val, scope) {
      console.log(this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index]);
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].shipTypes = this.list_select(val, this.shipTypes_option);

      if (this.ProposalConveyanceDto.conveyanceWayCode == '3' || this.ProposalConveyanceDto.conveyanceWayCode == "8" || this.ProposalConveyanceDto.conveyanceWayCode == "10") {
        if (val == null || val == "") {
          /*this.text4.shipTypesCode = "请输入船舶航次"
          $('.shipTypesCode').eq(scope.$index).find('input').css({
          	'border': '1px solid #f56c6c'
          })*/
        } else {
          this.text4.shipTypesCode = "";
          $('.shipTypesCode').eq(scope.$index).find('input').css({
            'border': '1px solid #ccc'
          });
        }
      }
    },
    //船龄
    vessel_ch: function vessel_ch(val, scope) {
      var index = scope.$index;
      this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = val.replace(/-/g, "");

      if (this.ProposalConveyanceDto.conveyanceWayCode == '3' || this.ProposalConveyanceDto.conveyanceWayCode == "8" || this.ProposalConveyanceDto.conveyanceWayCode == "10") {
        if (val == null || val == "") {
          /*this.text4.vessel = "请输入船舶航次"
          $('.vessel').eq(scope.$index).find('input').css({
          	'border': '1px solid #f56c6c'
          })*/
        } else {
          this.text4.vessel = "";
          $('.vessel').eq(scope.$index).find('input').css({
            'border': '1px solid #ccc'
          });
        }
      }
    },
    //			数量
    quantity_ch: function quantity_ch(val) {
      //				console.log(val)
      //				console.log(this.proposalItemCargoDto_obj)
      if (val != "" && (this.proposalItemCargoDto_obj.unitAmount != "" || this.proposalItemCargoDto_obj.unitAmount != undefined)) {
        if (typeof val == "string") {
          val = parseFloat(val.replace(/,/g, "")).toFixed(6);
        } else {
          val = val.toFixed(6);
        }

        if (typeof this.proposalItemCargoDto_obj.unitAmount == "string") {
          this.proposalItemCargoDto_obj.unitAmount = parseFloat(this.proposalItemCargoDto_obj.unitAmount.replace(/,/g, "")).toFixed(6);
        } else {
          this.proposalItemCargoDto_obj.unitAmount = this.proposalItemCargoDto_obj.unitAmount.toFixed(6);
        }

        this.proposalItemCargoDto_obj.totalAmount = accMul(val, this.proposalItemCargoDto_obj.unitAmount);
        this.proposalItemCargoDto_obj.vehiclePrice = this.proposalItemCargoDto_obj.totalAmount;
      } else {
        this.proposalItemCargoDto_obj.totalAmount = "";
      }
    },
    //     单价
    unitAmount_ch: function unitAmount_ch(val) {
      //				console.log(val)
      //				console.log(this.proposalItemCargoDto_obj.quantity)
      if (val != "" && (this.proposalItemCargoDto_obj.quantity != "" || this.proposalItemCargoDto_obj.quantity != undefined)) {
        if (typeof val == "string") {
          val = parseFloat(val.replace(/,/g, "")).toFixed(6);
        } else {
          val = val.toFixed(6);
        }

        if (typeof this.proposalItemCargoDto_obj.quantity == "string") {
          this.proposalItemCargoDto_obj.quantity = parseFloat(this.proposalItemCargoDto_obj.quantity.replace(/,/g, "")).toFixed(6);
        } else {
          this.proposalItemCargoDto_obj.quantity = this.proposalItemCargoDto_obj.quantity.toFixed(6);
        }

        this.proposalItemCargoDto_obj.totalAmount = accMul(val, this.proposalItemCargoDto_obj.quantity);
        this.proposalItemCargoDto_obj.vehiclePrice = this.proposalItemCargoDto_obj.totalAmount;
      } else {
        this.proposalItemCargoDto_obj.totalAmount = "";
      }
    },
    // 总价
    totalAmount_ch: function totalAmount_ch(val) {
      this.proposalItemCargoDto_obj.vehiclePrice = this.proposalItemCargoDto_obj.totalAmount;

      if (val != accMul(this.proposalItemCargoDto_obj.unitAmount, this.proposalItemCargoDto_obj.quantity)) {
        this.proposalItemCargoDto_obj.unitAmount = '0';
      }
    },
    //单位
    unit_fun: function unit_fun(val) {
      this.proposalItemCargoDto_obj.unitName = this.list_select(val, this.measuringUnit_option);
    },
    //包装方式
    packingWayCode_ch: function packingWayCode_ch(val) {
      if (val == null || val == "") {
        this.text5.packingWayCode = "请输入包装方式";
      } else {
        this.text5.packingWayCode = "";
      }

      this.ProposalItemDto.packingWay = this.list_select(val, this.packType_option);
    },
    //集装箱规格
    containerTypeCode_ch: function containerTypeCode_ch(val) {
      if (val == null || val == "") {
        this.text5.containerType = "请输入集装箱规格";
      } else {
        this.text5.containerType = "";
      } //				console.log(this.list_select(val, this.packTypes_option))


      this.ProposalItemDto.containerType = this.list_select(val, this.packTypes_option);
    },
    //是否冷藏
    isRefrigeRate_ch: function isRefrigeRate_ch(val) {
      if (val == null || val == "") {
        this.text5.isRefrigeRate = "请输入是否冷藏";
      } else {
        this.text5.isRefrigeRate = "";
      }
    },
    //是否集装箱
    isContainer_ch: function isContainer_ch(val) {
      if (val == null || val == "") {
        this.text5.isContainer = "请输入是否集装箱";
      } else {
        this.text5.isContainer = "";
      }
    },
    //货物新旧标志
    isNewOrOld_ch: function isNewOrOld_ch(val) {
      if (val == null || val == "") {
        this.text5.isNewOrOld = "请输入货物新旧标志";
      } else {
        this.text5.isNewOrOld = "";
      }
    },
    //提单号
    ladingNO_ch: function ladingNO_ch(val) {
      if ((val == null || val == "") && (this.ProposalItemDto.invoicNo == "" || this.ProposalItemDto.invoicNo == null)) {
        if (this.riskCode != null && this.riskCode != 'CINL') {
          this.text5.ladingNO = "请输入发票号或提单号，两者必录其一";
          this.text5.invoicNo = "请输入发票号或提单号，两者必录其一";
        } else {
          this.text5.ladingNO = "";
          this.text5.invoicNo = "";
        }
      } else {
        this.text5.ladingNO = "";
        this.text5.invoicNo = "";
      }
    },
    //发票号
    invoicNo_ch: function invoicNo_ch(val) {
      if ((val == null || val == "") && (this.ProposalItemDto.ladingNO == "" || this.ProposalItemDto.ladingNO == null)) {
        if (this.riskCode != null && this.riskCode != 'CINL') {
          this.text5.ladingNO = "请输入发票号或提单号，两者必录其一";
          this.text5.invoicNo = "请输入发票号或提单号，两者必录其一";
        } else {
          this.text5.ladingNO = "";
          this.text5.invoicNo = "";
        }
      } else {
        this.text5.invoicNo = "";
        this.text5.ladingNO = "";
      }
    },
    //唛头信息
    marks_ch: function marks_ch(val) {// if(val == null || val == "") {
      // 	this.text5.marks = "请输入唛头信息"
      // } else {
      // 	this.text5.marks = ""
      // }
    },
    //发票金额
    invoicAmount_ch: function invoicAmount_ch(val) {
      if (val == null || val == "") {
        this.text5.invoicAmount = "请输入发票金额";
      } else {
        this.text5.invoicAmount = "";
      }

      this.invoicAmountsum_fun();
    },
    //报关币别
    invoicCurrencyCode_ch: function invoicCurrencyCode_ch(val) {
      if (val == null || val == "") {
        this.text5.invoicCurrencyCode = "请输入发票币别";
      } else {
        this.text5.invoicCurrencyCode = "";
      }

      this.ProposalItemDto.invoicCurrency = this.list_select(val, this.currency_option);

      if (this.ProposalItemDto.invoicCurrencyCode == "JPY") {
        for (var k = 0; k < this.ProposalItemDto.proposalItemCargoDtoList.length; k++) {
          // 总价
          if (typeof this.ProposalItemDto.proposalItemCargoDtoList[k].totalAmount == "string") {
            var totalAmountt = parseFloat(this.ProposalItemDto.proposalItemCargoDtoList[k].totalAmount.replace(/,/g, ""));
            this.ProposalItemDto.proposalItemCargoDtoList[k].totalAmount = Math.round(totalAmountt);
          } else {
            this.ProposalItemDto.proposalItemCargoDtoList[k].totalAmount = Math.round(this.ProposalItemDto.proposalItemCargoDtoList[k].totalAmount);
          } // 单价


          if (typeof this.ProposalItemDto.proposalItemCargoDtoList[k].unitAmount == "string") {
            var unitAmountt = parseFloat(this.ProposalItemDto.proposalItemCargoDtoList[k].unitAmount.replace(/,/g, ""));
            this.ProposalItemDto.proposalItemCargoDtoList[k].unitAmount = Math.round(unitAmountt);
          } else {
            this.ProposalItemDto.proposalItemCargoDtoList[k].unitAmount = Math.round(this.ProposalItemDto.proposalItemCargoDtoList[k].unitAmount);
          }
        }

        this.decimalValue = 0;
      } else {
        this.decimalValue = 2;
      }

      setTimeout(this.invoicAmountsum_fun(), 1000);
    },
    // 申报基准
    reportName_ch: function reportName_ch(val) {
      // if(val == null || val == "") {
      // 	this.text5.reportName = "请输入申报基准"
      // } else {
      // 	this.text5.reportName = ""
      // }
      // console.log(val,'000000')
      if (val == null || val == "") {
        this.ProposalItemDto.reportName = "";
      } else {
        this.ProposalItemDto.reportName = this.list_select(val, this.reportName_option);
      } // 特定贸易条件下、运费改为其他税费


      if (this.ProposalItemDto.reportName === '销售合同金额（不含增值税）+ 进口增值税' || this.ProposalItemDto.reportName === '采购金额 + 进口关税 + 进口增值税 + 运费' || this.ProposalItemDto.reportName === '发票金额 + 运费') {
        this.otherTaxFeesFlag = true;
      } else {
        this.otherTaxFeesFlag = false;
      } // 根据申报基准选择内容--运费、运费币别/其他税费、其他税费币别


      if (this.otherTaxFeesFlag) {
        if (this.ProposalConveyanceDto.freight === "" || this.ProposalConveyanceDto.freight === null) {
          this.text4.freight = "请输入其他税费";
        } else {
          this.text4.freight = "";
        }

        if (this.ProposalConveyanceDto.freightCurrency === "" || this.ProposalConveyanceDto.freightCurrency === null) {
          this.text4.freightCurrency = "请输入其他税费币别";
        } else {
          this.text4.freightCurrency = "";
        }
      } else {
        if (this.ProposalConveyanceDto.freight != "" && this.ProposalConveyanceDto.freight != null) {
          if (this.ProposalConveyanceDto.freightCurrency == null || this.ProposalConveyanceDto.freightCurrency == "") {
            this.text4.freightCurrency = "请输入运费币别";
          } else {
            this.text4.freightCurrency = "";
          }
        } else {
          this.text4.freight = "";
        }
      }
    },
    // 是否投保仓储展览 变更
    isStorage_ch: function isStorage_ch(val) {
      if (val === null || val === '') {
        this.text5.isStorage = '请选择是否投保列明地址仓储/展览/加工/安装/加工/安装';
      } else {
        this.text5.isStorage = '';

        if (val === '1') {
          this.storageFlag = true;
        } else {
          this.storageFlag = false; // 清空

          this.ProposalItemDto.storageStartTime = '';
          this.ProposalItemDto.storageEndTime = '';
          this.ProposalItemDto.storagePeriod = '';
          this.storagePeriodChange('');
        }
      }
    },
    // 是否投保仓储展览 变更
    storageTime_ch: function storageTime_ch(val) {
      if (val === '1') {
        if (this.ProposalItemDto.storageStartTime === null || this.ProposalItemDto.storageStartTime === '') {
          this.text5.storageStartTime = '请选择列明地址仓储/展览/加工/安装起期';
        } else {
          this.text5.storageStartTime = '';
        }
      } else {
        if (this.ProposalItemDto.storageEndTime === null && this.ProposalItemDto.storageEndTime === '') {
          this.text5.storageEndTime = '请选择列明地址仓储/展览/加工/安装止期';
        } else {
          this.text5.storageEndTime = '';
        }
      } // 启运日期判断


      if (this.ProposalConveyanceDto.startTime !== null && this.ProposalConveyanceDto.startTime !== '') {
        var startDate = new Date(this.ProposalConveyanceDto.startTime);

        if (val === '1') {
          var startDateObj = new Date(this.ProposalItemDto.storageStartTime);

          if (startDateObj < startDate) {
            this.ProposalItemDto.storageStartTime = '';
            this.$message({
              message: '【列明地址仓储/展览/加工/安装起期】不得早于【起运日期】',
              type: 'warning'
            });
          }
        } else {
          var endDateObj = new Date(this.ProposalItemDto.storageEndTime);

          if (endDateObj < startDate) {
            this.ProposalItemDto.storageEndTime = '';
            this.$message({
              message: '【列明地址仓储/展览/加工/安装止期】不得早于【起运日期】',
              type: 'warning'
            });
          }
        }
      } // 仓储展示日期判断


      if (this.ProposalItemDto.storageStartTime !== null && this.ProposalItemDto.storageStartTime !== '' && this.ProposalItemDto.storageEndTime !== null && this.ProposalItemDto.storageEndTime !== '') {
        debugger;

        var _startDateObj = new Date(this.ProposalItemDto.storageStartTime);

        var _endDateObj = new Date(this.ProposalItemDto.storageEndTime);

        if (_endDateObj >= _startDateObj) {
          debugger;
          var diff = _endDateObj - _startDateObj;
          var days = Math.ceil((diff + 1) / (1000 * 60 * 60 * 24));
          this.ProposalItemDto.storagePeriod = days;
          this.storagePeriodChange(days);
        } else {
          this.ProposalItemDto.storageStartTime = '';
          this.ProposalItemDto.storageEndTime = '';
          this.ProposalItemDto.storagePeriod = '';
          this.storagePeriodChange('');
          this.$message({
            message: '【列明地址仓储/展览/加工/安装止期】不得早于【列明地址仓储/展览/加工/安装起期】',
            type: 'warning'
          });
        }
      }
    },
    //报关单号
    customslistNo_ch: function customslistNo_ch(val) {
      if (val == null || val == "") {
        this.text5.customslistNo = "请输入报关单号";
      } else {
        this.text5.customslistNo = "";
      }
    },
    //--
    //保额币别
    amountCurrencyCode_ch: function amountCurrencyCode_ch(val) {
      if (val == null || val == "") {
        this.text6.amountCurrencyCode = "请输入保额币别";
      } else {
        this.text6.amountCurrencyCode = "";
      }

      this.ProposalKindDto.amountCurrency = this.list_select(val, this.currency_option);
    },
    //保费币别
    remiumCurrencyCode_ch: function remiumCurrencyCode_ch(val) {
      if (val == null || val == "") {
        this.text6.remiumCurrencyCode = "请输入保费币别";
      } else {
        this.text6.remiumCurrencyCode = "";
      }

      this.ProposalKindDto.remiumCurrency = this.list_select(val, this.currency_option);
    },
    //保额兑保费汇率
    exchangeRate_ch: function exchangeRate_ch(val) {
      if (val == null || val == "") {
        this.text6.exchangeRate = "请输入保额兑保费汇率";
      } else {
        this.text6.exchangeRate = "";
      }
    },
    //加成比例%
    plusRate_ch: function plusRate_ch(val) {
      // this.ProposalKindDto.plusRate = val.replace(/\./g,"")
      if (val == null || val == "") {
        this.text6.plusRate = "请输入加成比例%";
      } else {
        if (checkCompensate(val) == false) {
          this.text6.plusRate = "请输入正确的数值";
        } else {
          this.text6.plusRate = "";
        }
      }
    },
    shouldShowLimitMiniPremium: function shouldShowLimitMiniPremium() {
      var _this$ProposalKindDto = this.ProposalKindDto,
          coreBackSumPremium = _this$ProposalKindDto.coreBackSumPremium,
          limitMiniPremium = _this$ProposalKindDto.limitMiniPremium,
          sumPremium = _this$ProposalKindDto.sumPremium;

      if (coreBackSumPremium === '') {
        if (limitMiniPremium > sumPremium) {
          return limitMiniPremium != null && limitMiniPremium !== '';
        }

        return false;
      } else {
        return sumPremium <= limitMiniPremium;
      }
    },
    invoiceEmail_ch: function invoiceEmail_ch(val) {
      if (val === null || val === '') {
        this.text7.invoiceEmail = '请输入发票接收邮箱';
      } else {
        this.text7.invoiceEmail = '';
        var re = /^((([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6}\,))*(([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})))$/;

        if (!re.test(this.ProposalInvoiceDto.invoiceEmail)) {
          this.text7.invoiceEmail = '发票接收邮箱格式不正确';
        }
      }
    },
    // 是否第三方支付
    isThirdPartyPayment_ch: function isThirdPartyPayment_ch(val) {
      if (val === null || val === '') {
        this.text7.isThirdPartyPayment = '请选择是否第三方支付';
      } else {
        this.text7.isThirdPartyPayment = '';

        if (val === '1') {
          if (this.ProposalInvoiceDto.actualPayer === null || this.ProposalInvoiceDto.actualPayer === '') {
            this.text7.actualPayer = '请输入实际付款人/公司名称';
          } else {
            this.text7.actualPayer = '';
          }

          if (this.ProposalInvoiceDto.invoiceHeader === null || this.ProposalInvoiceDto.invoiceHeader === '') {
            this.text7.invoiceHeader = '请输入发票抬头';
          } else {
            this.text7.invoiceHeader = '';
          }

          if (this.ProposalInvoiceDto.taxpayerIdentityType === null || this.ProposalInvoiceDto.taxpayerIdentityType === '') {
            this.text7.taxpayerIdentityType = '请选择纳税人身份';
          } else {
            this.text7.taxpayerIdentityType = '';
          }
        } else {
          this.text7.actualPayer = '';
          this.text7.invoiceHeader = '';
          this.text7.taxpayerIdentityType = '';
        }
      }
    },
    actualPayer_ch: function actualPayer_ch(val) {
      if (val === null || val === '') {
        if (this.ProposalInvoiceDto.isThirdPartyPayment === '1') {
          this.text7.actualPayer = '请输入实际付款人/公司名称';
        } else {
          this.text7.actualPayer = '';
        }
      } else {
        this.text7.actualPayer = '';
      }
    },
    invoiceHeader_ch: function invoiceHeader_ch(val) {
      if (val === null || val === '') {
        if (this.ProposalInvoiceDto.isThirdPartyPayment === '1') {
          this.text7.invoiceHeader = '请输入发票抬头';
        } else {
          this.text7.invoiceHeader = '';
        }
      } else {
        this.text7.invoiceHeader = '';
      }
    },
    taxpayerIdentityType_ch: function taxpayerIdentityType_ch(val) {
      if (val === null || val === '') {
        if (this.ProposalInvoiceDto.isThirdPartyPayment === '1') {
          this.text7.taxpayerIdentityType = '请选择纳税人身份';
        } else {
          this.text7.taxpayerIdentityType = '';
        }
      } else {
        this.text7.taxpayerIdentityType = '';
      }
    },
    HScode_int: function HScode_int(val) {
      var reg = /^[0-9a-zA-Z]*$/;
      console.log(reg.test(val) + '------');

      if (val && (!reg.test(val) || val.length > 10)) {
        this.$message({
          message: 'HScode最大可输入10位（数字，字母，数字+字母）！',
          type: 'warning'
        });
        this.proposalItemCargoDto_obj.cargoCode = '';
      }
    },
    // 商品中文名称
    cargoName_int: function cargoName_int(val) {
      // if(val.length > 10){
      // 	console.log(val.substring(0,10))
      // 	this.proposalItemCargoDto_obj.cargoName = val.substring(0,10)
      // }
      var temp = 0;
      var reg = /[\s\S]/g;
      var resultn = val.match(reg);

      for (var i = 0; i < resultn.length; i++) {
        if (/[\u4e00-\u9fa5]/.test(resultn[i])) {
          temp += 3;
        } else {
          temp++;
        }

        if (temp > 250) {
          this.$message({
            message: '最多支持输入250个字符(约82个汉字)',
            type: 'warning'
          });
          this.proposalItemCargoDto_obj.cargoName = val.substring(0, i);
          break;
        }
      }
    },
    // 商品英文名称
    cargoEnName_int: function cargoEnName_int(val) {
      var temp = 0;
      var reg = /[\s\S]/g;
      var resultn = val.match(reg);

      for (var i = 0; i < resultn.length; i++) {
        if (/[\u4e00-\u9fa5]/.test(resultn[i])) {
          temp += 3;
        } else {
          temp++;
        }

        if (temp > 250) {
          this.$message({
            message: '最多支持输入250个字符(约82个汉字)',
            type: 'warning'
          });
          this.proposalItemCargoDto_obj.cargoEnName = val.substring(0, i);
          break;
        }
      }
    },
    //运输信息上传文件后解析 -----  货运险信息
    uploadFile: function () {
      var _uploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var _this40 = this;

        var _file, fileReader, arr, arr1;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _file = params.file;
                fileReader = new FileReader();
                arr = [];
                arr1 = [];

                fileReader.onload = function (ev) {
                  try {
                    // console.log(ev.target.result)
                    var data = ev.target.result;
                    var workbook = XLSX.read(data, {
                      type: 'binary'
                    });
                    var arr_list = ["HScode", "标的类型", "商品中文名称", "商品英文名称", "数量", "单位", "单价", "总价", "货物新旧标识", "车辆型号", "底盘号", "发动机号", "车辆价格"];
                    var A1 = workbook.Sheets.Sheet1.A1.h;
                    var B1 = workbook.Sheets.Sheet1.B1.h;
                    var C1 = workbook.Sheets.Sheet1.C1.h;
                    var D1 = workbook.Sheets.Sheet1.D1.h;
                    var E1 = workbook.Sheets.Sheet1.E1.h;
                    var F1 = workbook.Sheets.Sheet1.F1.h;
                    var G1 = workbook.Sheets.Sheet1.G1.h;
                    var H1 = workbook.Sheets.Sheet1.H1.h;
                    var I1 = workbook.Sheets.Sheet1.I1.h;
                    var J1 = workbook.Sheets.Sheet1.J1.h;
                    var K1 = workbook.Sheets.Sheet1.K1.h;
                    var L1 = workbook.Sheets.Sheet1.L1.h;
                    var M1 = workbook.Sheets.Sheet1.M1.h;
                    arr1.push(A1, B1, C1, D1, E1, F1, G1, H1, I1, J1, K1, L1, M1); // console.log(arr1)

                    console.log(unique(arr1).toString());

                    for (var sheet in workbook.Sheets) {
                      //循环读取每个文件
                      var sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]); //若当前sheet没有数据，则continue

                      if (sheetArray.length == 0) {
                        continue;
                      } // for(let item in sheetArray) {
                      // 	for(let item_s in sheetArray[item]) {
                      // 		arr.push(item_s)
                      // 	}
                      // }
                      // 判断上传表格模板字段是否正确


                      if (unique(arr1).toString() === arr_list.toString()) {
                        _this40.ProposalItemDto.proposalItemCargoDtoList = [];
                        _this40.ProposalItemDto.proposalItemCargoDtoTempList = [];

                        for (var item in sheetArray) {
                          var number = Number(item) + Number(1);
                          console.log(sheetArray[item] + item);
                          var rowTable = {};
                          var unitAmount1 = 0;
                          var totalAmount1 = 0;
                          var vehiclePrice1 = 0; //这里的rowTable的属性名注意要与上面表格的prop一致
                          //sheetArray的属性名与上传的表格的列名一致

                          console.log('HScode=' + sheetArray[item]);
                          console.log('HScode=' + sheetArray[item].HScode);

                          if (sheetArray[item].HScode == undefined) {
                            rowTable.cargoCode = '';
                          } else {
                            if (sheetArray[item].HScode.length > 10) {
                              _this40.$message({
                                message: '货物清单上传模板中第 ' + number + ' 行数据的HScode不允许超过十位,请确认输入是否正确',
                                type: 'warning'
                              });

                              _this40.dialogFormVisible1 = false;
                              return;
                            }

                            rowTable.cargoCode = sheetArray[item].HScode;
                          }

                          console.log(_this40.itemType_option.length);

                          for (var i = 0; i < _this40.itemType_option.length; i++) {
                            if (sheetArray[item].标的类型 == _this40.itemType_option[i].label) {
                              rowTable.itemType = _this40.itemType_option[i].value;
                              rowTable.itemTypeName = sheetArray[item].标的类型;
                            }

                            if (sheetArray[item].标的类型 == undefined) {
                              _this40.$message({
                                message: '货物清单上传模板中第 ' + number + ' 行数据中的 标的类型 不允许为空，请确认是否输入正确',
                                type: 'warning'
                              });

                              _this40.dialogFormVisible1 = false;
                              return;
                            }
                          }

                          console.log('HScode=' + sheetArray[item].商品中文名称);

                          if (sheetArray[item].商品中文名称 == undefined) {
                            rowTable.cargoName = '';
                          } else {
                            if (sheetArray[item].商品中文名称.length > 250) {
                              _this40.$message({
                                message: '货物清单上传模板中第 ' + number + ' 行数据的商品中文名称不允许超过250个字符,请确认输入是否正确',
                                type: 'warning'
                              });

                              _this40.dialogFormVisible1 = false;
                              return;
                            }

                            rowTable.cargoName = sheetArray[item].商品中文名称;
                          }

                          console.log('HScode=' + sheetArray[item].商品英文名称);

                          if (sheetArray[item].商品英文名称 == undefined) {
                            rowTable.cargoEnName = '';
                          } else {
                            if (sheetArray[item].商品英文名称.length > 250) {
                              _this40.$message({
                                message: '货物清单上传模板中第 ' + number + ' 行数据的商品英文名称不允许超过250个字符,请确认输入是否正确',
                                type: 'warning'
                              });

                              _this40.dialogFormVisible1 = false;
                              return;
                            }

                            rowTable.cargoEnName = sheetArray[item].商品英文名称;
                          }

                          if (sheetArray[item].商品中文名称 == undefined && sheetArray[item].商品英文名称 == undefined) {
                            _this40.$message({
                              message: '货物清单上传模板中第 ' + number + ' 行数据的商品中文名称和商品英文名称需必录其一',
                              type: 'warning'
                            });

                            _this40.dialogFormVisible1 = false;
                            return;
                          }

                          rowTable.serialNo = Number(item) + 1;

                          if (sheetArray[item].数量 != undefined || sheetArray[item].数量 != null) {
                            rowTable.quantity = sheetArray[item].数量.trim();

                            if (typeof rowTable.quantity == "string") {
                              rowTable.quantity = parseFloat(rowTable.quantity.replace(/,/g, ""));
                            } else {
                              rowTable.quantity = parseFloat(rowTable.quantity.replace(/,/g, ""));
                            }
                          } else {
                            _this40.$message({
                              message: '货物清单上传模板中第 ' + number + ' 行数据中的 数量 不允许为空，请确认是否输入正确',
                              type: 'warning'
                            });

                            _this40.dialogFormVisible1 = false;
                            return;
                          }

                          for (var i = 0; i < _this40.measuringUnit_option.length; i++) {
                            var dwlabel = _this40.measuringUnit_option[i].label.substring(0, _this40.measuringUnit_option[i].label.indexOf(" "));

                            if (sheetArray[item].单位 == dwlabel) {
                              rowTable.unit = _this40.measuringUnit_option[i].value;
                              rowTable.unitName = sheetArray[item].单位;
                            }

                            if (sheetArray[item].单位 == undefined) {
                              _this40.$message({
                                message: '货物清单上传模板中第 ' + number + ' 行数据中的 单位 不允许为空，请确认是否输入正确',
                                type: 'warning'
                              });

                              _this40.dialogFormVisible1 = false;
                              return;
                            }
                          }

                          if (sheetArray[item].单价 != undefined || sheetArray[item].单价 != null) {
                            rowTable.unitAmount = sheetArray[item].单价;

                            if (typeof rowTable.unitAmount == "string") {
                              rowTable.unitAmount = parseFloat(rowTable.unitAmount.replace(/,/g, ""));
                              unitAmount1 = rowTable.unitAmount;
                              rowTable.unitAmount = num5_type_fun(rowTable.unitAmount);
                            } else {
                              rowTable.unitAmount = rowTable.unitAmount;
                            }
                          } else {
                            rowTable.unitAmount = '0';
                          }

                          if (sheetArray[item].总价 != undefined || sheetArray[item].总价 != null) {
                            rowTable.totalAmount = sheetArray[item].总价;

                            if (typeof rowTable.totalAmount == "string") {
                              rowTable.totalAmount = parseFloat(rowTable.totalAmount.replace(/,/g, ""));
                              totalAmount1 = rowTable.totalAmount;
                              rowTable.totalAmount = num5_type_fun(rowTable.totalAmount);
                            } else {
                              rowTable.totalAmount = parseFloat(rowTable.totalAmount.replace(/,/g, ""));
                            }
                          } else {
                            _this40.$message({
                              message: '货物清单上传模板中第 ' + number + ' 行数据中的 总价 不允许为空，请确认是否输入正确',
                              type: 'warning'
                            });

                            _this40.dialogFormVisible1 = false;
                            return;
                          }

                          for (var i = 0; i < _this40.isneworold_option.length; i++) {
                            if (sheetArray[item].货物新旧标识 == _this40.isneworold_option[i].label) {
                              rowTable.isNewOrOld = _this40.isneworold_option[i].value;
                            }

                            if (sheetArray[item].货物新旧标识 == undefined) {
                              _this40.$message({
                                message: '货物清单上传模板中第 ' + number + ' 行数据中的 货物新旧标识 不允许为空，请确认是否输入正确',
                                type: 'warning'
                              });

                              _this40.dialogFormVisible1 = false;
                              return;
                            }
                          }

                          if (rowTable.itemType == 'J01') {
                            if (sheetArray[item].车辆型号 != undefined || sheetArray[item].车辆型号 != null) {
                              rowTable.vehicleModel = sheetArray[item].车辆型号;
                            } else {
                              _this40.$message({
                                message: '货物清单上传模板中第 ' + number + ' 行数据中的 车辆型号 不允许为空，请确认是否输入正确',
                                type: 'warning'
                              });

                              _this40.dialogFormVisible1 = false;
                              return;
                            }

                            if (sheetArray[item].底盘号 != undefined || sheetArray[item].底盘号 != null) {
                              rowTable.chassisNumber = sheetArray[item].底盘号;
                            } else {
                              _this40.$message({
                                message: '货物清单上传模板中第 ' + number + ' 行数据中的 底盘号 不允许为空，请确认是否输入正确',
                                type: 'warning'
                              });

                              _this40.dialogFormVisible1 = false;
                              return;
                            }

                            if (sheetArray[item].发动机号 != undefined || sheetArray[item].发动机号 != null) {
                              rowTable.engineNumber = sheetArray[item].发动机号;
                            } else {
                              _this40.$message({
                                message: '货物清单上传模板中第 ' + number + ' 行数据中的 发动机号 不允许为空，请确认是否输入正确',
                                type: 'warning'
                              });

                              _this40.dialogFormVisible1 = false;
                              return;
                            }

                            if (sheetArray[item].车辆价格 != undefined || sheetArray[item].车辆价格 != null) {
                              rowTable.vehiclePrice = sheetArray[item].车辆价格;

                              if (typeof rowTable.vehiclePrice == "string") {
                                rowTable.vehiclePrice = parseFloat(rowTable.vehiclePrice.replace(/,/g, ""));
                                vehiclePrice1 = rowTable.vehiclePrice;
                                rowTable.vehiclePrice = num5_type_fun(rowTable.vehiclePrice);
                              } else {
                                rowTable.vehiclePrice = parseFloat(rowTable.vehiclePrice.replace(/,/g, ""));
                              }
                            } else {
                              _this40.$message({
                                message: '货物清单上传模板中第 ' + number + ' 行数据中的 车辆型号 不允许为空，请确认是否输入正确',
                                type: 'warning'
                              });

                              _this40.dialogFormVisible1 = false;
                              return;
                            }
                          } // 总价计算公式：单价*数量
                          // if(Number(rowTable.quantity) * unitAmount1 !== Number(totalAmount1)) {
                          //   this.$message({
                          //     message: '货物清单上传模板中第 ' + number + ' 行数据中的 总价 与系统计算总价不同，请确认是否输入正确',
                          //     type: 'warning'
                          //   })
                          //   this.dialogFormVisible1 = false
                          //   return
                          // }


                          if (rowTable.itemTypeName === '商品车（轿车）') {
                            if (vehiclePrice1 !== totalAmount1) {
                              _this40.$message({
                                message: '货物清单上传模板中第 ' + number + ' 行数据中的 车辆价格 与 总价 不同，请确认是否输入正确',
                                type: 'warning'
                              });

                              _this40.dialogFormVisible1 = false;
                              return;
                            }
                          }

                          _this40.ProposalItemDto.proposalItemCargoDtoTempList.push(rowTable);
                        }

                        _this40.ProposalItemDto.proposalItemCargoDtoList = _this40.ProposalItemDto.proposalItemCargoDtoTempList;
                        _this40.dialogFormVisible1 = false;

                        _this40.invoicAmountsum_fun();

                        break;
                      } else {
                        _this40.$refs.uploader.clearFiles();

                        _this40.$message.warning('上传文件模板不正确，请确认后重新上传');

                        break;
                      } // console.log("读取文件");

                    }
                  } catch (e) {// this.$message.warning('上传文件模板不正确，请确认后重新上传');
                  }
                };

                fileReader.readAsBinaryString(_file);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function uploadFile(_x) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }(),
    // 判断上传货物清单文件类型
    beforeUpload: function beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      var extension = testmsg === 'xls';
      var extension2 = testmsg === 'xlsx'; // const isLt2M = file.size / 1024 / 1024 < 10

      if (!extension && !extension2) {
        this.$message({
          message: '上传文件模板不正确，请确认后重新上传',
          type: 'warning'
        });
      }

      return extension || extension2;
    },
    //运输信息上传文件时弹窗提示错误
    exceed: function exceed() {
      this.$message.error("最多只能上传1个xlsx文件");
    },
    //运输信息删除上传文件
    remove: function remove() {
      this.ProposalItemDto.proposalItemCargoDtoList = [];
    },
    //------  下拉信息集合函数
    select_data: function select_data(code) {
      this.findInsuranceCompany_fun(code);
      this.companyqueryAll_fun(code); //this.biaodi_fun()

      this.codeTypeList_fun();
      this.codeTypeList_fun2();
    },
    //保险公司
    findInsuranceCompany_fun: function findInsuranceCompany_fun(code) {
      var _this41 = this;

      var data = {
        insuranceCompanyCode: code
      };
      getCompanyList(data).then(function (res) {
        _this41.options_insuranceCompanyName = [];

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].insuranceCompanyCode;
          obj.label = res[i].insuranceCompanyName;

          _this41.options_insuranceCompanyName.push(obj);
        }
      });
    },
    //分支机构
    companyqueryAll_fun: function companyqueryAll_fun(code) {
      var _this42 = this;

      var data = {
        insuranceCompanyCode: code
      };
      getChilComList(data).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].companyCode;
          obj.label = res[i].companyName;

          _this42.options_companyName.push(obj);
        }
      });
    },
    //			标的类型

    /*biaodi_fun() {
    	const itemInfo = {
    		codeLever: '1',
    		codeType: 'itemType'
    	}
    	getItemList(itemInfo).then(res => {
    			if(res.codeType == 'itemType') {
    			this.itemType_option = []
    				for(var i = 0; i < res.dictionary.length; i++) {
    				var obj = {}
    				obj.value = res.dictionary[i].codeCode
    				obj.label = res.dictionary[i].codeCname
    					this.itemType_option.push(obj)
    			}
    				// console.log(this.itemType_option)
    		}
    	})
    	},*/

    /*// 自定义标的货物类型
    customizationtype() {
    	var data = {
    		insuranceCompanyCode : this.ProposalMainDto.insuranceCompanyCode,
    		userCode : this.ProposalApplicantDto.identifyNumber,
    		userName : this.ProposalApplicantDto.applicantName
    	}
    		markof_type(data).then(res => {
    		this.itemType_option2 = []
    			for(var i = 0; i < res.length; i++) {
    			var obj = {}
    			obj.value = res[i].itemCode
    			obj.label = res[i].itemName
    				this.itemType_option2.push(obj)
    		}
    	})
    },*/
    //			下拉集合
    codeTypeList_fun: function codeTypeList_fun() {
      var _this43 = this;

      var data = {
        "codeLever": "1",
        "codeType": ["conveyance", "tradeTerms", "currency", "packType", "idCard", "measuringUnit", "isneworold", "isneworold", "shipClass", "shipTypes", "country"]
      };
      codeTypeList(data).then(function (res) {
        var plk = {
          label: "请选择",
          value: ""
        };
        _this43.conveyance_option = [plk];
        _this43.tradeTerms_option = [plk];
        _this43.currency_option = [plk];
        _this43.packType_option = [plk];
        _this43.idCard_option = [];
        _this43.measuringUnit_option = [];
        _this43.shipClass_option = [plk];
        _this43.shipTypes_option = [plk];

        for (var i = 0; i < res.length; i++) {
          if (res[i].codeType == "conveyance") {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this43.conveyance_option.push(obj);
            }
          }

          if (res[i].codeType == "tradeTerms") {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              if (res[i].dictionary[k].codeCname != "COST" && res[i].dictionary[k].codeCname != "INVOICE VALUE" && res[i].dictionary[k].codeCname != "ACTUAL VALUE" && res[i].dictionary[k].codeCname != "SEE REMARKS" && res[i].dictionary[k].codeCname != "销售合同金额（不含增值税）+ 进口增值税" && res[i].dictionary[k].codeCname != "采购金额 + 进口关税 + 进口增值税 + 运费" && res[i].dictionary[k].codeCname != "发票金额 + 运费" && res[i].dictionary[k].codeCname != "进货价格 + 货损前被保险人需支付的运输、保管、加工费用的合计金额") {
                _this43.tradeTerms_option.push(obj);
              }
            }
          }

          if (res[i].codeType == "currency") {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname + ' - ' + res[i].dictionary[k].codeCode; // console.log(obj)

              _this43.currency_option.push(obj);
            }
          }

          if (res[i].codeType == "packType") {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname + ' - ' + res[i].dictionary[k].codeEname;

              _this43.packType_option.push(obj);
            }
          }

          if (res[i].codeType == "idCard") {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this43.idCard_option.push(obj);
            }
          }

          if (res[i].codeType == "measuringUnit") {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname + ' - ' + res[i].dictionary[k].codeEname;

              _this43.measuringUnit_option.push(obj);
            }
          }

          if (res[i].codeType == "isneworold") {
            _this43.isneworold_option = [];

            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this43.isneworold_option.push(obj);
            }
          } // 船级社 / 船舶类型


          if (res[i].codeType == "shipClass") {
            _this43.shipClass_option = [];

            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this43.shipClass_option.push(obj);
            }
          }

          if (res[i].codeType == "shipTypes") {
            _this43.shipTypes_option = [];

            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this43.shipTypes_option.push(obj);
            }
          }

          if (res[i].codeType == 'country') {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.codeCode = res[i].dictionary[k].codeCode;
              obj.codeCname = res[i].dictionary[k].codeCname;

              if (obj.codeCname != '中国') {
                _this43.countryAllList.push(obj);
              }

              if (obj.codeCname == '中国') {
                _this43.chinaList.push(obj);

                _this43.countryList = _this43.chinaList;
              }
            }
          } // if(res[i].codeType == "vesselType") {
          //   this.shipTypes_option = []
          //   for(var k = 0; k < res[i].dictionary.length; k++) {
          //     var obj = {}
          //     obj.value = res[i].dictionary[k].codeCode
          //     obj.label = res[i].dictionary[k].codeCname
          //     this.shipTypes_option.push(obj)
          //   }
          //
          // }

        } //					console.log(res)

      });
    },
    //------------------------国家
    codeTypeList_fun2: function codeTypeList_fun2() {
      //								var data = {
      //									"codeLever": "1",
      //									"codeType": ["country"]
      //								}
      //
      //								codeTypeList(data).then(res => {
      //									this.country_option = []
      //									for(var k = 0; k < res[0].dictionary.length; k++) {
      //										var obj = {}
      //										obj.value = res[0].dictionary[k].codeCode
      //										obj.label = res[0].dictionary[k].codeCname
      //										this.country_option.push(obj)
      //									}
      //
      //								})
      var list = getCountryList();
      this.country_option = [];

      for (var k = 0; k < list.length; k++) {
        var obj = {};
        obj.value = list[k].codeCode;
        obj.label = list[k].codeCname + ' - ' + list[k].codeEname;
        this.country_option.push(obj);
      }
    },
    loadMore: function loadMore() {
      // 这里写入要触发的方法
      ++this.countryIndex;

      if (this.countryIndex < this.countryCount + 2) {
        var maxcont = this.countryIndex > this.countryCount ? this.countryAll.length : this.countryIndex * 10;
        var mincont = this.countryIndex > this.countryCount ? this.countryCount * 10 : this.countryIndex * 10 - 10;
        console.log(this.countryIndex, 'this.countryIndex');
        console.log(mincont, 'mincont');
        console.log(maxcont, 'maxcont');

        for (var k = mincont; k < maxcont; k++) {
          var obj = {};
          obj.value = this.countryAll[k].codeCode;
          obj.label = this.countryAll[k].codeCname + ' - ' + this.countryAll[k].codeEname;
          this.country_option.push(obj);
        }
      }
    },
    //			----------------城市
    codeTypeList_fun3: function codeTypeList_fun3(code, scope, type) {
      //				console.log(code, scope.$index, type)
      console.log(code);

      if (code == "CHN") {
        var list = getCHNCity();

        if (type == "1") {
          var arr1 = [];

          for (var k = 0; k < list.length; k++) {
            var obj = {};
            obj.value = list[k].codeCode;
            obj.label = list[k].codeCname + ' - ' + list[k].codeEname;
            arr1.push(obj);
          }

          this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].city_option1 = arr1;
        } else if (type == "2") {
          var arr2 = [];

          for (var k = 0; k < list.length; k++) {
            var obj = {};
            obj.value = list[k].codeCode;
            obj.label = list[k].codeCname + ' - ' + list[k].codeEname;
            arr2.push(obj);
          }

          this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].city_option2 = arr2;
        }
      } else {
        var list = getUnderCity(code);

        if (type == "1") {
          var arr1 = [];

          for (var k = 0; k < list.length; k++) {
            var obj = {};
            obj.value = list[k].codeCode;
            obj.label = list[k].codeCname + ' - ' + list[k].codeEname;
            arr1.push(obj);
          }

          this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].city_option1 = arr1;
        } else if (type == "2") {
          var arr2 = [];

          for (var k = 0; k < list.length; k++) {
            var obj = {};
            obj.value = list[k].codeCode;
            obj.label = list[k].codeCname + ' - ' + list[k].codeEname;
            arr2.push(obj);
          }

          this.ProposalConveyanceDto.proposalConveyanceListDtoList[scope.$index].city_option2 = arr2;
        }
      } //				var data = {
      //					"codeLever": "2",
      //					"codeCode": [code]
      //
      //				}
      //				queryCountry(data).then(res => {
      //					this.city_option = []
      //					for(var k = 0; k < res[0].children.length; k++) {
      //						var obj = {}
      //						obj.value = res[0].children[k].codeCode
      //						obj.label = res[0].children[k].codeCname
      //						this.city_option.push(obj)
      //					}
      //
      //				})

    },
    //主副险责任 --- 条款名称 、条款类型
    clausequeryAll_fun: function clausequeryAll_fun(insuranceCompanyCode, riskCode) {
      var _this44 = this;

      var data = {
        insuranceCompanyCode: insuranceCompanyCode,
        riskCode: riskCode
      };
      getClauseList(data).then(function (res) {
        //					console.log('--------条款名称--------')
        //					console.log(res)
        _this44.clauseTypeCode_option = [];

        for (var k = 0; k < res.length; k++) {
          var obj = {};
          obj.value = res[k].clauseCode;
          obj.label = res[k].clauseName;

          _this44.clauseTypeCode_option.push(obj);
        }
      });
    },
    //--责任查询
    getKindInfoList_fun: function getKindInfoList_fun(insuranceCompanyCode, clauseCode) {
      var data = {
        insuranceCompanyCode: insuranceCompanyCode,
        clauseCode: clauseCode
      };
      getKindInfoList(data).then(function (res) {//					console.log('--------责任名称--------')
        //					console.log(res)
      });
    },
    //          特约信息查询
    getEngageList_fun: function getEngageList_fun(code1, code2, code3) {
      var _this45 = this;

      var data = {
        insuranceCompanyCode: code1
      }; //         queryEditEngage(datas).then(res => {
      //           debugger
      //             if(res.length>0){
      //                 // this.ty_engageName = res[0].engageName
      //                 // this.ty_engageCode = res[0].engageCode
      //                 this.ty_engageCode_option = res
      //             }
      // })

      queryRemarkEngage(data).then(function (res) {
        if (res.length > 0) {
          // this.ty_engageName = res[0].engageName
          // this.ty_engageCode = res[0].engageCode
          _this45.ty_engageCode_option = res;
        }
      });
    },
    //标的-----发票金额计算
    invoicAmountsum_fun: function invoicAmountsum_fun() {
      debugger;
      var sum = 0;

      for (var k = 0; k < this.ProposalItemDto.proposalItemCargoDtoList.length; k++) {
        if (this.ProposalItemDto.proposalItemCargoDtoList[k].totalAmount != null) {
          if (typeof this.ProposalItemDto.proposalItemCargoDtoList[k].totalAmount == "string") {
            var numtotalAmount = parseFloat(this.ProposalItemDto.proposalItemCargoDtoList[k].totalAmount.replace(/,/g, "")); // console.log(numtotalAmount,'*****------')
          } else {
            var numtotalAmount = this.ProposalItemDto.proposalItemCargoDtoList[k].totalAmount;
          } // sum = accAdd(sum,this.ProposalItemDto.proposalItemCargoDtoList[k].totalAmount)


          sum = accAdd(sum, numtotalAmount); // console.log("******",sum)
        }
      }

      console.log(this.ProposalItemDto.invoicCurrencyCode);

      if (this.ProposalItemDto.invoicCurrencyCode == "JPY") {
        this.ProposalItemDto.invoicAmount = toThousands(Math.round(sum));
      } else {
        // this.ProposalItemDto.invoicAmount = num3_type_fun(sum.toFixed(2))
        sum = Math.round(Math.round(sum * 1000) / 10) / 100;
        this.ProposalItemDto.invoicAmount = num3_type_fun(sum.toFixed(2));
      } //				if(this.ProposalConveyanceDto.clinchWayCode == "3") {
      //
      //					if(this.ProposalConveyanceDto.freightCurrency == this.ProposalItemDto.invoicCurrencyCode) {
      //						if(this.ProposalConveyanceDto.freight == "" || this.ProposalConveyanceDto.freight == null) {
      //							this.ProposalItemDto.invoicAmount = sum.toFixed(2)
      //						} else {
      //							this.ProposalItemDto.invoicAmount = accAdd(sum, this.ProposalConveyanceDto.freight).toFixed(2)
      //						}
      //
      //					} else {
      //						this.ProposalItemDto.invoicAmount = sum.toFixed(2)
      //					}
      //
      //				} else {
      //
      //
      //
      //				}

    },
    //下拉框通过code 获取 name值函数
    list_select: function list_select(val, list) {
      var obj = {};
      obj = list.find(function (item) {
        //这里的userList就是上面遍历的数据源
        return item.value === val; //筛选出匹配数据
      });
      return obj.label;
    },
    // 获取船舶 港口数据
    port_ship: function port_ship(val) {
      var _this46 = this;

      if (this.dataChange == null || '') {
        this.open();
      }

      if (this.ProposalConveyanceDto.startTime == null || '') {
        this.open();
      }

      var a = this.ProposalConveyanceDto.startTime.valueOf();

      if (a == "" || a == null || a == undefined) {
        this.open();
      } else {
        this.loing_box = true;
        var data = {
          // kw: val,
          // searchGb: 1,
          // insuranceCompanyCode:this.insuranceCompanyCode
          vslName: val,
          flag: '1'
        };
        newShipInformation(data).then(function (res) {
          if (res.resultCode == "0000") {
            _this46.shipFlag = true;

            if (res.resultObj.length == 1) {
              _this46.tableData_ship = res.resultObj;
              var index = _this46.ship_index;

              var qystartTime2 = _this46.ProposalConveyanceDto.startTime.substring(0, 4); // 起运日期
              // console.log(index)
              // console.log(res.data)
              // if(res.resultObj[0].classSocietyName !== null && res.resultObj[0].classSociety !== null){
              //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassName = res.resultObj[0].classSocietyName
              //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassCode = res.resultObj[0].classSociety
              // }else {
              //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassName = ''
              //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassCode = ''
              // }


              _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].blName = res.resultObj[0].nameEn;

              if (res.resultObj[0].classSociety !== null && res.resultObj[0].classSocietyNameCn !== null) {
                _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassCode = res.resultObj[0].classSociety;
                _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassName = res.resultObj[0].classSocietyNameCn;
                _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].nShipClassCode = res.resultObj[0].nClassSociety;
              } else {
                _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassCode = '';
                _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipClassName = '';
              }

              if (res.resultObj[0].vesselSubType !== null && res.resultObj[0].vesselSubTypeNameCn !== null) {
                _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypesCode = res.resultObj[0].vesselSubType;
                _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypes = res.resultObj[0].vesselSubTypeNameCn; // 如果code没有映射成功，清空

                var existingOption = _this46.shipTypes_option.find(function (option) {
                  return option.value === res.resultObj[0].vesselSubType;
                });

                if (!existingOption) {
                  _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypesCode = '';
                  _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypes = '';
                }
              } else {
                _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypesCode = '';
                _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].shipTypes = '';
              }

              if (res.resultObj[0].vesselAge !== null) {
                _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = res.resultObj[0].vesselAge;
              } else {
                _this46.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = '';
              } // YCKK-1376 船舶接口调用之后航次字段前端不赋值优化
              // if (res.resultObj[0].voyage !== null ){
              //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].voyageNo = res.resultObj[0].voyage
              // }else {
              //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].voyageNo = ''
              // }
              // if(qystartTime2 == res.resultObj[0].vesselAge){
              //   this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = '1'
              // }else{
              //   if(undefined == res.resultObj[0].vesselAge || null == res.resultObj[0].vesselAge || res.resultObj[0].vesselAge.length === 0){
              //     this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = ''
              //   }else {
              //     this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = '' + (qystartTime2 - res.resultObj[0].vesselAge)
              //   }
              // }
              // this.ProposalConveyanceDto.proposalConveyanceListDtoList[index].vessel = new Date().getFullYear() - res.data[0].buildYear

            } else {
              _this46.tableData_ship = res.resultObj;
              _this46.dialogFormVisible2 = true;
            }
          } else {
            _this46.$alert('<p>' + res.resultMsg + '</p>', '', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              callback: function callback(action) {}
            });
          }

          _this46.loing_box = false;
        }, function (res) {
          _this46.loing_box = false;
        });
      }
    },
    //提示录入起运时间
    open: function open() {
      this.$alert('请先选择起运日期', '提示', {
        confirmButtonText: '确定'
      });
    },
    //取消
    close_but: function close_but() {
      // 返回上一步路由
      this.$router.go(-1); //关闭导航栏

      this.$store.dispatch('delVisitedViews', this.$route);
    },
    nationFlagChange: function nationFlagChange() {
      //this.flag=true
      debugger;

      if (this.ProposalItemDto.nationType == '2') {
        this.showAddressFlag = false;
        this.nationFlag = false;
        this.countryList = [];
        this.countryList = this.countryAllList;
        this.ProposalItemDto.countryEName = '';
        this.ProposalItemDto.countryName = '';
        this.ProposalItemDto.provinceCode = '';
        this.ProposalItemDto.provinceName = '';
        this.ProposalItemDto.cityCode = '';
        this.ProposalItemDto.cityName = '';
        this.ProposalItemDto.areaCode = '';
        this.ProposalItemDto.areaName = '';
        this.ProposalItemDto.roadName = '';
        this.ProposalItemDto.houseNumber = '';
        this.ProposalItemDto.otherInfo = '';
        this.ProposalItemDto.detailAddress = '';
        this.ProposalItemDto.nationalFlag = this.nationType;
        this.ProposalItemDto.nationalFlagName = '国外';
      } else {
        this.nationFlag = true;
        this.showAddressFlag = true;
        this.countryList = this.chinaList;
        this.ProposalItemDto.countryEName = 'CHN';
        this.ProposalItemDto.countryName = '中国';
        this.ProposalItemDto.provinceCode = '';
        this.ProposalItemDto.provinceName = '';
        this.ProposalItemDto.cityCode = '';
        this.ProposalItemDto.cityName = '';
        this.ProposalItemDto.areaCode = '';
        this.ProposalItemDto.areaName = '';
        this.ProposalItemDto.roadName = '';
        this.ProposalItemDto.houseNumber = '';
        this.ProposalItemDto.otherInfo = '';
        this.ProposalItemDto.detailAddress = "";
        this.ProposalItemDto.nationalFlag = this.nationType;
        this.ProposalItemDto.nationalFlagName = '国内';
      }
    },
    countryChange: function countryChange(val) {
      // if(this.ProposalItemDto.nationType=='1'){
      //   this.ProposalItemDto.nationFlag=false
      // }else{
      //   this.ProposalItemDto.nationFlag=true
      // }
      this.ProposalItemDto.nationFlag = true;
      var countryArr = [];
      countryArr = val.split('-');
      this.ProposalItemDto.countryEName = countryArr[0];
      this.ProposalItemDto.countryName = countryArr[1];
    },
    provinceChange: function provinceChange(val) {
      this.flag = true;
      var provinceArr = [];
      provinceArr = val.split('-');
      this.ProposalItemDto.provinceCode = provinceArr[0];
      this.ProposalItemDto.provinceName = provinceArr[1];
      this.ProposalItemDto.cityCode = '';
      this.ProposalItemDto.cityName = '';
      this.ProposalItemDto.areaCode = '';
      this.ProposalItemDto.areaName = '';
      this.ProposalItemDto.roadName = '';
      this.ProposalItemDto.houseNumber = '';
      this.ProposalItemDto.otherInfo = '';
      this.cityList = [];

      for (var i = 0; i < this.allAddressData.length; i++) {
        if (this.allAddressData[i].codeCode == provinceArr[0]) {
          for (var j = 0; j < this.allAddressData[i].children.length; j++) {
            var obj = {};
            obj.codeCode = this.allAddressData[i].children[j].codeCode;
            obj.codeCname = this.allAddressData[i].children[j].codeCname;
            this.cityList.push(obj);
          }
        }
      }

      this.ProposalItemDto.detailAddress = this.ProposalItemDto.provinceName;
    },
    cityChange: function cityChange(val) {
      debugger;
      this.flag = true;
      this.ProposalItemDto.cityCode = val;
      this.areaList = [];
      var cityArr = [];
      cityArr = val.split('-');
      this.ProposalItemDto.cityCode = cityArr[0];
      this.ProposalItemDto.cityName = cityArr[1];
      this.ProposalItemDto.areaCode = '';
      this.ProposalItemDto.areaName = '';
      this.ProposalItemDto.roadName = '';
      this.ProposalItemDto.houseNumber = '';
      this.ProposalItemDto.otherInfo = '';

      for (var i = 0; i < this.allAddressData.length; i++) {
        if (this.allAddressData[i].codeCode == this.ProposalItemDto.provinceCode) {
          for (var j = 0; j < this.allAddressData[i].children.length; j++) {
            if (this.allAddressData[i].children[j].codeCode == cityArr[0]) {
              for (var k = 0; k < this.allAddressData[i].children[j].children.length; k++) {
                var obj = {};
                obj.codeCode = this.allAddressData[i].children[j].children[k].codeCode;
                obj.codeCname = this.allAddressData[i].children[j].children[k].codeCname;
                this.areaList.push(obj);
              }
            }
          }
        }
      }

      if (this.ProposalItemDto.provinceName == this.ProposalItemDto.cityName || this.ProposalItemDto.cityName === '市辖区') {
        this.ProposalItemDto.detailAddress = this.ProposalItemDto.provinceName;
      } else {
        this.ProposalItemDto.detailAddress = this.ProposalItemDto.provinceName + this.ProposalItemDto.cityName;
      }
    },
    areaChange: function areaChange(val) {
      this.ProposalItemDto.areaCode = val;
      var areaArr = [];
      areaArr = val.split('-');
      this.ProposalItemDto.areaCode = areaArr[0];
      this.ProposalItemDto.areaName = areaArr[1];
      this.ProposalItemDto.roadName = '';
      this.ProposalItemDto.houseNumber = '';
      this.ProposalItemDto.otherInfo = '';

      if (this.ProposalItemDto.provinceName == this.ProposalItemDto.cityName || this.ProposalItemDto.cityName === '市辖区') {
        this.ProposalItemDto.detailAddress = this.ProposalItemDto.provinceName + this.ProposalItemDto.areaName;
      } else {
        this.ProposalItemDto.detailAddress = this.ProposalItemDto.provinceName + this.ProposalItemDto.cityName + this.ProposalItemDto.areaName;
      }
    },
    loadChange: function loadChange() {
      if (this.ProposalItemDto.houseNumber == null) {
        this.ProposalItemDto.houseNumber = '';
      }

      if (this.ProposalItemDto.otherInfo == null) {
        this.ProposalItemDto.otherInfo = '';
      }

      this.judgeProvinceCity();
    },
    judgeProvinceCity: function judgeProvinceCity() {
      if (this.ProposalItemDto.provinceName == this.ProposalItemDto.cityName || this.ProposalItemDto.cityName === '市辖区') {
        this.ProposalItemDto.detailAddress = this.ProposalItemDto.provinceName + this.ProposalItemDto.areaName + this.ProposalItemDto.roadName + this.ProposalItemDto.houseNumber + this.ProposalItemDto.otherInfo;
      } else {
        this.ProposalItemDto.detailAddress = this.ProposalItemDto.provinceName + this.ProposalItemDto.cityName + this.ProposalItemDto.areaName + this.ProposalItemDto.roadName + this.ProposalItemDto.houseNumber + this.ProposalItemDto.otherInfo;
      }
    },
    houseNumberChange: function houseNumberChange() {
      if (this.ProposalItemDto.otherInfo == null) {
        this.ProposalItemDto.otherInfo = '';
      }

      this.judgeProvinceCity();
    },
    otherInfoChange: function otherInfoChange() {
      this.judgeProvinceCity();
    },
    detailAddressCheck: function detailAddressCheck(val) {
      console.log(1234);
      var temp = 0;
      var reg = /[\s\S]/g;
      var resultn = val.match(reg);

      for (var i = 0; i < resultn.length; i++) {
        if (/[\u4e00-\u9fa5]/.test(resultn[i])) {
          temp += 3;
        } else {
          temp += 3;
        }

        if (temp > 250) {
          this.$message({
            message: '详细地址最多支持输入250个字符(约82个汉字)',
            type: 'warning'
          });
          this.ProposalItemDto.detailAddress = val.substring(0, i);
          break;
        }
      }
    },
    getProvinceCityData1: function getProvinceCityData1() {
      var _this47 = this;

      //获取省市区数据
      getProvinceCityArea().then(function (res) {
        _this47.allAddressData = res;

        for (var i = 0; i < res.length; i++) {
          if (res[i].codeType == 'insuredProvince') {
            var obj = {};
            obj.codeCode = res[i].codeCode;
            obj.codeCname = res[i].codeCname;

            _this47.provinceList.push(obj);
          }
        }
      });
    },
    getProvinceCityData: function getProvinceCityData() {
      var _this48 = this;

      return new Promise(function (resolve, reject) {
        getProvinceCityArea().then(function (res) {
          _this48.allAddressData = res;
          _this48.provinceList = res.filter(function (item) {
            return item.codeType === 'insuredProvince';
          }).map(function (item) {
            return {
              codeCode: item.codeCode,
              codeCname: item.codeCname
            };
          });
          resolve(_this48.provinceList); // 让调用者知道数据已加载
        }).catch(function (error) {
          reject(error); // 处理可能的错误
        });
      });
    },
    storagePeriodChange: function storagePeriodChange(value) {
      console.log(value);

      if (value != "" && value != undefined) {
        this.ProposalItemDto.nationType = '1';
        this.ProposalItemDto.countryEName = 'CHN';
        this.ProposalItemDto.countryName = '中国';
        this.addressFlag = true;
        this.showAddressFlag = true;
        this.nationFlag = true;
        this.text5.storagePeriod = '';
      } else {
        this.addressFlag = false;
        this.ProposalItemDto.provinceCode = '';
        this.ProposalItemDto.provinceName = '';
        this.ProposalItemDto.cityCode = '';
        this.ProposalItemDto.cityName = '';
        this.ProposalItemDto.areaCode = '';
        this.ProposalItemDto.areaName = '';
        this.ProposalItemDto.roadName = '';
        this.ProposalItemDto.houseNumber = '';
        this.ProposalItemDto.otherInfo = '';
        this.ProposalItemDto.detailAddress = '';
        this.text5.storagePeriod = '请选择列明地址仓储/展览/加工/安装起期与列明地址仓储/展览/加工/安装止期,来计算列明地址仓储/展览/加工/安装起期(天)';
      }
    }
  }
};